export const precalculatedTuningModCombinations: {
  [key: number]: [number, number, number, number, number, number][];
} = {
  1: [
    [0, 0, 0, 1, 1, 1],
    [0, 0, 0, 2, 2, 2],
    [1, 0, 0, 0, 0, 3],
    [0, 0, 0, 3, 3, 3],
    [0, 0, 0, 4, 4, 4],
    [0, 1, 0, 0, 0, 5],
    [0, 0, 0, 5, 1, 5],
    [0, 0, 0, 6, 2, 6],
    [0, 0, 0, 7, 3, 7],
    [0, 0, 0, 8, 4, 8],
    [0, 0, 0, 9, 5, 9],
    [0, 0, 1, 0, 0, 10],
    [0, 0, 0, 10, 2, 10],
    [0, 0, 0, 11, 3, 11],
    [0, 0, 0, 12, 4, 12],
    [0, 0, 0, 13, 5, 13],
    [0, 0, 0, 15, 3, 15],
    [0, 0, 0, 16, 4, 16],
    [0, 0, 0, 17, 5, 17],
    [0, 0, 0, 20, 4, 20],
    [0, 0, 0, 21, 5, 21],
    [0, 0, 0, 25, 5, 25],
  ],
  2: [
    [0, 0, 0, 2, 2, 2],
    [1, 0, 0, 0, 0, 3],
    [1, 0, 0, 1, 1, 3],
    [0, 0, 0, 3, 3, 3],
    [0, 0, 0, 4, 4, 4],
    [0, 1, 0, 0, 0, 5],
    [0, 0, 0, 5, 1, 5],
    [0, 1, 0, 1, 1, 6],
    [0, 0, 0, 6, 2, 6],
    [0, 0, 0, 7, 3, 7],
    [0, 0, 0, 8, 4, 8],
    [0, 0, 0, 9, 5, 9],
    [0, 0, 1, 0, 0, 10],
    [0, 0, 0, 10, 2, 10],
    [0, 0, 1, 1, 1, 11],
    [0, 0, 0, 11, 3, 11],
    [0, 0, 0, 12, 4, 12],
    [0, 0, 0, 13, 5, 13],
    [0, 0, 0, 15, 3, 15],
    [0, 0, 0, 16, 4, 16],
    [0, 0, 0, 17, 5, 17],
    [0, 0, 0, 20, 4, 20],
    [0, 0, 0, 21, 5, 21],
    [0, 0, 0, 25, 5, 25],
  ],
  3: [
    [1, 0, 0, 0, 0, 3],
    [1, 0, 0, 1, 1, 3],
    [1, 0, 0, 2, 2, 3],
    [0, 0, 0, 3, 3, 3],
    [0, 0, 0, 4, 4, 4],
    [0, 1, 0, 0, 0, 5],
    [0, 0, 0, 5, 1, 5],
    [0, 1, 0, 1, 1, 6],
    [0, 0, 0, 6, 2, 6],
    [0, 1, 0, 2, 2, 7],
    [0, 0, 0, 7, 3, 7],
    [0, 0, 0, 8, 4, 8],
    [0, 0, 0, 9, 5, 9],
    [0, 0, 1, 0, 0, 10],
    [0, 0, 0, 10, 2, 10],
    [0, 0, 1, 1, 1, 11],
    [0, 0, 0, 11, 3, 11],
    [0, 0, 1, 2, 2, 12],
    [0, 0, 0, 12, 4, 12],
    [0, 0, 0, 13, 5, 13],
    [0, 0, 0, 15, 3, 15],
    [0, 0, 0, 16, 4, 16],
    [0, 0, 0, 17, 5, 17],
    [0, 0, 0, 20, 4, 20],
    [0, 0, 0, 21, 5, 21],
    [0, 0, 0, 25, 5, 25],
  ],
  4: [
    [1, 0, 0, 1, 1, 3],
    [1, 0, 0, 2, 2, 3],
    [1, 0, 0, 3, 3, 3],
    [0, 0, 0, 4, 4, 4],
    [0, 1, 0, 0, 0, 5],
    [0, 0, 0, 5, 1, 5],
    [2, 0, 0, 0, 0, 6],
    [0, 1, 0, 1, 1, 6],
    [0, 0, 0, 6, 2, 6],
    [0, 1, 0, 2, 2, 7],
    [0, 0, 0, 7, 3, 7],
    [0, 1, 0, 3, 3, 8],
    [0, 0, 0, 8, 4, 8],
    [0, 0, 0, 9, 5, 9],
    [0, 0, 1, 0, 0, 10],
    [0, 0, 0, 10, 2, 10],
    [0, 0, 1, 1, 1, 11],
    [0, 0, 0, 11, 3, 11],
    [0, 0, 1, 2, 2, 12],
    [0, 0, 0, 12, 4, 12],
    [0, 0, 1, 3, 3, 13],
    [0, 0, 0, 13, 5, 13],
    [0, 0, 0, 15, 3, 15],
    [0, 0, 0, 16, 4, 16],
    [0, 0, 0, 17, 5, 17],
    [0, 0, 0, 20, 4, 20],
    [0, 0, 0, 21, 5, 21],
    [0, 0, 0, 25, 5, 25],
  ],
  5: [
    [1, 0, 0, 2, 2, 3],
    [1, 0, 0, 3, 3, 3],
    [1, 0, 0, 4, 4, 3],
    [0, 1, 0, 0, 0, 5],
    [0, 0, 0, 5, 1, 5],
    [2, 0, 0, 0, 0, 6],
    [2, 0, 0, 1, 1, 6],
    [0, 1, 0, 1, 1, 6],
    [0, 0, 0, 6, 2, 6],
    [0, 1, 0, 2, 2, 7],
    [0, 0, 0, 7, 3, 7],
    [0, 1, 0, 3, 3, 8],
    [0, 0, 0, 8, 4, 8],
    [0, 1, 0, 4, 4, 9],
    [0, 0, 0, 9, 5, 9],
    [0, 0, 1, 0, 0, 10],
    [0, 0, 0, 10, 2, 10],
    [0, 0, 1, 1, 1, 11],
    [0, 0, 0, 11, 3, 11],
    [0, 0, 1, 2, 2, 12],
    [0, 0, 0, 12, 4, 12],
    [0, 0, 1, 3, 3, 13],
    [0, 0, 0, 13, 5, 13],
    [0, 0, 1, 4, 4, 14],
    [0, 0, 0, 15, 3, 15],
    [0, 0, 0, 16, 4, 16],
    [0, 0, 0, 17, 5, 17],
    [0, 0, 0, 20, 4, 20],
    [0, 0, 0, 21, 5, 21],
    [0, 0, 0, 25, 5, 25],
  ],
  6: [
    [1, 0, 0, 5, 1, 3],
    [1, 0, 0, 3, 3, 3],
    [1, 0, 0, 4, 4, 3],
    [2, 0, 0, 0, 0, 6],
    [2, 0, 0, 1, 1, 6],
    [0, 1, 0, 1, 1, 6],
    [2, 0, 0, 2, 2, 6],
    [0, 0, 0, 6, 2, 6],
    [0, 1, 0, 2, 2, 7],
    [0, 0, 0, 7, 3, 7],
    [1, 1, 0, 0, 0, 8],
    [0, 1, 0, 3, 3, 8],
    [0, 0, 0, 8, 4, 8],
    [0, 1, 0, 4, 4, 9],
    [0, 0, 0, 9, 5, 9],
    [0, 2, 0, 0, 0, 10],
    [0, 0, 1, 0, 0, 10],
    [0, 1, 0, 5, 1, 10],
    [0, 0, 0, 10, 2, 10],
    [0, 0, 1, 1, 1, 11],
    [0, 0, 0, 11, 3, 11],
    [0, 0, 1, 2, 2, 12],
    [0, 0, 0, 12, 4, 12],
    [0, 0, 1, 3, 3, 13],
    [0, 0, 0, 13, 5, 13],
    [0, 0, 1, 4, 4, 14],
    [0, 0, 1, 5, 1, 15],
    [0, 0, 0, 15, 3, 15],
    [0, 0, 0, 16, 4, 16],
    [0, 0, 0, 17, 5, 17],
    [0, 0, 0, 20, 4, 20],
    [0, 0, 0, 21, 5, 21],
    [0, 0, 0, 25, 5, 25],
  ],
  7: [
    [1, 0, 0, 5, 1, 3],
    [1, 0, 0, 6, 2, 3],
    [1, 0, 0, 4, 4, 3],
    [2, 0, 0, 1, 1, 6],
    [2, 0, 0, 2, 2, 6],
    [2, 0, 0, 3, 3, 6],
    [0, 1, 0, 2, 2, 7],
    [0, 0, 0, 7, 3, 7],
    [1, 1, 0, 0, 0, 8],
    [0, 1, 0, 3, 3, 8],
    [0, 0, 0, 8, 4, 8],
    [3, 0, 0, 0, 0, 9],
    [1, 1, 0, 1, 1, 9],
    [0, 1, 0, 4, 4, 9],
    [0, 0, 0, 9, 5, 9],
    [0, 2, 0, 0, 0, 10],
    [0, 0, 1, 0, 0, 10],
    [0, 1, 0, 5, 1, 10],
    [0, 0, 0, 10, 2, 10],
    [0, 2, 0, 1, 1, 11],
    [0, 0, 1, 1, 1, 11],
    [0, 1, 0, 6, 2, 11],
    [0, 0, 0, 11, 3, 11],
    [0, 0, 1, 2, 2, 12],
    [0, 0, 0, 12, 4, 12],
    [0, 0, 1, 3, 3, 13],
    [0, 0, 0, 13, 5, 13],
    [0, 0, 1, 4, 4, 14],
    [0, 0, 1, 5, 1, 15],
    [0, 0, 0, 15, 3, 15],
    [0, 0, 1, 6, 2, 16],
    [0, 0, 0, 16, 4, 16],
    [0, 0, 0, 17, 5, 17],
    [0, 0, 0, 20, 4, 20],
    [0, 0, 0, 21, 5, 21],
    [0, 0, 0, 25, 5, 25],
  ],
  8: [
    [1, 0, 0, 5, 1, 3],
    [1, 0, 0, 6, 2, 3],
    [1, 0, 0, 7, 3, 3],
    [2, 0, 0, 2, 2, 6],
    [2, 0, 0, 3, 3, 6],
    [1, 1, 0, 0, 0, 8],
    [0, 1, 0, 3, 3, 8],
    [0, 0, 0, 8, 4, 8],
    [3, 0, 0, 0, 0, 9],
    [3, 0, 0, 1, 1, 9],
    [1, 1, 0, 1, 1, 9],
    [0, 1, 0, 4, 4, 9],
    [0, 0, 0, 9, 5, 9],
    [0, 2, 0, 0, 0, 10],
    [0, 0, 1, 0, 0, 10],
    [0, 1, 0, 5, 1, 10],
    [1, 1, 0, 2, 2, 10],
    [0, 0, 0, 10, 2, 10],
    [0, 2, 0, 1, 1, 11],
    [0, 0, 1, 1, 1, 11],
    [0, 1, 0, 6, 2, 11],
    [0, 0, 0, 11, 3, 11],
    [0, 2, 0, 2, 2, 12],
    [0, 0, 1, 2, 2, 12],
    [0, 1, 0, 7, 3, 12],
    [0, 0, 0, 12, 4, 12],
    [0, 0, 1, 3, 3, 13],
    [0, 0, 0, 13, 5, 13],
    [0, 0, 1, 4, 4, 14],
    [0, 0, 1, 5, 1, 15],
    [0, 0, 0, 15, 3, 15],
    [0, 0, 1, 6, 2, 16],
    [0, 0, 0, 16, 4, 16],
    [0, 0, 1, 7, 3, 17],
    [0, 0, 0, 17, 5, 17],
    [0, 0, 0, 20, 4, 20],
    [0, 0, 0, 21, 5, 21],
    [0, 0, 0, 25, 5, 25],
  ],
  9: [
    [1, 0, 0, 6, 2, 3],
    [1, 0, 0, 7, 3, 3],
    [1, 0, 0, 8, 4, 3],
    [2, 0, 0, 5, 1, 6],
    [2, 0, 0, 3, 3, 6],
    [3, 0, 0, 0, 0, 9],
    [3, 0, 0, 1, 1, 9],
    [1, 1, 0, 1, 1, 9],
    [3, 0, 0, 2, 2, 9],
    [0, 1, 0, 4, 4, 9],
    [0, 0, 0, 9, 5, 9],
    [0, 2, 0, 0, 0, 10],
    [0, 0, 1, 0, 0, 10],
    [0, 1, 0, 5, 1, 10],
    [1, 1, 0, 2, 2, 10],
    [0, 0, 0, 10, 2, 10],
    [2, 1, 0, 0, 0, 11],
    [0, 2, 0, 1, 1, 11],
    [0, 0, 1, 1, 1, 11],
    [0, 1, 0, 6, 2, 11],
    [1, 1, 0, 3, 3, 11],
    [0, 0, 0, 11, 3, 11],
    [0, 2, 0, 2, 2, 12],
    [0, 0, 1, 2, 2, 12],
    [0, 1, 0, 7, 3, 12],
    [0, 0, 0, 12, 4, 12],
    [0, 2, 0, 3, 3, 13],
    [0, 0, 1, 3, 3, 13],
    [0, 1, 0, 8, 4, 13],
    [0, 0, 0, 13, 5, 13],
    [0, 0, 1, 4, 4, 14],
    [0, 0, 1, 5, 1, 15],
    [0, 0, 0, 15, 3, 15],
    [0, 0, 1, 6, 2, 16],
    [0, 0, 0, 16, 4, 16],
    [0, 0, 1, 7, 3, 17],
    [0, 0, 0, 17, 5, 17],
    [0, 0, 1, 8, 4, 18],
    [0, 0, 0, 20, 4, 20],
    [0, 0, 0, 21, 5, 21],
    [0, 0, 0, 25, 5, 25],
  ],
  10: [
    [1, 0, 0, 7, 3, 3],
    [1, 0, 0, 8, 4, 3],
    [2, 0, 0, 5, 1, 6],
    [2, 0, 0, 6, 2, 6],
    [3, 0, 0, 1, 1, 9],
    [3, 0, 0, 2, 2, 9],
    [0, 2, 0, 0, 0, 10],
    [0, 0, 1, 0, 0, 10],
    [0, 1, 0, 5, 1, 10],
    [1, 1, 0, 2, 2, 10],
    [0, 0, 0, 10, 2, 10],
    [2, 1, 0, 0, 0, 11],
    [0, 2, 0, 1, 1, 11],
    [0, 0, 1, 1, 1, 11],
    [0, 1, 0, 6, 2, 11],
    [1, 1, 0, 3, 3, 11],
    [0, 0, 0, 11, 3, 11],
    [4, 0, 0, 0, 0, 12],
    [2, 1, 0, 1, 1, 12],
    [0, 2, 0, 2, 2, 12],
    [0, 0, 1, 2, 2, 12],
    [0, 1, 0, 7, 3, 12],
    [1, 1, 0, 4, 4, 12],
    [0, 0, 0, 12, 4, 12],
    [0, 2, 0, 3, 3, 13],
    [0, 0, 1, 3, 3, 13],
    [0, 1, 0, 8, 4, 13],
    [0, 0, 0, 13, 5, 13],
    [0, 2, 0, 4, 4, 14],
    [0, 0, 1, 4, 4, 14],
    [0, 1, 0, 9, 5, 14],
    [0, 0, 1, 5, 1, 15],
    [0, 0, 0, 15, 3, 15],
    [0, 0, 1, 6, 2, 16],
    [0, 0, 0, 16, 4, 16],
    [0, 0, 1, 7, 3, 17],
    [0, 0, 0, 17, 5, 17],
    [0, 0, 1, 8, 4, 18],
    [0, 0, 1, 9, 5, 19],
    [0, 0, 0, 20, 4, 20],
    [0, 0, 0, 21, 5, 21],
    [0, 0, 0, 25, 5, 25],
  ],
  11: [
    [1, 0, 0, 10, 2, 3],
    [1, 0, 0, 8, 4, 3],
    [2, 0, 0, 5, 1, 6],
    [2, 0, 0, 6, 2, 6],
    [2, 0, 0, 7, 3, 6],
    [3, 0, 0, 2, 2, 9],
    [2, 1, 0, 0, 0, 11],
    [0, 2, 0, 1, 1, 11],
    [0, 0, 1, 1, 1, 11],
    [0, 1, 0, 6, 2, 11],
    [1, 1, 0, 3, 3, 11],
    [0, 0, 0, 11, 3, 11],
    [4, 0, 0, 0, 0, 12],
    [4, 0, 0, 1, 1, 12],
    [2, 1, 0, 1, 1, 12],
    [0, 2, 0, 2, 2, 12],
    [0, 0, 1, 2, 2, 12],
    [0, 1, 0, 7, 3, 12],
    [1, 1, 0, 4, 4, 12],
    [0, 0, 0, 12, 4, 12],
    [1, 2, 0, 0, 0, 13],
    [1, 0, 1, 0, 0, 13],
    [1, 1, 0, 5, 1, 13],
    [2, 1, 0, 2, 2, 13],
    [0, 2, 0, 3, 3, 13],
    [0, 0, 1, 3, 3, 13],
    [0, 1, 0, 8, 4, 13],
    [0, 0, 0, 13, 5, 13],
    [0, 2, 0, 4, 4, 14],
    [0, 0, 1, 4, 4, 14],
    [0, 1, 0, 9, 5, 14],
    [0, 3, 0, 0, 0, 15],
    [0, 1, 1, 0, 0, 15],
    [0, 2, 0, 5, 1, 15],
    [0, 0, 1, 5, 1, 15],
    [0, 1, 0, 10, 2, 15],
    [0, 0, 0, 15, 3, 15],
    [0, 0, 1, 6, 2, 16],
    [0, 0, 0, 16, 4, 16],
    [0, 0, 1, 7, 3, 17],
    [0, 0, 0, 17, 5, 17],
    [0, 0, 1, 8, 4, 18],
    [0, 0, 1, 9, 5, 19],
    [0, 0, 2, 0, 0, 20],
    [0, 0, 1, 10, 2, 20],
    [0, 0, 0, 20, 4, 20],
    [0, 0, 0, 21, 5, 21],
    [0, 0, 0, 25, 5, 25],
  ],
  12: [
    [1, 0, 0, 10, 2, 3],
    [1, 0, 0, 11, 3, 3],
    [2, 0, 0, 6, 2, 6],
    [2, 0, 0, 7, 3, 6],
    [3, 0, 0, 5, 1, 9],
    [4, 0, 0, 0, 0, 12],
    [4, 0, 0, 1, 1, 12],
    [2, 1, 0, 1, 1, 12],
    [0, 2, 0, 2, 2, 12],
    [0, 0, 1, 2, 2, 12],
    [0, 1, 0, 7, 3, 12],
    [1, 1, 0, 4, 4, 12],
    [0, 0, 0, 12, 4, 12],
    [1, 2, 0, 0, 0, 13],
    [1, 0, 1, 0, 0, 13],
    [1, 1, 0, 5, 1, 13],
    [2, 1, 0, 2, 2, 13],
    [0, 2, 0, 3, 3, 13],
    [0, 0, 1, 3, 3, 13],
    [0, 1, 0, 8, 4, 13],
    [0, 0, 0, 13, 5, 13],
    [3, 1, 0, 0, 0, 14],
    [1, 2, 0, 1, 1, 14],
    [1, 0, 1, 1, 1, 14],
    [1, 1, 0, 6, 2, 14],
    [2, 1, 0, 3, 3, 14],
    [0, 2, 0, 4, 4, 14],
    [0, 0, 1, 4, 4, 14],
    [0, 1, 0, 9, 5, 14],
    [0, 3, 0, 0, 0, 15],
    [0, 1, 1, 0, 0, 15],
    [0, 2, 0, 5, 1, 15],
    [0, 0, 1, 5, 1, 15],
    [0, 1, 0, 10, 2, 15],
    [0, 0, 0, 15, 3, 15],
    [0, 3, 0, 1, 1, 16],
    [0, 1, 1, 1, 1, 16],
    [0, 2, 0, 6, 2, 16],
    [0, 0, 1, 6, 2, 16],
    [0, 1, 0, 11, 3, 16],
    [0, 0, 0, 16, 4, 16],
    [0, 0, 1, 7, 3, 17],
    [0, 0, 0, 17, 5, 17],
    [0, 0, 1, 8, 4, 18],
    [0, 0, 1, 9, 5, 19],
    [0, 0, 2, 0, 0, 20],
    [0, 0, 1, 10, 2, 20],
    [0, 0, 0, 20, 4, 20],
    [0, 0, 2, 1, 1, 21],
    [0, 0, 1, 11, 3, 21],
    [0, 0, 0, 21, 5, 21],
    [0, 0, 0, 25, 5, 25],
  ],
  13: [
    [1, 0, 0, 10, 2, 3],
    [1, 0, 0, 11, 3, 3],
    [1, 0, 0, 12, 4, 3],
    [2, 0, 0, 7, 3, 6],
    [3, 0, 0, 5, 1, 9],
    [3, 0, 0, 6, 2, 9],
    [4, 0, 0, 1, 1, 12],
    [1, 2, 0, 0, 0, 13],
    [1, 0, 1, 0, 0, 13],
    [1, 1, 0, 5, 1, 13],
    [2, 1, 0, 2, 2, 13],
    [0, 2, 0, 3, 3, 13],
    [0, 0, 1, 3, 3, 13],
    [0, 1, 0, 8, 4, 13],
    [0, 0, 0, 13, 5, 13],
    [3, 1, 0, 0, 0, 14],
    [1, 2, 0, 1, 1, 14],
    [1, 0, 1, 1, 1, 14],
    [1, 1, 0, 6, 2, 14],
    [2, 1, 0, 3, 3, 14],
    [0, 2, 0, 4, 4, 14],
    [0, 0, 1, 4, 4, 14],
    [0, 1, 0, 9, 5, 14],
    [5, 0, 0, 0, 0, 15],
    [0, 3, 0, 0, 0, 15],
    [0, 1, 1, 0, 0, 15],
    [3, 1, 0, 1, 1, 15],
    [0, 2, 0, 5, 1, 15],
    [0, 0, 1, 5, 1, 15],
    [1, 2, 0, 2, 2, 15],
    [1, 0, 1, 2, 2, 15],
    [0, 1, 0, 10, 2, 15],
    [1, 1, 0, 7, 3, 15],
    [0, 0, 0, 15, 3, 15],
    [0, 3, 0, 1, 1, 16],
    [0, 1, 1, 1, 1, 16],
    [0, 2, 0, 6, 2, 16],
    [0, 0, 1, 6, 2, 16],
    [0, 1, 0, 11, 3, 16],
    [0, 0, 0, 16, 4, 16],
    [0, 3, 0, 2, 2, 17],
    [0, 1, 1, 2, 2, 17],
    [0, 2, 0, 7, 3, 17],
    [0, 0, 1, 7, 3, 17],
    [0, 1, 0, 12, 4, 17],
    [0, 0, 0, 17, 5, 17],
    [0, 0, 1, 8, 4, 18],
    [0, 0, 1, 9, 5, 19],
    [0, 0, 2, 0, 0, 20],
    [0, 0, 1, 10, 2, 20],
    [0, 0, 0, 20, 4, 20],
    [0, 0, 2, 1, 1, 21],
    [0, 0, 1, 11, 3, 21],
    [0, 0, 0, 21, 5, 21],
    [0, 0, 2, 2, 2, 22],
    [0, 0, 1, 12, 4, 22],
    [0, 0, 0, 25, 5, 25],
  ],
  14: [
    [1, 0, 0, 11, 3, 3],
    [1, 0, 0, 12, 4, 3],
    [2, 0, 0, 10, 2, 6],
    [3, 0, 0, 5, 1, 9],
    [3, 0, 0, 6, 2, 9],
    [3, 1, 0, 0, 0, 14],
    [1, 2, 0, 1, 1, 14],
    [1, 0, 1, 1, 1, 14],
    [1, 1, 0, 6, 2, 14],
    [2, 1, 0, 3, 3, 14],
    [0, 2, 0, 4, 4, 14],
    [0, 0, 1, 4, 4, 14],
    [0, 1, 0, 9, 5, 14],
    [5, 0, 0, 0, 0, 15],
    [0, 3, 0, 0, 0, 15],
    [0, 1, 1, 0, 0, 15],
    [3, 1, 0, 1, 1, 15],
    [0, 2, 0, 5, 1, 15],
    [0, 0, 1, 5, 1, 15],
    [1, 2, 0, 2, 2, 15],
    [1, 0, 1, 2, 2, 15],
    [0, 1, 0, 10, 2, 15],
    [1, 1, 0, 7, 3, 15],
    [0, 0, 0, 15, 3, 15],
    [2, 2, 0, 0, 0, 16],
    [2, 0, 1, 0, 0, 16],
    [0, 3, 0, 1, 1, 16],
    [0, 1, 1, 1, 1, 16],
    [2, 1, 0, 5, 1, 16],
    [3, 1, 0, 2, 2, 16],
    [0, 2, 0, 6, 2, 16],
    [0, 0, 1, 6, 2, 16],
    [1, 2, 0, 3, 3, 16],
    [1, 0, 1, 3, 3, 16],
    [0, 1, 0, 11, 3, 16],
    [1, 1, 0, 8, 4, 16],
    [0, 0, 0, 16, 4, 16],
    [0, 3, 0, 2, 2, 17],
    [0, 1, 1, 2, 2, 17],
    [0, 2, 0, 7, 3, 17],
    [0, 0, 1, 7, 3, 17],
    [0, 1, 0, 12, 4, 17],
    [0, 0, 0, 17, 5, 17],
    [0, 3, 0, 3, 3, 18],
    [0, 1, 1, 3, 3, 18],
    [0, 2, 0, 8, 4, 18],
    [0, 0, 1, 8, 4, 18],
    [0, 1, 0, 13, 5, 18],
    [0, 0, 1, 9, 5, 19],
    [0, 0, 2, 0, 0, 20],
    [0, 0, 1, 10, 2, 20],
    [0, 0, 0, 20, 4, 20],
    [0, 0, 2, 1, 1, 21],
    [0, 0, 1, 11, 3, 21],
    [0, 0, 0, 21, 5, 21],
    [0, 0, 2, 2, 2, 22],
    [0, 0, 1, 12, 4, 22],
    [0, 0, 2, 3, 3, 23],
    [0, 0, 1, 13, 5, 23],
    [0, 0, 0, 25, 5, 25],
  ],
  15: [
    [1, 0, 0, 12, 4, 3],
    [2, 0, 0, 10, 2, 6],
    [2, 0, 0, 11, 3, 6],
    [3, 0, 0, 6, 2, 9],
    [4, 0, 0, 5, 1, 12],
    [5, 0, 0, 0, 0, 15],
    [0, 3, 0, 0, 0, 15],
    [0, 1, 1, 0, 0, 15],
    [3, 1, 0, 1, 1, 15],
    [0, 2, 0, 5, 1, 15],
    [0, 0, 1, 5, 1, 15],
    [1, 2, 0, 2, 2, 15],
    [1, 0, 1, 2, 2, 15],
    [0, 1, 0, 10, 2, 15],
    [1, 1, 0, 7, 3, 15],
    [0, 0, 0, 15, 3, 15],
    [2, 2, 0, 0, 0, 16],
    [2, 0, 1, 0, 0, 16],
    [0, 3, 0, 1, 1, 16],
    [0, 1, 1, 1, 1, 16],
    [2, 1, 0, 5, 1, 16],
    [3, 1, 0, 2, 2, 16],
    [0, 2, 0, 6, 2, 16],
    [0, 0, 1, 6, 2, 16],
    [1, 2, 0, 3, 3, 16],
    [1, 0, 1, 3, 3, 16],
    [0, 1, 0, 11, 3, 16],
    [1, 1, 0, 8, 4, 16],
    [0, 0, 0, 16, 4, 16],
    [4, 1, 0, 0, 0, 17],
    [2, 2, 0, 1, 1, 17],
    [2, 0, 1, 1, 1, 17],
    [0, 3, 0, 2, 2, 17],
    [0, 1, 1, 2, 2, 17],
    [2, 1, 0, 6, 2, 17],
    [0, 2, 0, 7, 3, 17],
    [0, 0, 1, 7, 3, 17],
    [1, 2, 0, 4, 4, 17],
    [1, 0, 1, 4, 4, 17],
    [0, 1, 0, 12, 4, 17],
    [0, 0, 0, 17, 5, 17],
    [0, 3, 0, 3, 3, 18],
    [0, 1, 1, 3, 3, 18],
    [0, 2, 0, 8, 4, 18],
    [0, 0, 1, 8, 4, 18],
    [0, 1, 0, 13, 5, 18],
    [0, 3, 0, 4, 4, 19],
    [0, 1, 1, 4, 4, 19],
    [0, 2, 0, 9, 5, 19],
    [0, 0, 1, 9, 5, 19],
    [0, 0, 2, 0, 0, 20],
    [0, 0, 1, 10, 2, 20],
    [0, 0, 0, 20, 4, 20],
    [0, 0, 2, 1, 1, 21],
    [0, 0, 1, 11, 3, 21],
    [0, 0, 0, 21, 5, 21],
    [0, 0, 2, 2, 2, 22],
    [0, 0, 1, 12, 4, 22],
    [0, 0, 2, 3, 3, 23],
    [0, 0, 1, 13, 5, 23],
    [0, 0, 2, 4, 4, 24],
    [0, 0, 0, 25, 5, 25],
  ],
  16: [
    [1, 0, 0, 15, 3, 3],
    [2, 0, 0, 10, 2, 6],
    [2, 0, 0, 11, 3, 6],
    [4, 0, 0, 5, 1, 12],
    [2, 2, 0, 0, 0, 16],
    [2, 0, 1, 0, 0, 16],
    [0, 3, 0, 1, 1, 16],
    [0, 1, 1, 1, 1, 16],
    [2, 1, 0, 5, 1, 16],
    [3, 1, 0, 2, 2, 16],
    [0, 2, 0, 6, 2, 16],
    [0, 0, 1, 6, 2, 16],
    [1, 2, 0, 3, 3, 16],
    [1, 0, 1, 3, 3, 16],
    [0, 1, 0, 11, 3, 16],
    [1, 1, 0, 8, 4, 16],
    [0, 0, 0, 16, 4, 16],
    [4, 1, 0, 0, 0, 17],
    [2, 2, 0, 1, 1, 17],
    [2, 0, 1, 1, 1, 17],
    [0, 3, 0, 2, 2, 17],
    [0, 1, 1, 2, 2, 17],
    [2, 1, 0, 6, 2, 17],
    [0, 2, 0, 7, 3, 17],
    [0, 0, 1, 7, 3, 17],
    [1, 2, 0, 4, 4, 17],
    [1, 0, 1, 4, 4, 17],
    [0, 1, 0, 12, 4, 17],
    [0, 0, 0, 17, 5, 17],
    [1, 3, 0, 0, 0, 18],
    [1, 1, 1, 0, 0, 18],
    [4, 1, 0, 1, 1, 18],
    [1, 2, 0, 5, 1, 18],
    [1, 0, 1, 5, 1, 18],
    [2, 2, 0, 2, 2, 18],
    [2, 0, 1, 2, 2, 18],
    [1, 1, 0, 10, 2, 18],
    [0, 3, 0, 3, 3, 18],
    [0, 1, 1, 3, 3, 18],
    [2, 1, 0, 7, 3, 18],
    [0, 2, 0, 8, 4, 18],
    [0, 0, 1, 8, 4, 18],
    [0, 1, 0, 13, 5, 18],
    [0, 3, 0, 4, 4, 19],
    [0, 1, 1, 4, 4, 19],
    [0, 2, 0, 9, 5, 19],
    [0, 0, 1, 9, 5, 19],
    [0, 4, 0, 0, 0, 20],
    [0, 2, 1, 0, 0, 20],
    [0, 0, 2, 0, 0, 20],
    [0, 3, 0, 5, 1, 20],
    [0, 1, 1, 5, 1, 20],
    [0, 2, 0, 10, 2, 20],
    [0, 0, 1, 10, 2, 20],
    [0, 1, 0, 15, 3, 20],
    [0, 0, 0, 20, 4, 20],
    [0, 0, 2, 1, 1, 21],
    [0, 0, 1, 11, 3, 21],
    [0, 0, 0, 21, 5, 21],
    [0, 0, 2, 2, 2, 22],
    [0, 0, 1, 12, 4, 22],
    [0, 0, 2, 3, 3, 23],
    [0, 0, 1, 13, 5, 23],
    [0, 0, 2, 4, 4, 24],
    [0, 0, 2, 5, 1, 25],
    [0, 0, 1, 15, 3, 25],
    [0, 0, 0, 25, 5, 25],
  ],
  17: [
    [1, 0, 0, 15, 3, 3],
    [1, 0, 0, 16, 4, 3],
    [2, 0, 0, 11, 3, 6],
    [3, 0, 0, 10, 2, 9],
    [4, 0, 0, 5, 1, 12],
    [4, 1, 0, 0, 0, 17],
    [2, 2, 0, 1, 1, 17],
    [2, 0, 1, 1, 1, 17],
    [0, 3, 0, 2, 2, 17],
    [0, 1, 1, 2, 2, 17],
    [2, 1, 0, 6, 2, 17],
    [0, 2, 0, 7, 3, 17],
    [0, 0, 1, 7, 3, 17],
    [1, 2, 0, 4, 4, 17],
    [1, 0, 1, 4, 4, 17],
    [0, 1, 0, 12, 4, 17],
    [0, 0, 0, 17, 5, 17],
    [1, 3, 0, 0, 0, 18],
    [1, 1, 1, 0, 0, 18],
    [4, 1, 0, 1, 1, 18],
    [1, 2, 0, 5, 1, 18],
    [1, 0, 1, 5, 1, 18],
    [2, 2, 0, 2, 2, 18],
    [2, 0, 1, 2, 2, 18],
    [1, 1, 0, 10, 2, 18],
    [0, 3, 0, 3, 3, 18],
    [0, 1, 1, 3, 3, 18],
    [2, 1, 0, 7, 3, 18],
    [0, 2, 0, 8, 4, 18],
    [0, 0, 1, 8, 4, 18],
    [0, 1, 0, 13, 5, 18],
    [3, 2, 0, 0, 0, 19],
    [3, 0, 1, 0, 0, 19],
    [1, 3, 0, 1, 1, 19],
    [1, 1, 1, 1, 1, 19],
    [3, 1, 0, 5, 1, 19],
    [1, 2, 0, 6, 2, 19],
    [1, 0, 1, 6, 2, 19],
    [2, 2, 0, 3, 3, 19],
    [2, 0, 1, 3, 3, 19],
    [1, 1, 0, 11, 3, 19],
    [0, 3, 0, 4, 4, 19],
    [0, 1, 1, 4, 4, 19],
    [0, 2, 0, 9, 5, 19],
    [0, 0, 1, 9, 5, 19],
    [0, 4, 0, 0, 0, 20],
    [0, 2, 1, 0, 0, 20],
    [0, 0, 2, 0, 0, 20],
    [0, 3, 0, 5, 1, 20],
    [0, 1, 1, 5, 1, 20],
    [0, 2, 0, 10, 2, 20],
    [0, 0, 1, 10, 2, 20],
    [0, 1, 0, 15, 3, 20],
    [0, 0, 0, 20, 4, 20],
    [0, 4, 0, 1, 1, 21],
    [0, 2, 1, 1, 1, 21],
    [0, 0, 2, 1, 1, 21],
    [0, 3, 0, 6, 2, 21],
    [0, 1, 1, 6, 2, 21],
    [0, 2, 0, 11, 3, 21],
    [0, 0, 1, 11, 3, 21],
    [0, 1, 0, 16, 4, 21],
    [0, 0, 0, 21, 5, 21],
    [0, 0, 2, 2, 2, 22],
    [0, 0, 1, 12, 4, 22],
    [0, 0, 2, 3, 3, 23],
    [0, 0, 1, 13, 5, 23],
    [0, 0, 2, 4, 4, 24],
    [0, 0, 2, 5, 1, 25],
    [0, 0, 1, 15, 3, 25],
    [0, 0, 0, 25, 5, 25],
    [0, 0, 2, 6, 2, 26],
    [0, 0, 1, 16, 4, 26],
  ],
  18: [
    [1, 0, 0, 15, 3, 3],
    [1, 0, 0, 16, 4, 3],
    [3, 0, 0, 10, 2, 9],
    [1, 3, 0, 0, 0, 18],
    [1, 1, 1, 0, 0, 18],
    [4, 1, 0, 1, 1, 18],
    [1, 2, 0, 5, 1, 18],
    [1, 0, 1, 5, 1, 18],
    [2, 2, 0, 2, 2, 18],
    [2, 0, 1, 2, 2, 18],
    [1, 1, 0, 10, 2, 18],
    [0, 3, 0, 3, 3, 18],
    [0, 1, 1, 3, 3, 18],
    [2, 1, 0, 7, 3, 18],
    [0, 2, 0, 8, 4, 18],
    [0, 0, 1, 8, 4, 18],
    [0, 1, 0, 13, 5, 18],
    [3, 2, 0, 0, 0, 19],
    [3, 0, 1, 0, 0, 19],
    [1, 3, 0, 1, 1, 19],
    [1, 1, 1, 1, 1, 19],
    [3, 1, 0, 5, 1, 19],
    [1, 2, 0, 6, 2, 19],
    [1, 0, 1, 6, 2, 19],
    [2, 2, 0, 3, 3, 19],
    [2, 0, 1, 3, 3, 19],
    [1, 1, 0, 11, 3, 19],
    [0, 3, 0, 4, 4, 19],
    [0, 1, 1, 4, 4, 19],
    [0, 2, 0, 9, 5, 19],
    [0, 0, 1, 9, 5, 19],
    [5, 1, 0, 0, 0, 20],
    [0, 4, 0, 0, 0, 20],
    [0, 2, 1, 0, 0, 20],
    [0, 0, 2, 0, 0, 20],
    [3, 2, 0, 1, 1, 20],
    [3, 0, 1, 1, 1, 20],
    [0, 3, 0, 5, 1, 20],
    [0, 1, 1, 5, 1, 20],
    [1, 3, 0, 2, 2, 20],
    [1, 1, 1, 2, 2, 20],
    [3, 1, 0, 6, 2, 20],
    [0, 2, 0, 10, 2, 20],
    [0, 0, 1, 10, 2, 20],
    [1, 2, 0, 7, 3, 20],
    [1, 0, 1, 7, 3, 20],
    [0, 1, 0, 15, 3, 20],
    [1, 1, 0, 12, 4, 20],
    [0, 0, 0, 20, 4, 20],
    [0, 4, 0, 1, 1, 21],
    [0, 2, 1, 1, 1, 21],
    [0, 0, 2, 1, 1, 21],
    [0, 3, 0, 6, 2, 21],
    [0, 1, 1, 6, 2, 21],
    [0, 2, 0, 11, 3, 21],
    [0, 0, 1, 11, 3, 21],
    [0, 1, 0, 16, 4, 21],
    [0, 0, 0, 21, 5, 21],
    [0, 4, 0, 2, 2, 22],
    [0, 2, 1, 2, 2, 22],
    [0, 0, 2, 2, 2, 22],
    [0, 3, 0, 7, 3, 22],
    [0, 1, 1, 7, 3, 22],
    [0, 2, 0, 12, 4, 22],
    [0, 0, 1, 12, 4, 22],
    [0, 1, 0, 17, 5, 22],
    [0, 0, 2, 3, 3, 23],
    [0, 0, 1, 13, 5, 23],
    [0, 0, 2, 4, 4, 24],
    [0, 0, 2, 5, 1, 25],
    [0, 0, 1, 15, 3, 25],
    [0, 0, 0, 25, 5, 25],
    [0, 0, 2, 6, 2, 26],
    [0, 0, 1, 16, 4, 26],
    [0, 0, 2, 7, 3, 27],
    [0, 0, 1, 17, 5, 27],
  ],
  19: [
    [1, 0, 0, 16, 4, 3],
    [2, 0, 0, 15, 3, 6],
    [3, 0, 0, 10, 2, 9],
    [3, 2, 0, 0, 0, 19],
    [3, 0, 1, 0, 0, 19],
    [1, 3, 0, 1, 1, 19],
    [1, 1, 1, 1, 1, 19],
    [3, 1, 0, 5, 1, 19],
    [1, 2, 0, 6, 2, 19],
    [1, 0, 1, 6, 2, 19],
    [2, 2, 0, 3, 3, 19],
    [2, 0, 1, 3, 3, 19],
    [1, 1, 0, 11, 3, 19],
    [0, 3, 0, 4, 4, 19],
    [0, 1, 1, 4, 4, 19],
    [0, 2, 0, 9, 5, 19],
    [0, 0, 1, 9, 5, 19],
    [5, 1, 0, 0, 0, 20],
    [0, 4, 0, 0, 0, 20],
    [0, 2, 1, 0, 0, 20],
    [0, 0, 2, 0, 0, 20],
    [3, 2, 0, 1, 1, 20],
    [3, 0, 1, 1, 1, 20],
    [0, 3, 0, 5, 1, 20],
    [0, 1, 1, 5, 1, 20],
    [1, 3, 0, 2, 2, 20],
    [1, 1, 1, 2, 2, 20],
    [3, 1, 0, 6, 2, 20],
    [0, 2, 0, 10, 2, 20],
    [0, 0, 1, 10, 2, 20],
    [1, 2, 0, 7, 3, 20],
    [1, 0, 1, 7, 3, 20],
    [0, 1, 0, 15, 3, 20],
    [1, 1, 0, 12, 4, 20],
    [0, 0, 0, 20, 4, 20],
    [2, 3, 0, 0, 0, 21],
    [2, 1, 1, 0, 0, 21],
    [0, 4, 0, 1, 1, 21],
    [0, 2, 1, 1, 1, 21],
    [0, 0, 2, 1, 1, 21],
    [2, 2, 0, 5, 1, 21],
    [2, 0, 1, 5, 1, 21],
    [3, 2, 0, 2, 2, 21],
    [3, 0, 1, 2, 2, 21],
    [0, 3, 0, 6, 2, 21],
    [0, 1, 1, 6, 2, 21],
    [2, 1, 0, 10, 2, 21],
    [1, 3, 0, 3, 3, 21],
    [1, 1, 1, 3, 3, 21],
    [0, 2, 0, 11, 3, 21],
    [0, 0, 1, 11, 3, 21],
    [1, 2, 0, 8, 4, 21],
    [1, 0, 1, 8, 4, 21],
    [0, 1, 0, 16, 4, 21],
    [0, 0, 0, 21, 5, 21],
    [0, 4, 0, 2, 2, 22],
    [0, 2, 1, 2, 2, 22],
    [0, 0, 2, 2, 2, 22],
    [0, 3, 0, 7, 3, 22],
    [0, 1, 1, 7, 3, 22],
    [0, 2, 0, 12, 4, 22],
    [0, 0, 1, 12, 4, 22],
    [0, 1, 0, 17, 5, 22],
    [0, 4, 0, 3, 3, 23],
    [0, 2, 1, 3, 3, 23],
    [0, 0, 2, 3, 3, 23],
    [0, 3, 0, 8, 4, 23],
    [0, 1, 1, 8, 4, 23],
    [0, 2, 0, 13, 5, 23],
    [0, 0, 1, 13, 5, 23],
    [0, 0, 2, 4, 4, 24],
    [0, 0, 2, 5, 1, 25],
    [0, 0, 1, 15, 3, 25],
    [0, 0, 0, 25, 5, 25],
    [0, 0, 2, 6, 2, 26],
    [0, 0, 1, 16, 4, 26],
    [0, 0, 2, 7, 3, 27],
    [0, 0, 1, 17, 5, 27],
    [0, 0, 2, 8, 4, 28],
  ],
  20: [
    [2, 0, 0, 15, 3, 6],
    [5, 1, 0, 0, 0, 20],
    [0, 4, 0, 0, 0, 20],
    [0, 2, 1, 0, 0, 20],
    [0, 0, 2, 0, 0, 20],
    [3, 2, 0, 1, 1, 20],
    [3, 0, 1, 1, 1, 20],
    [0, 3, 0, 5, 1, 20],
    [0, 1, 1, 5, 1, 20],
    [1, 3, 0, 2, 2, 20],
    [1, 1, 1, 2, 2, 20],
    [3, 1, 0, 6, 2, 20],
    [0, 2, 0, 10, 2, 20],
    [0, 0, 1, 10, 2, 20],
    [1, 2, 0, 7, 3, 20],
    [1, 0, 1, 7, 3, 20],
    [0, 1, 0, 15, 3, 20],
    [1, 1, 0, 12, 4, 20],
    [0, 0, 0, 20, 4, 20],
    [2, 3, 0, 0, 0, 21],
    [2, 1, 1, 0, 0, 21],
    [0, 4, 0, 1, 1, 21],
    [0, 2, 1, 1, 1, 21],
    [0, 0, 2, 1, 1, 21],
    [2, 2, 0, 5, 1, 21],
    [2, 0, 1, 5, 1, 21],
    [3, 2, 0, 2, 2, 21],
    [3, 0, 1, 2, 2, 21],
    [0, 3, 0, 6, 2, 21],
    [0, 1, 1, 6, 2, 21],
    [2, 1, 0, 10, 2, 21],
    [1, 3, 0, 3, 3, 21],
    [1, 1, 1, 3, 3, 21],
    [0, 2, 0, 11, 3, 21],
    [0, 0, 1, 11, 3, 21],
    [1, 2, 0, 8, 4, 21],
    [1, 0, 1, 8, 4, 21],
    [0, 1, 0, 16, 4, 21],
    [0, 0, 0, 21, 5, 21],
    [4, 2, 0, 0, 0, 22],
    [4, 0, 1, 0, 0, 22],
    [2, 3, 0, 1, 1, 22],
    [2, 1, 1, 1, 1, 22],
    [4, 1, 0, 5, 1, 22],
    [0, 4, 0, 2, 2, 22],
    [0, 2, 1, 2, 2, 22],
    [0, 0, 2, 2, 2, 22],
    [2, 2, 0, 6, 2, 22],
    [2, 0, 1, 6, 2, 22],
    [0, 3, 0, 7, 3, 22],
    [0, 1, 1, 7, 3, 22],
    [2, 1, 0, 11, 3, 22],
    [1, 3, 0, 4, 4, 22],
    [1, 1, 1, 4, 4, 22],
    [0, 2, 0, 12, 4, 22],
    [0, 0, 1, 12, 4, 22],
    [0, 1, 0, 17, 5, 22],
    [0, 4, 0, 3, 3, 23],
    [0, 2, 1, 3, 3, 23],
    [0, 0, 2, 3, 3, 23],
    [0, 3, 0, 8, 4, 23],
    [0, 1, 1, 8, 4, 23],
    [0, 2, 0, 13, 5, 23],
    [0, 0, 1, 13, 5, 23],
    [0, 4, 0, 4, 4, 24],
    [0, 2, 1, 4, 4, 24],
    [0, 0, 2, 4, 4, 24],
    [0, 3, 0, 9, 5, 24],
    [0, 1, 1, 9, 5, 24],
    [0, 0, 2, 5, 1, 25],
    [0, 0, 1, 15, 3, 25],
    [0, 0, 0, 25, 5, 25],
    [0, 0, 2, 6, 2, 26],
    [0, 0, 1, 16, 4, 26],
    [0, 0, 2, 7, 3, 27],
    [0, 0, 1, 17, 5, 27],
    [0, 0, 2, 8, 4, 28],
    [0, 0, 2, 9, 5, 29],
  ],
  21: [
    [1, 0, 0, 20, 4, 3],
    [2, 0, 0, 15, 3, 6],
    [2, 3, 0, 0, 0, 21],
    [2, 1, 1, 0, 0, 21],
    [0, 4, 0, 1, 1, 21],
    [0, 2, 1, 1, 1, 21],
    [0, 0, 2, 1, 1, 21],
    [2, 2, 0, 5, 1, 21],
    [2, 0, 1, 5, 1, 21],
    [3, 2, 0, 2, 2, 21],
    [3, 0, 1, 2, 2, 21],
    [0, 3, 0, 6, 2, 21],
    [0, 1, 1, 6, 2, 21],
    [2, 1, 0, 10, 2, 21],
    [1, 3, 0, 3, 3, 21],
    [1, 1, 1, 3, 3, 21],
    [0, 2, 0, 11, 3, 21],
    [0, 0, 1, 11, 3, 21],
    [1, 2, 0, 8, 4, 21],
    [1, 0, 1, 8, 4, 21],
    [0, 1, 0, 16, 4, 21],
    [0, 0, 0, 21, 5, 21],
    [4, 2, 0, 0, 0, 22],
    [4, 0, 1, 0, 0, 22],
    [2, 3, 0, 1, 1, 22],
    [2, 1, 1, 1, 1, 22],
    [4, 1, 0, 5, 1, 22],
    [0, 4, 0, 2, 2, 22],
    [0, 2, 1, 2, 2, 22],
    [0, 0, 2, 2, 2, 22],
    [2, 2, 0, 6, 2, 22],
    [2, 0, 1, 6, 2, 22],
    [0, 3, 0, 7, 3, 22],
    [0, 1, 1, 7, 3, 22],
    [2, 1, 0, 11, 3, 22],
    [1, 3, 0, 4, 4, 22],
    [1, 1, 1, 4, 4, 22],
    [0, 2, 0, 12, 4, 22],
    [0, 0, 1, 12, 4, 22],
    [0, 1, 0, 17, 5, 22],
    [1, 4, 0, 0, 0, 23],
    [1, 2, 1, 0, 0, 23],
    [1, 0, 2, 0, 0, 23],
    [4, 2, 0, 1, 1, 23],
    [4, 0, 1, 1, 1, 23],
    [1, 3, 0, 5, 1, 23],
    [1, 1, 1, 5, 1, 23],
    [2, 3, 0, 2, 2, 23],
    [2, 1, 1, 2, 2, 23],
    [1, 2, 0, 10, 2, 23],
    [1, 0, 1, 10, 2, 23],
    [0, 4, 0, 3, 3, 23],
    [0, 2, 1, 3, 3, 23],
    [0, 0, 2, 3, 3, 23],
    [2, 2, 0, 7, 3, 23],
    [2, 0, 1, 7, 3, 23],
    [1, 1, 0, 15, 3, 23],
    [0, 3, 0, 8, 4, 23],
    [0, 1, 1, 8, 4, 23],
    [0, 2, 0, 13, 5, 23],
    [0, 0, 1, 13, 5, 23],
    [0, 4, 0, 4, 4, 24],
    [0, 2, 1, 4, 4, 24],
    [0, 0, 2, 4, 4, 24],
    [0, 3, 0, 9, 5, 24],
    [0, 1, 1, 9, 5, 24],
    [0, 5, 0, 0, 0, 25],
    [0, 3, 1, 0, 0, 25],
    [0, 1, 2, 0, 0, 25],
    [0, 4, 0, 5, 1, 25],
    [0, 2, 1, 5, 1, 25],
    [0, 0, 2, 5, 1, 25],
    [0, 3, 0, 10, 2, 25],
    [0, 1, 1, 10, 2, 25],
    [0, 2, 0, 15, 3, 25],
    [0, 0, 1, 15, 3, 25],
    [0, 1, 0, 20, 4, 25],
    [0, 0, 0, 25, 5, 25],
    [0, 0, 2, 6, 2, 26],
    [0, 0, 1, 16, 4, 26],
    [0, 0, 2, 7, 3, 27],
    [0, 0, 1, 17, 5, 27],
    [0, 0, 2, 8, 4, 28],
    [0, 0, 2, 9, 5, 29],
    [0, 0, 3, 0, 0, 30],
    [0, 0, 2, 10, 2, 30],
    [0, 0, 1, 20, 4, 30],
  ],
  22: [
    [1, 0, 0, 20, 4, 3],
    [4, 2, 0, 0, 0, 22],
    [4, 0, 1, 0, 0, 22],
    [2, 3, 0, 1, 1, 22],
    [2, 1, 1, 1, 1, 22],
    [4, 1, 0, 5, 1, 22],
    [0, 4, 0, 2, 2, 22],
    [0, 2, 1, 2, 2, 22],
    [0, 0, 2, 2, 2, 22],
    [2, 2, 0, 6, 2, 22],
    [2, 0, 1, 6, 2, 22],
    [0, 3, 0, 7, 3, 22],
    [0, 1, 1, 7, 3, 22],
    [2, 1, 0, 11, 3, 22],
    [1, 3, 0, 4, 4, 22],
    [1, 1, 1, 4, 4, 22],
    [0, 2, 0, 12, 4, 22],
    [0, 0, 1, 12, 4, 22],
    [0, 1, 0, 17, 5, 22],
    [1, 4, 0, 0, 0, 23],
    [1, 2, 1, 0, 0, 23],
    [1, 0, 2, 0, 0, 23],
    [4, 2, 0, 1, 1, 23],
    [4, 0, 1, 1, 1, 23],
    [1, 3, 0, 5, 1, 23],
    [1, 1, 1, 5, 1, 23],
    [2, 3, 0, 2, 2, 23],
    [2, 1, 1, 2, 2, 23],
    [1, 2, 0, 10, 2, 23],
    [1, 0, 1, 10, 2, 23],
    [0, 4, 0, 3, 3, 23],
    [0, 2, 1, 3, 3, 23],
    [0, 0, 2, 3, 3, 23],
    [2, 2, 0, 7, 3, 23],
    [2, 0, 1, 7, 3, 23],
    [1, 1, 0, 15, 3, 23],
    [0, 3, 0, 8, 4, 23],
    [0, 1, 1, 8, 4, 23],
    [0, 2, 0, 13, 5, 23],
    [0, 0, 1, 13, 5, 23],
    [3, 3, 0, 0, 0, 24],
    [3, 1, 1, 0, 0, 24],
    [1, 4, 0, 1, 1, 24],
    [1, 2, 1, 1, 1, 24],
    [1, 0, 2, 1, 1, 24],
    [3, 2, 0, 5, 1, 24],
    [3, 0, 1, 5, 1, 24],
    [1, 3, 0, 6, 2, 24],
    [1, 1, 1, 6, 2, 24],
    [3, 1, 0, 10, 2, 24],
    [2, 3, 0, 3, 3, 24],
    [2, 1, 1, 3, 3, 24],
    [1, 2, 0, 11, 3, 24],
    [1, 0, 1, 11, 3, 24],
    [0, 4, 0, 4, 4, 24],
    [0, 2, 1, 4, 4, 24],
    [0, 0, 2, 4, 4, 24],
    [1, 1, 0, 16, 4, 24],
    [0, 3, 0, 9, 5, 24],
    [0, 1, 1, 9, 5, 24],
    [0, 5, 0, 0, 0, 25],
    [0, 3, 1, 0, 0, 25],
    [0, 1, 2, 0, 0, 25],
    [0, 4, 0, 5, 1, 25],
    [0, 2, 1, 5, 1, 25],
    [0, 0, 2, 5, 1, 25],
    [0, 3, 0, 10, 2, 25],
    [0, 1, 1, 10, 2, 25],
    [0, 2, 0, 15, 3, 25],
    [0, 0, 1, 15, 3, 25],
    [0, 1, 0, 20, 4, 25],
    [0, 0, 0, 25, 5, 25],
    [0, 5, 0, 1, 1, 26],
    [0, 3, 1, 1, 1, 26],
    [0, 1, 2, 1, 1, 26],
    [0, 4, 0, 6, 2, 26],
    [0, 2, 1, 6, 2, 26],
    [0, 0, 2, 6, 2, 26],
    [0, 3, 0, 11, 3, 26],
    [0, 1, 1, 11, 3, 26],
    [0, 2, 0, 16, 4, 26],
    [0, 0, 1, 16, 4, 26],
    [0, 1, 0, 21, 5, 26],
    [0, 0, 2, 7, 3, 27],
    [0, 0, 1, 17, 5, 27],
    [0, 0, 2, 8, 4, 28],
    [0, 0, 2, 9, 5, 29],
    [0, 0, 3, 0, 0, 30],
    [0, 0, 2, 10, 2, 30],
    [0, 0, 1, 20, 4, 30],
    [0, 0, 3, 1, 1, 31],
    [0, 0, 2, 11, 3, 31],
    [0, 0, 1, 21, 5, 31],
  ],
  23: [
    [1, 0, 0, 20, 4, 3],
    [1, 4, 0, 0, 0, 23],
    [1, 2, 1, 0, 0, 23],
    [1, 0, 2, 0, 0, 23],
    [4, 2, 0, 1, 1, 23],
    [4, 0, 1, 1, 1, 23],
    [1, 3, 0, 5, 1, 23],
    [1, 1, 1, 5, 1, 23],
    [2, 3, 0, 2, 2, 23],
    [2, 1, 1, 2, 2, 23],
    [1, 2, 0, 10, 2, 23],
    [1, 0, 1, 10, 2, 23],
    [0, 4, 0, 3, 3, 23],
    [0, 2, 1, 3, 3, 23],
    [0, 0, 2, 3, 3, 23],
    [2, 2, 0, 7, 3, 23],
    [2, 0, 1, 7, 3, 23],
    [1, 1, 0, 15, 3, 23],
    [0, 3, 0, 8, 4, 23],
    [0, 1, 1, 8, 4, 23],
    [0, 2, 0, 13, 5, 23],
    [0, 0, 1, 13, 5, 23],
    [3, 3, 0, 0, 0, 24],
    [3, 1, 1, 0, 0, 24],
    [1, 4, 0, 1, 1, 24],
    [1, 2, 1, 1, 1, 24],
    [1, 0, 2, 1, 1, 24],
    [3, 2, 0, 5, 1, 24],
    [3, 0, 1, 5, 1, 24],
    [1, 3, 0, 6, 2, 24],
    [1, 1, 1, 6, 2, 24],
    [3, 1, 0, 10, 2, 24],
    [2, 3, 0, 3, 3, 24],
    [2, 1, 1, 3, 3, 24],
    [1, 2, 0, 11, 3, 24],
    [1, 0, 1, 11, 3, 24],
    [0, 4, 0, 4, 4, 24],
    [0, 2, 1, 4, 4, 24],
    [0, 0, 2, 4, 4, 24],
    [1, 1, 0, 16, 4, 24],
    [0, 3, 0, 9, 5, 24],
    [0, 1, 1, 9, 5, 24],
    [5, 2, 0, 0, 0, 25],
    [0, 5, 0, 0, 0, 25],
    [5, 0, 1, 0, 0, 25],
    [0, 3, 1, 0, 0, 25],
    [0, 1, 2, 0, 0, 25],
    [3, 3, 0, 1, 1, 25],
    [3, 1, 1, 1, 1, 25],
    [0, 4, 0, 5, 1, 25],
    [0, 2, 1, 5, 1, 25],
    [0, 0, 2, 5, 1, 25],
    [1, 4, 0, 2, 2, 25],
    [1, 2, 1, 2, 2, 25],
    [1, 0, 2, 2, 2, 25],
    [3, 2, 0, 6, 2, 25],
    [3, 0, 1, 6, 2, 25],
    [0, 3, 0, 10, 2, 25],
    [0, 1, 1, 10, 2, 25],
    [1, 3, 0, 7, 3, 25],
    [1, 1, 1, 7, 3, 25],
    [0, 2, 0, 15, 3, 25],
    [0, 0, 1, 15, 3, 25],
    [1, 2, 0, 12, 4, 25],
    [1, 0, 1, 12, 4, 25],
    [0, 1, 0, 20, 4, 25],
    [0, 0, 0, 25, 5, 25],
    [0, 5, 0, 1, 1, 26],
    [0, 3, 1, 1, 1, 26],
    [0, 1, 2, 1, 1, 26],
    [0, 4, 0, 6, 2, 26],
    [0, 2, 1, 6, 2, 26],
    [0, 0, 2, 6, 2, 26],
    [0, 3, 0, 11, 3, 26],
    [0, 1, 1, 11, 3, 26],
    [0, 2, 0, 16, 4, 26],
    [0, 0, 1, 16, 4, 26],
    [0, 1, 0, 21, 5, 26],
    [0, 5, 0, 2, 2, 27],
    [0, 3, 1, 2, 2, 27],
    [0, 1, 2, 2, 2, 27],
    [0, 4, 0, 7, 3, 27],
    [0, 2, 1, 7, 3, 27],
    [0, 0, 2, 7, 3, 27],
    [0, 3, 0, 12, 4, 27],
    [0, 1, 1, 12, 4, 27],
    [0, 2, 0, 17, 5, 27],
    [0, 0, 1, 17, 5, 27],
    [0, 0, 2, 8, 4, 28],
    [0, 0, 2, 9, 5, 29],
    [0, 0, 3, 0, 0, 30],
    [0, 0, 2, 10, 2, 30],
    [0, 0, 1, 20, 4, 30],
    [0, 0, 3, 1, 1, 31],
    [0, 0, 2, 11, 3, 31],
    [0, 0, 1, 21, 5, 31],
    [0, 0, 3, 2, 2, 32],
    [0, 0, 2, 12, 4, 32],
  ],
  24: [
    [3, 3, 0, 0, 0, 24],
    [3, 1, 1, 0, 0, 24],
    [1, 4, 0, 1, 1, 24],
    [1, 2, 1, 1, 1, 24],
    [1, 0, 2, 1, 1, 24],
    [3, 2, 0, 5, 1, 24],
    [3, 0, 1, 5, 1, 24],
    [1, 3, 0, 6, 2, 24],
    [1, 1, 1, 6, 2, 24],
    [3, 1, 0, 10, 2, 24],
    [2, 3, 0, 3, 3, 24],
    [2, 1, 1, 3, 3, 24],
    [1, 2, 0, 11, 3, 24],
    [1, 0, 1, 11, 3, 24],
    [0, 4, 0, 4, 4, 24],
    [0, 2, 1, 4, 4, 24],
    [0, 0, 2, 4, 4, 24],
    [1, 1, 0, 16, 4, 24],
    [0, 3, 0, 9, 5, 24],
    [0, 1, 1, 9, 5, 24],
    [5, 2, 0, 0, 0, 25],
    [0, 5, 0, 0, 0, 25],
    [5, 0, 1, 0, 0, 25],
    [0, 3, 1, 0, 0, 25],
    [0, 1, 2, 0, 0, 25],
    [3, 3, 0, 1, 1, 25],
    [3, 1, 1, 1, 1, 25],
    [0, 4, 0, 5, 1, 25],
    [0, 2, 1, 5, 1, 25],
    [0, 0, 2, 5, 1, 25],
    [1, 4, 0, 2, 2, 25],
    [1, 2, 1, 2, 2, 25],
    [1, 0, 2, 2, 2, 25],
    [3, 2, 0, 6, 2, 25],
    [3, 0, 1, 6, 2, 25],
    [0, 3, 0, 10, 2, 25],
    [0, 1, 1, 10, 2, 25],
    [1, 3, 0, 7, 3, 25],
    [1, 1, 1, 7, 3, 25],
    [0, 2, 0, 15, 3, 25],
    [0, 0, 1, 15, 3, 25],
    [1, 2, 0, 12, 4, 25],
    [1, 0, 1, 12, 4, 25],
    [0, 1, 0, 20, 4, 25],
    [0, 0, 0, 25, 5, 25],
    [2, 4, 0, 0, 0, 26],
    [2, 2, 1, 0, 0, 26],
    [2, 0, 2, 0, 0, 26],
    [0, 5, 0, 1, 1, 26],
    [0, 3, 1, 1, 1, 26],
    [0, 1, 2, 1, 1, 26],
    [2, 3, 0, 5, 1, 26],
    [2, 1, 1, 5, 1, 26],
    [3, 3, 0, 2, 2, 26],
    [3, 1, 1, 2, 2, 26],
    [0, 4, 0, 6, 2, 26],
    [0, 2, 1, 6, 2, 26],
    [0, 0, 2, 6, 2, 26],
    [2, 2, 0, 10, 2, 26],
    [2, 0, 1, 10, 2, 26],
    [1, 4, 0, 3, 3, 26],
    [1, 2, 1, 3, 3, 26],
    [1, 0, 2, 3, 3, 26],
    [0, 3, 0, 11, 3, 26],
    [0, 1, 1, 11, 3, 26],
    [2, 1, 0, 15, 3, 26],
    [1, 3, 0, 8, 4, 26],
    [1, 1, 1, 8, 4, 26],
    [0, 2, 0, 16, 4, 26],
    [0, 0, 1, 16, 4, 26],
    [0, 1, 0, 21, 5, 26],
    [0, 5, 0, 2, 2, 27],
    [0, 3, 1, 2, 2, 27],
    [0, 1, 2, 2, 2, 27],
    [0, 4, 0, 7, 3, 27],
    [0, 2, 1, 7, 3, 27],
    [0, 0, 2, 7, 3, 27],
    [0, 3, 0, 12, 4, 27],
    [0, 1, 1, 12, 4, 27],
    [0, 2, 0, 17, 5, 27],
    [0, 0, 1, 17, 5, 27],
    [0, 5, 0, 3, 3, 28],
    [0, 3, 1, 3, 3, 28],
    [0, 1, 2, 3, 3, 28],
    [0, 4, 0, 8, 4, 28],
    [0, 2, 1, 8, 4, 28],
    [0, 0, 2, 8, 4, 28],
    [0, 3, 0, 13, 5, 28],
    [0, 1, 1, 13, 5, 28],
    [0, 0, 2, 9, 5, 29],
    [0, 0, 3, 0, 0, 30],
    [0, 0, 2, 10, 2, 30],
    [0, 0, 1, 20, 4, 30],
    [0, 0, 3, 1, 1, 31],
    [0, 0, 2, 11, 3, 31],
    [0, 0, 1, 21, 5, 31],
    [0, 0, 3, 2, 2, 32],
    [0, 0, 2, 12, 4, 32],
    [0, 0, 3, 3, 3, 33],
    [0, 0, 2, 13, 5, 33],
  ],
  25: [
    [5, 2, 0, 0, 0, 25],
    [0, 5, 0, 0, 0, 25],
    [5, 0, 1, 0, 0, 25],
    [0, 3, 1, 0, 0, 25],
    [0, 1, 2, 0, 0, 25],
    [3, 3, 0, 1, 1, 25],
    [3, 1, 1, 1, 1, 25],
    [0, 4, 0, 5, 1, 25],
    [0, 2, 1, 5, 1, 25],
    [0, 0, 2, 5, 1, 25],
    [1, 4, 0, 2, 2, 25],
    [1, 2, 1, 2, 2, 25],
    [1, 0, 2, 2, 2, 25],
    [3, 2, 0, 6, 2, 25],
    [3, 0, 1, 6, 2, 25],
    [0, 3, 0, 10, 2, 25],
    [0, 1, 1, 10, 2, 25],
    [1, 3, 0, 7, 3, 25],
    [1, 1, 1, 7, 3, 25],
    [0, 2, 0, 15, 3, 25],
    [0, 0, 1, 15, 3, 25],
    [1, 2, 0, 12, 4, 25],
    [1, 0, 1, 12, 4, 25],
    [0, 1, 0, 20, 4, 25],
    [0, 0, 0, 25, 5, 25],
    [2, 4, 0, 0, 0, 26],
    [2, 2, 1, 0, 0, 26],
    [2, 0, 2, 0, 0, 26],
    [0, 5, 0, 1, 1, 26],
    [0, 3, 1, 1, 1, 26],
    [0, 1, 2, 1, 1, 26],
    [2, 3, 0, 5, 1, 26],
    [2, 1, 1, 5, 1, 26],
    [3, 3, 0, 2, 2, 26],
    [3, 1, 1, 2, 2, 26],
    [0, 4, 0, 6, 2, 26],
    [0, 2, 1, 6, 2, 26],
    [0, 0, 2, 6, 2, 26],
    [2, 2, 0, 10, 2, 26],
    [2, 0, 1, 10, 2, 26],
    [1, 4, 0, 3, 3, 26],
    [1, 2, 1, 3, 3, 26],
    [1, 0, 2, 3, 3, 26],
    [0, 3, 0, 11, 3, 26],
    [0, 1, 1, 11, 3, 26],
    [2, 1, 0, 15, 3, 26],
    [1, 3, 0, 8, 4, 26],
    [1, 1, 1, 8, 4, 26],
    [0, 2, 0, 16, 4, 26],
    [0, 0, 1, 16, 4, 26],
    [0, 1, 0, 21, 5, 26],
    [4, 3, 0, 0, 0, 27],
    [4, 1, 1, 0, 0, 27],
    [2, 4, 0, 1, 1, 27],
    [2, 2, 1, 1, 1, 27],
    [2, 0, 2, 1, 1, 27],
    [4, 2, 0, 5, 1, 27],
    [4, 0, 1, 5, 1, 27],
    [0, 5, 0, 2, 2, 27],
    [0, 3, 1, 2, 2, 27],
    [0, 1, 2, 2, 2, 27],
    [2, 3, 0, 6, 2, 27],
    [2, 1, 1, 6, 2, 27],
    [0, 4, 0, 7, 3, 27],
    [0, 2, 1, 7, 3, 27],
    [0, 0, 2, 7, 3, 27],
    [2, 2, 0, 11, 3, 27],
    [2, 0, 1, 11, 3, 27],
    [1, 4, 0, 4, 4, 27],
    [1, 2, 1, 4, 4, 27],
    [1, 0, 2, 4, 4, 27],
    [0, 3, 0, 12, 4, 27],
    [0, 1, 1, 12, 4, 27],
    [0, 2, 0, 17, 5, 27],
    [0, 0, 1, 17, 5, 27],
    [0, 5, 0, 3, 3, 28],
    [0, 3, 1, 3, 3, 28],
    [0, 1, 2, 3, 3, 28],
    [0, 4, 0, 8, 4, 28],
    [0, 2, 1, 8, 4, 28],
    [0, 0, 2, 8, 4, 28],
    [0, 3, 0, 13, 5, 28],
    [0, 1, 1, 13, 5, 28],
    [0, 5, 0, 4, 4, 29],
    [0, 3, 1, 4, 4, 29],
    [0, 1, 2, 4, 4, 29],
    [0, 4, 0, 9, 5, 29],
    [0, 2, 1, 9, 5, 29],
    [0, 0, 2, 9, 5, 29],
    [0, 0, 3, 0, 0, 30],
    [0, 0, 2, 10, 2, 30],
    [0, 0, 1, 20, 4, 30],
    [0, 0, 3, 1, 1, 31],
    [0, 0, 2, 11, 3, 31],
    [0, 0, 1, 21, 5, 31],
    [0, 0, 3, 2, 2, 32],
    [0, 0, 2, 12, 4, 32],
    [0, 0, 3, 3, 3, 33],
    [0, 0, 2, 13, 5, 33],
    [0, 0, 3, 4, 4, 34],
  ],
  26: [
    [2, 4, 0, 0, 0, 26],
    [2, 2, 1, 0, 0, 26],
    [2, 0, 2, 0, 0, 26],
    [0, 5, 0, 1, 1, 26],
    [0, 3, 1, 1, 1, 26],
    [0, 1, 2, 1, 1, 26],
    [2, 3, 0, 5, 1, 26],
    [2, 1, 1, 5, 1, 26],
    [3, 3, 0, 2, 2, 26],
    [3, 1, 1, 2, 2, 26],
    [0, 4, 0, 6, 2, 26],
    [0, 2, 1, 6, 2, 26],
    [0, 0, 2, 6, 2, 26],
    [2, 2, 0, 10, 2, 26],
    [2, 0, 1, 10, 2, 26],
    [1, 4, 0, 3, 3, 26],
    [1, 2, 1, 3, 3, 26],
    [1, 0, 2, 3, 3, 26],
    [0, 3, 0, 11, 3, 26],
    [0, 1, 1, 11, 3, 26],
    [2, 1, 0, 15, 3, 26],
    [1, 3, 0, 8, 4, 26],
    [1, 1, 1, 8, 4, 26],
    [0, 2, 0, 16, 4, 26],
    [0, 0, 1, 16, 4, 26],
    [0, 1, 0, 21, 5, 26],
    [4, 3, 0, 0, 0, 27],
    [4, 1, 1, 0, 0, 27],
    [2, 4, 0, 1, 1, 27],
    [2, 2, 1, 1, 1, 27],
    [2, 0, 2, 1, 1, 27],
    [4, 2, 0, 5, 1, 27],
    [4, 0, 1, 5, 1, 27],
    [0, 5, 0, 2, 2, 27],
    [0, 3, 1, 2, 2, 27],
    [0, 1, 2, 2, 2, 27],
    [2, 3, 0, 6, 2, 27],
    [2, 1, 1, 6, 2, 27],
    [0, 4, 0, 7, 3, 27],
    [0, 2, 1, 7, 3, 27],
    [0, 0, 2, 7, 3, 27],
    [2, 2, 0, 11, 3, 27],
    [2, 0, 1, 11, 3, 27],
    [1, 4, 0, 4, 4, 27],
    [1, 2, 1, 4, 4, 27],
    [1, 0, 2, 4, 4, 27],
    [0, 3, 0, 12, 4, 27],
    [0, 1, 1, 12, 4, 27],
    [0, 2, 0, 17, 5, 27],
    [0, 0, 1, 17, 5, 27],
    [1, 5, 0, 0, 0, 28],
    [1, 3, 1, 0, 0, 28],
    [1, 1, 2, 0, 0, 28],
    [4, 3, 0, 1, 1, 28],
    [4, 1, 1, 1, 1, 28],
    [1, 4, 0, 5, 1, 28],
    [1, 2, 1, 5, 1, 28],
    [1, 0, 2, 5, 1, 28],
    [2, 4, 0, 2, 2, 28],
    [2, 2, 1, 2, 2, 28],
    [2, 0, 2, 2, 2, 28],
    [1, 3, 0, 10, 2, 28],
    [1, 1, 1, 10, 2, 28],
    [0, 5, 0, 3, 3, 28],
    [0, 3, 1, 3, 3, 28],
    [0, 1, 2, 3, 3, 28],
    [2, 3, 0, 7, 3, 28],
    [2, 1, 1, 7, 3, 28],
    [1, 2, 0, 15, 3, 28],
    [1, 0, 1, 15, 3, 28],
    [0, 4, 0, 8, 4, 28],
    [0, 2, 1, 8, 4, 28],
    [0, 0, 2, 8, 4, 28],
    [1, 1, 0, 20, 4, 28],
    [0, 3, 0, 13, 5, 28],
    [0, 1, 1, 13, 5, 28],
    [0, 5, 0, 4, 4, 29],
    [0, 3, 1, 4, 4, 29],
    [0, 1, 2, 4, 4, 29],
    [0, 4, 0, 9, 5, 29],
    [0, 2, 1, 9, 5, 29],
    [0, 0, 2, 9, 5, 29],
    [0, 4, 1, 0, 0, 30],
    [0, 2, 2, 0, 0, 30],
    [0, 0, 3, 0, 0, 30],
    [0, 5, 0, 5, 1, 30],
    [0, 3, 1, 5, 1, 30],
    [0, 1, 2, 5, 1, 30],
    [0, 4, 0, 10, 2, 30],
    [0, 2, 1, 10, 2, 30],
    [0, 0, 2, 10, 2, 30],
    [0, 3, 0, 15, 3, 30],
    [0, 1, 1, 15, 3, 30],
    [0, 2, 0, 20, 4, 30],
    [0, 0, 1, 20, 4, 30],
    [0, 1, 0, 25, 5, 30],
    [0, 0, 3, 1, 1, 31],
    [0, 0, 2, 11, 3, 31],
    [0, 0, 1, 21, 5, 31],
    [0, 0, 3, 2, 2, 32],
    [0, 0, 2, 12, 4, 32],
    [0, 0, 3, 3, 3, 33],
    [0, 0, 2, 13, 5, 33],
    [0, 0, 3, 4, 4, 34],
    [0, 0, 3, 5, 1, 35],
    [0, 0, 2, 15, 3, 35],
    [0, 0, 1, 25, 5, 35],
  ],
  27: [
    [4, 3, 0, 0, 0, 27],
    [4, 1, 1, 0, 0, 27],
    [2, 4, 0, 1, 1, 27],
    [2, 2, 1, 1, 1, 27],
    [2, 0, 2, 1, 1, 27],
    [4, 2, 0, 5, 1, 27],
    [4, 0, 1, 5, 1, 27],
    [0, 5, 0, 2, 2, 27],
    [0, 3, 1, 2, 2, 27],
    [0, 1, 2, 2, 2, 27],
    [2, 3, 0, 6, 2, 27],
    [2, 1, 1, 6, 2, 27],
    [0, 4, 0, 7, 3, 27],
    [0, 2, 1, 7, 3, 27],
    [0, 0, 2, 7, 3, 27],
    [2, 2, 0, 11, 3, 27],
    [2, 0, 1, 11, 3, 27],
    [1, 4, 0, 4, 4, 27],
    [1, 2, 1, 4, 4, 27],
    [1, 0, 2, 4, 4, 27],
    [0, 3, 0, 12, 4, 27],
    [0, 1, 1, 12, 4, 27],
    [0, 2, 0, 17, 5, 27],
    [0, 0, 1, 17, 5, 27],
    [1, 5, 0, 0, 0, 28],
    [1, 3, 1, 0, 0, 28],
    [1, 1, 2, 0, 0, 28],
    [4, 3, 0, 1, 1, 28],
    [4, 1, 1, 1, 1, 28],
    [1, 4, 0, 5, 1, 28],
    [1, 2, 1, 5, 1, 28],
    [1, 0, 2, 5, 1, 28],
    [2, 4, 0, 2, 2, 28],
    [2, 2, 1, 2, 2, 28],
    [2, 0, 2, 2, 2, 28],
    [1, 3, 0, 10, 2, 28],
    [1, 1, 1, 10, 2, 28],
    [0, 5, 0, 3, 3, 28],
    [0, 3, 1, 3, 3, 28],
    [0, 1, 2, 3, 3, 28],
    [2, 3, 0, 7, 3, 28],
    [2, 1, 1, 7, 3, 28],
    [1, 2, 0, 15, 3, 28],
    [1, 0, 1, 15, 3, 28],
    [0, 4, 0, 8, 4, 28],
    [0, 2, 1, 8, 4, 28],
    [0, 0, 2, 8, 4, 28],
    [1, 1, 0, 20, 4, 28],
    [0, 3, 0, 13, 5, 28],
    [0, 1, 1, 13, 5, 28],
    [3, 4, 0, 0, 0, 29],
    [3, 2, 1, 0, 0, 29],
    [3, 0, 2, 0, 0, 29],
    [1, 5, 0, 1, 1, 29],
    [1, 3, 1, 1, 1, 29],
    [1, 1, 2, 1, 1, 29],
    [3, 3, 0, 5, 1, 29],
    [3, 1, 1, 5, 1, 29],
    [1, 4, 0, 6, 2, 29],
    [1, 2, 1, 6, 2, 29],
    [1, 0, 2, 6, 2, 29],
    [3, 2, 0, 10, 2, 29],
    [3, 0, 1, 10, 2, 29],
    [2, 4, 0, 3, 3, 29],
    [2, 2, 1, 3, 3, 29],
    [2, 0, 2, 3, 3, 29],
    [1, 3, 0, 11, 3, 29],
    [1, 1, 1, 11, 3, 29],
    [0, 5, 0, 4, 4, 29],
    [0, 3, 1, 4, 4, 29],
    [0, 1, 2, 4, 4, 29],
    [1, 2, 0, 16, 4, 29],
    [1, 0, 1, 16, 4, 29],
    [0, 4, 0, 9, 5, 29],
    [0, 2, 1, 9, 5, 29],
    [0, 0, 2, 9, 5, 29],
    [0, 4, 1, 0, 0, 30],
    [0, 2, 2, 0, 0, 30],
    [0, 0, 3, 0, 0, 30],
    [0, 5, 0, 5, 1, 30],
    [0, 3, 1, 5, 1, 30],
    [0, 1, 2, 5, 1, 30],
    [0, 4, 0, 10, 2, 30],
    [0, 2, 1, 10, 2, 30],
    [0, 0, 2, 10, 2, 30],
    [0, 3, 0, 15, 3, 30],
    [0, 1, 1, 15, 3, 30],
    [0, 2, 0, 20, 4, 30],
    [0, 0, 1, 20, 4, 30],
    [0, 1, 0, 25, 5, 30],
    [0, 4, 1, 1, 1, 31],
    [0, 2, 2, 1, 1, 31],
    [0, 0, 3, 1, 1, 31],
    [0, 5, 0, 6, 2, 31],
    [0, 3, 1, 6, 2, 31],
    [0, 1, 2, 6, 2, 31],
    [0, 4, 0, 11, 3, 31],
    [0, 2, 1, 11, 3, 31],
    [0, 0, 2, 11, 3, 31],
    [0, 3, 0, 16, 4, 31],
    [0, 1, 1, 16, 4, 31],
    [0, 2, 0, 21, 5, 31],
    [0, 0, 1, 21, 5, 31],
    [0, 0, 3, 2, 2, 32],
    [0, 0, 2, 12, 4, 32],
    [0, 0, 3, 3, 3, 33],
    [0, 0, 2, 13, 5, 33],
    [0, 0, 3, 4, 4, 34],
    [0, 0, 3, 5, 1, 35],
    [0, 0, 2, 15, 3, 35],
    [0, 0, 1, 25, 5, 35],
    [0, 0, 3, 6, 2, 36],
    [0, 0, 2, 16, 4, 36],
  ],
  28: [
    [1, 5, 0, 0, 0, 28],
    [1, 3, 1, 0, 0, 28],
    [1, 1, 2, 0, 0, 28],
    [4, 3, 0, 1, 1, 28],
    [4, 1, 1, 1, 1, 28],
    [1, 4, 0, 5, 1, 28],
    [1, 2, 1, 5, 1, 28],
    [1, 0, 2, 5, 1, 28],
    [2, 4, 0, 2, 2, 28],
    [2, 2, 1, 2, 2, 28],
    [2, 0, 2, 2, 2, 28],
    [1, 3, 0, 10, 2, 28],
    [1, 1, 1, 10, 2, 28],
    [0, 5, 0, 3, 3, 28],
    [0, 3, 1, 3, 3, 28],
    [0, 1, 2, 3, 3, 28],
    [2, 3, 0, 7, 3, 28],
    [2, 1, 1, 7, 3, 28],
    [1, 2, 0, 15, 3, 28],
    [1, 0, 1, 15, 3, 28],
    [0, 4, 0, 8, 4, 28],
    [0, 2, 1, 8, 4, 28],
    [0, 0, 2, 8, 4, 28],
    [1, 1, 0, 20, 4, 28],
    [0, 3, 0, 13, 5, 28],
    [0, 1, 1, 13, 5, 28],
    [3, 4, 0, 0, 0, 29],
    [3, 2, 1, 0, 0, 29],
    [3, 0, 2, 0, 0, 29],
    [1, 5, 0, 1, 1, 29],
    [1, 3, 1, 1, 1, 29],
    [1, 1, 2, 1, 1, 29],
    [3, 3, 0, 5, 1, 29],
    [3, 1, 1, 5, 1, 29],
    [1, 4, 0, 6, 2, 29],
    [1, 2, 1, 6, 2, 29],
    [1, 0, 2, 6, 2, 29],
    [3, 2, 0, 10, 2, 29],
    [3, 0, 1, 10, 2, 29],
    [2, 4, 0, 3, 3, 29],
    [2, 2, 1, 3, 3, 29],
    [2, 0, 2, 3, 3, 29],
    [1, 3, 0, 11, 3, 29],
    [1, 1, 1, 11, 3, 29],
    [0, 5, 0, 4, 4, 29],
    [0, 3, 1, 4, 4, 29],
    [0, 1, 2, 4, 4, 29],
    [1, 2, 0, 16, 4, 29],
    [1, 0, 1, 16, 4, 29],
    [0, 4, 0, 9, 5, 29],
    [0, 2, 1, 9, 5, 29],
    [0, 0, 2, 9, 5, 29],
    [5, 3, 0, 0, 0, 30],
    [5, 1, 1, 0, 0, 30],
    [0, 4, 1, 0, 0, 30],
    [0, 2, 2, 0, 0, 30],
    [0, 0, 3, 0, 0, 30],
    [3, 4, 0, 1, 1, 30],
    [3, 2, 1, 1, 1, 30],
    [3, 0, 2, 1, 1, 30],
    [0, 5, 0, 5, 1, 30],
    [0, 3, 1, 5, 1, 30],
    [0, 1, 2, 5, 1, 30],
    [1, 5, 0, 2, 2, 30],
    [1, 3, 1, 2, 2, 30],
    [1, 1, 2, 2, 2, 30],
    [3, 3, 0, 6, 2, 30],
    [3, 1, 1, 6, 2, 30],
    [0, 4, 0, 10, 2, 30],
    [0, 2, 1, 10, 2, 30],
    [0, 0, 2, 10, 2, 30],
    [1, 4, 0, 7, 3, 30],
    [1, 2, 1, 7, 3, 30],
    [1, 0, 2, 7, 3, 30],
    [0, 3, 0, 15, 3, 30],
    [0, 1, 1, 15, 3, 30],
    [1, 3, 0, 12, 4, 30],
    [1, 1, 1, 12, 4, 30],
    [0, 2, 0, 20, 4, 30],
    [0, 0, 1, 20, 4, 30],
    [0, 1, 0, 25, 5, 30],
    [0, 4, 1, 1, 1, 31],
    [0, 2, 2, 1, 1, 31],
    [0, 0, 3, 1, 1, 31],
    [0, 5, 0, 6, 2, 31],
    [0, 3, 1, 6, 2, 31],
    [0, 1, 2, 6, 2, 31],
    [0, 4, 0, 11, 3, 31],
    [0, 2, 1, 11, 3, 31],
    [0, 0, 2, 11, 3, 31],
    [0, 3, 0, 16, 4, 31],
    [0, 1, 1, 16, 4, 31],
    [0, 2, 0, 21, 5, 31],
    [0, 0, 1, 21, 5, 31],
    [0, 4, 1, 2, 2, 32],
    [0, 2, 2, 2, 2, 32],
    [0, 0, 3, 2, 2, 32],
    [0, 5, 0, 7, 3, 32],
    [0, 3, 1, 7, 3, 32],
    [0, 1, 2, 7, 3, 32],
    [0, 4, 0, 12, 4, 32],
    [0, 2, 1, 12, 4, 32],
    [0, 0, 2, 12, 4, 32],
    [0, 3, 0, 17, 5, 32],
    [0, 1, 1, 17, 5, 32],
    [0, 0, 3, 3, 3, 33],
    [0, 0, 2, 13, 5, 33],
    [0, 0, 3, 4, 4, 34],
    [0, 0, 3, 5, 1, 35],
    [0, 0, 2, 15, 3, 35],
    [0, 0, 1, 25, 5, 35],
    [0, 0, 3, 6, 2, 36],
    [0, 0, 2, 16, 4, 36],
    [0, 0, 3, 7, 3, 37],
    [0, 0, 2, 17, 5, 37],
  ],
  29: [
    [3, 4, 0, 0, 0, 29],
    [3, 2, 1, 0, 0, 29],
    [3, 0, 2, 0, 0, 29],
    [1, 5, 0, 1, 1, 29],
    [1, 3, 1, 1, 1, 29],
    [1, 1, 2, 1, 1, 29],
    [3, 3, 0, 5, 1, 29],
    [3, 1, 1, 5, 1, 29],
    [1, 4, 0, 6, 2, 29],
    [1, 2, 1, 6, 2, 29],
    [1, 0, 2, 6, 2, 29],
    [3, 2, 0, 10, 2, 29],
    [3, 0, 1, 10, 2, 29],
    [2, 4, 0, 3, 3, 29],
    [2, 2, 1, 3, 3, 29],
    [2, 0, 2, 3, 3, 29],
    [1, 3, 0, 11, 3, 29],
    [1, 1, 1, 11, 3, 29],
    [0, 5, 0, 4, 4, 29],
    [0, 3, 1, 4, 4, 29],
    [0, 1, 2, 4, 4, 29],
    [1, 2, 0, 16, 4, 29],
    [1, 0, 1, 16, 4, 29],
    [0, 4, 0, 9, 5, 29],
    [0, 2, 1, 9, 5, 29],
    [0, 0, 2, 9, 5, 29],
    [5, 3, 0, 0, 0, 30],
    [5, 1, 1, 0, 0, 30],
    [0, 4, 1, 0, 0, 30],
    [0, 2, 2, 0, 0, 30],
    [0, 0, 3, 0, 0, 30],
    [3, 4, 0, 1, 1, 30],
    [3, 2, 1, 1, 1, 30],
    [3, 0, 2, 1, 1, 30],
    [0, 5, 0, 5, 1, 30],
    [0, 3, 1, 5, 1, 30],
    [0, 1, 2, 5, 1, 30],
    [1, 5, 0, 2, 2, 30],
    [1, 3, 1, 2, 2, 30],
    [1, 1, 2, 2, 2, 30],
    [3, 3, 0, 6, 2, 30],
    [3, 1, 1, 6, 2, 30],
    [0, 4, 0, 10, 2, 30],
    [0, 2, 1, 10, 2, 30],
    [0, 0, 2, 10, 2, 30],
    [1, 4, 0, 7, 3, 30],
    [1, 2, 1, 7, 3, 30],
    [1, 0, 2, 7, 3, 30],
    [0, 3, 0, 15, 3, 30],
    [0, 1, 1, 15, 3, 30],
    [1, 3, 0, 12, 4, 30],
    [1, 1, 1, 12, 4, 30],
    [0, 2, 0, 20, 4, 30],
    [0, 0, 1, 20, 4, 30],
    [0, 1, 0, 25, 5, 30],
    [2, 5, 0, 0, 0, 31],
    [2, 3, 1, 0, 0, 31],
    [2, 1, 2, 0, 0, 31],
    [0, 4, 1, 1, 1, 31],
    [0, 2, 2, 1, 1, 31],
    [0, 0, 3, 1, 1, 31],
    [2, 4, 0, 5, 1, 31],
    [2, 2, 1, 5, 1, 31],
    [2, 0, 2, 5, 1, 31],
    [3, 4, 0, 2, 2, 31],
    [3, 2, 1, 2, 2, 31],
    [3, 0, 2, 2, 2, 31],
    [0, 5, 0, 6, 2, 31],
    [0, 3, 1, 6, 2, 31],
    [0, 1, 2, 6, 2, 31],
    [2, 3, 0, 10, 2, 31],
    [2, 1, 1, 10, 2, 31],
    [1, 5, 0, 3, 3, 31],
    [1, 3, 1, 3, 3, 31],
    [1, 1, 2, 3, 3, 31],
    [0, 4, 0, 11, 3, 31],
    [0, 2, 1, 11, 3, 31],
    [0, 0, 2, 11, 3, 31],
    [2, 2, 0, 15, 3, 31],
    [2, 0, 1, 15, 3, 31],
    [1, 4, 0, 8, 4, 31],
    [1, 2, 1, 8, 4, 31],
    [1, 0, 2, 8, 4, 31],
    [0, 3, 0, 16, 4, 31],
    [0, 1, 1, 16, 4, 31],
    [0, 2, 0, 21, 5, 31],
    [0, 0, 1, 21, 5, 31],
    [0, 4, 1, 2, 2, 32],
    [0, 2, 2, 2, 2, 32],
    [0, 0, 3, 2, 2, 32],
    [0, 5, 0, 7, 3, 32],
    [0, 3, 1, 7, 3, 32],
    [0, 1, 2, 7, 3, 32],
    [0, 4, 0, 12, 4, 32],
    [0, 2, 1, 12, 4, 32],
    [0, 0, 2, 12, 4, 32],
    [0, 3, 0, 17, 5, 32],
    [0, 1, 1, 17, 5, 32],
    [0, 4, 1, 3, 3, 33],
    [0, 2, 2, 3, 3, 33],
    [0, 0, 3, 3, 3, 33],
    [0, 5, 0, 8, 4, 33],
    [0, 3, 1, 8, 4, 33],
    [0, 1, 2, 8, 4, 33],
    [0, 4, 0, 13, 5, 33],
    [0, 2, 1, 13, 5, 33],
    [0, 0, 2, 13, 5, 33],
    [0, 0, 3, 4, 4, 34],
    [0, 0, 3, 5, 1, 35],
    [0, 0, 2, 15, 3, 35],
    [0, 0, 1, 25, 5, 35],
    [0, 0, 3, 6, 2, 36],
    [0, 0, 2, 16, 4, 36],
    [0, 0, 3, 7, 3, 37],
    [0, 0, 2, 17, 5, 37],
    [0, 0, 3, 8, 4, 38],
  ],
  30: [
    [5, 3, 0, 0, 0, 30],
    [5, 1, 1, 0, 0, 30],
    [0, 4, 1, 0, 0, 30],
    [0, 2, 2, 0, 0, 30],
    [0, 0, 3, 0, 0, 30],
    [3, 4, 0, 1, 1, 30],
    [3, 2, 1, 1, 1, 30],
    [3, 0, 2, 1, 1, 30],
    [0, 5, 0, 5, 1, 30],
    [0, 3, 1, 5, 1, 30],
    [0, 1, 2, 5, 1, 30],
    [1, 5, 0, 2, 2, 30],
    [1, 3, 1, 2, 2, 30],
    [1, 1, 2, 2, 2, 30],
    [3, 3, 0, 6, 2, 30],
    [3, 1, 1, 6, 2, 30],
    [0, 4, 0, 10, 2, 30],
    [0, 2, 1, 10, 2, 30],
    [0, 0, 2, 10, 2, 30],
    [1, 4, 0, 7, 3, 30],
    [1, 2, 1, 7, 3, 30],
    [1, 0, 2, 7, 3, 30],
    [0, 3, 0, 15, 3, 30],
    [0, 1, 1, 15, 3, 30],
    [1, 3, 0, 12, 4, 30],
    [1, 1, 1, 12, 4, 30],
    [0, 2, 0, 20, 4, 30],
    [0, 0, 1, 20, 4, 30],
    [0, 1, 0, 25, 5, 30],
    [2, 5, 0, 0, 0, 31],
    [2, 3, 1, 0, 0, 31],
    [2, 1, 2, 0, 0, 31],
    [0, 4, 1, 1, 1, 31],
    [0, 2, 2, 1, 1, 31],
    [0, 0, 3, 1, 1, 31],
    [2, 4, 0, 5, 1, 31],
    [2, 2, 1, 5, 1, 31],
    [2, 0, 2, 5, 1, 31],
    [3, 4, 0, 2, 2, 31],
    [3, 2, 1, 2, 2, 31],
    [3, 0, 2, 2, 2, 31],
    [0, 5, 0, 6, 2, 31],
    [0, 3, 1, 6, 2, 31],
    [0, 1, 2, 6, 2, 31],
    [2, 3, 0, 10, 2, 31],
    [2, 1, 1, 10, 2, 31],
    [1, 5, 0, 3, 3, 31],
    [1, 3, 1, 3, 3, 31],
    [1, 1, 2, 3, 3, 31],
    [0, 4, 0, 11, 3, 31],
    [0, 2, 1, 11, 3, 31],
    [0, 0, 2, 11, 3, 31],
    [2, 2, 0, 15, 3, 31],
    [2, 0, 1, 15, 3, 31],
    [1, 4, 0, 8, 4, 31],
    [1, 2, 1, 8, 4, 31],
    [1, 0, 2, 8, 4, 31],
    [0, 3, 0, 16, 4, 31],
    [0, 1, 1, 16, 4, 31],
    [0, 2, 0, 21, 5, 31],
    [0, 0, 1, 21, 5, 31],
    [4, 4, 0, 0, 0, 32],
    [4, 2, 1, 0, 0, 32],
    [4, 0, 2, 0, 0, 32],
    [2, 5, 0, 1, 1, 32],
    [2, 3, 1, 1, 1, 32],
    [2, 1, 2, 1, 1, 32],
    [4, 3, 0, 5, 1, 32],
    [4, 1, 1, 5, 1, 32],
    [0, 4, 1, 2, 2, 32],
    [0, 2, 2, 2, 2, 32],
    [0, 0, 3, 2, 2, 32],
    [2, 4, 0, 6, 2, 32],
    [2, 2, 1, 6, 2, 32],
    [2, 0, 2, 6, 2, 32],
    [0, 5, 0, 7, 3, 32],
    [0, 3, 1, 7, 3, 32],
    [0, 1, 2, 7, 3, 32],
    [2, 3, 0, 11, 3, 32],
    [2, 1, 1, 11, 3, 32],
    [1, 5, 0, 4, 4, 32],
    [1, 3, 1, 4, 4, 32],
    [1, 1, 2, 4, 4, 32],
    [0, 4, 0, 12, 4, 32],
    [0, 2, 1, 12, 4, 32],
    [0, 0, 2, 12, 4, 32],
    [0, 3, 0, 17, 5, 32],
    [0, 1, 1, 17, 5, 32],
    [0, 4, 1, 3, 3, 33],
    [0, 2, 2, 3, 3, 33],
    [0, 0, 3, 3, 3, 33],
    [0, 5, 0, 8, 4, 33],
    [0, 3, 1, 8, 4, 33],
    [0, 1, 2, 8, 4, 33],
    [0, 4, 0, 13, 5, 33],
    [0, 2, 1, 13, 5, 33],
    [0, 0, 2, 13, 5, 33],
    [0, 4, 1, 4, 4, 34],
    [0, 2, 2, 4, 4, 34],
    [0, 0, 3, 4, 4, 34],
    [0, 5, 0, 9, 5, 34],
    [0, 3, 1, 9, 5, 34],
    [0, 1, 2, 9, 5, 34],
    [0, 0, 3, 5, 1, 35],
    [0, 0, 2, 15, 3, 35],
    [0, 0, 1, 25, 5, 35],
    [0, 0, 3, 6, 2, 36],
    [0, 0, 2, 16, 4, 36],
    [0, 0, 3, 7, 3, 37],
    [0, 0, 2, 17, 5, 37],
    [0, 0, 3, 8, 4, 38],
    [0, 0, 3, 9, 5, 39],
  ],
  31: [
    [2, 5, 0, 0, 0, 31],
    [2, 3, 1, 0, 0, 31],
    [2, 1, 2, 0, 0, 31],
    [0, 4, 1, 1, 1, 31],
    [0, 2, 2, 1, 1, 31],
    [0, 0, 3, 1, 1, 31],
    [2, 4, 0, 5, 1, 31],
    [2, 2, 1, 5, 1, 31],
    [2, 0, 2, 5, 1, 31],
    [3, 4, 0, 2, 2, 31],
    [3, 2, 1, 2, 2, 31],
    [3, 0, 2, 2, 2, 31],
    [0, 5, 0, 6, 2, 31],
    [0, 3, 1, 6, 2, 31],
    [0, 1, 2, 6, 2, 31],
    [2, 3, 0, 10, 2, 31],
    [2, 1, 1, 10, 2, 31],
    [1, 5, 0, 3, 3, 31],
    [1, 3, 1, 3, 3, 31],
    [1, 1, 2, 3, 3, 31],
    [0, 4, 0, 11, 3, 31],
    [0, 2, 1, 11, 3, 31],
    [0, 0, 2, 11, 3, 31],
    [2, 2, 0, 15, 3, 31],
    [2, 0, 1, 15, 3, 31],
    [1, 4, 0, 8, 4, 31],
    [1, 2, 1, 8, 4, 31],
    [1, 0, 2, 8, 4, 31],
    [0, 3, 0, 16, 4, 31],
    [0, 1, 1, 16, 4, 31],
    [0, 2, 0, 21, 5, 31],
    [0, 0, 1, 21, 5, 31],
    [4, 4, 0, 0, 0, 32],
    [4, 2, 1, 0, 0, 32],
    [4, 0, 2, 0, 0, 32],
    [2, 5, 0, 1, 1, 32],
    [2, 3, 1, 1, 1, 32],
    [2, 1, 2, 1, 1, 32],
    [4, 3, 0, 5, 1, 32],
    [4, 1, 1, 5, 1, 32],
    [0, 4, 1, 2, 2, 32],
    [0, 2, 2, 2, 2, 32],
    [0, 0, 3, 2, 2, 32],
    [2, 4, 0, 6, 2, 32],
    [2, 2, 1, 6, 2, 32],
    [2, 0, 2, 6, 2, 32],
    [0, 5, 0, 7, 3, 32],
    [0, 3, 1, 7, 3, 32],
    [0, 1, 2, 7, 3, 32],
    [2, 3, 0, 11, 3, 32],
    [2, 1, 1, 11, 3, 32],
    [1, 5, 0, 4, 4, 32],
    [1, 3, 1, 4, 4, 32],
    [1, 1, 2, 4, 4, 32],
    [0, 4, 0, 12, 4, 32],
    [0, 2, 1, 12, 4, 32],
    [0, 0, 2, 12, 4, 32],
    [0, 3, 0, 17, 5, 32],
    [0, 1, 1, 17, 5, 32],
    [1, 4, 1, 0, 0, 33],
    [1, 2, 2, 0, 0, 33],
    [1, 0, 3, 0, 0, 33],
    [4, 4, 0, 1, 1, 33],
    [4, 2, 1, 1, 1, 33],
    [4, 0, 2, 1, 1, 33],
    [1, 5, 0, 5, 1, 33],
    [1, 3, 1, 5, 1, 33],
    [1, 1, 2, 5, 1, 33],
    [2, 5, 0, 2, 2, 33],
    [2, 3, 1, 2, 2, 33],
    [2, 1, 2, 2, 2, 33],
    [1, 4, 0, 10, 2, 33],
    [1, 2, 1, 10, 2, 33],
    [1, 0, 2, 10, 2, 33],
    [0, 4, 1, 3, 3, 33],
    [0, 2, 2, 3, 3, 33],
    [0, 0, 3, 3, 3, 33],
    [2, 4, 0, 7, 3, 33],
    [2, 2, 1, 7, 3, 33],
    [2, 0, 2, 7, 3, 33],
    [1, 3, 0, 15, 3, 33],
    [1, 1, 1, 15, 3, 33],
    [0, 5, 0, 8, 4, 33],
    [0, 3, 1, 8, 4, 33],
    [0, 1, 2, 8, 4, 33],
    [1, 2, 0, 20, 4, 33],
    [1, 0, 1, 20, 4, 33],
    [0, 4, 0, 13, 5, 33],
    [0, 2, 1, 13, 5, 33],
    [0, 0, 2, 13, 5, 33],
    [0, 4, 1, 4, 4, 34],
    [0, 2, 2, 4, 4, 34],
    [0, 0, 3, 4, 4, 34],
    [0, 5, 0, 9, 5, 34],
    [0, 3, 1, 9, 5, 34],
    [0, 1, 2, 9, 5, 34],
    [0, 3, 2, 0, 0, 35],
    [0, 1, 3, 0, 0, 35],
    [0, 4, 1, 5, 1, 35],
    [0, 2, 2, 5, 1, 35],
    [0, 0, 3, 5, 1, 35],
    [0, 5, 0, 10, 2, 35],
    [0, 3, 1, 10, 2, 35],
    [0, 1, 2, 10, 2, 35],
    [0, 4, 0, 15, 3, 35],
    [0, 2, 1, 15, 3, 35],
    [0, 0, 2, 15, 3, 35],
    [0, 3, 0, 20, 4, 35],
    [0, 1, 1, 20, 4, 35],
    [0, 2, 0, 25, 5, 35],
    [0, 0, 1, 25, 5, 35],
    [0, 0, 3, 6, 2, 36],
    [0, 0, 2, 16, 4, 36],
    [0, 0, 3, 7, 3, 37],
    [0, 0, 2, 17, 5, 37],
    [0, 0, 3, 8, 4, 38],
    [0, 0, 3, 9, 5, 39],
    [0, 0, 4, 0, 0, 40],
    [0, 0, 3, 10, 2, 40],
    [0, 0, 2, 20, 4, 40],
  ],
  32: [
    [4, 4, 0, 0, 0, 32],
    [4, 2, 1, 0, 0, 32],
    [4, 0, 2, 0, 0, 32],
    [2, 5, 0, 1, 1, 32],
    [2, 3, 1, 1, 1, 32],
    [2, 1, 2, 1, 1, 32],
    [4, 3, 0, 5, 1, 32],
    [4, 1, 1, 5, 1, 32],
    [0, 4, 1, 2, 2, 32],
    [0, 2, 2, 2, 2, 32],
    [0, 0, 3, 2, 2, 32],
    [2, 4, 0, 6, 2, 32],
    [2, 2, 1, 6, 2, 32],
    [2, 0, 2, 6, 2, 32],
    [0, 5, 0, 7, 3, 32],
    [0, 3, 1, 7, 3, 32],
    [0, 1, 2, 7, 3, 32],
    [2, 3, 0, 11, 3, 32],
    [2, 1, 1, 11, 3, 32],
    [1, 5, 0, 4, 4, 32],
    [1, 3, 1, 4, 4, 32],
    [1, 1, 2, 4, 4, 32],
    [0, 4, 0, 12, 4, 32],
    [0, 2, 1, 12, 4, 32],
    [0, 0, 2, 12, 4, 32],
    [0, 3, 0, 17, 5, 32],
    [0, 1, 1, 17, 5, 32],
    [1, 4, 1, 0, 0, 33],
    [1, 2, 2, 0, 0, 33],
    [1, 0, 3, 0, 0, 33],
    [4, 4, 0, 1, 1, 33],
    [4, 2, 1, 1, 1, 33],
    [4, 0, 2, 1, 1, 33],
    [1, 5, 0, 5, 1, 33],
    [1, 3, 1, 5, 1, 33],
    [1, 1, 2, 5, 1, 33],
    [2, 5, 0, 2, 2, 33],
    [2, 3, 1, 2, 2, 33],
    [2, 1, 2, 2, 2, 33],
    [1, 4, 0, 10, 2, 33],
    [1, 2, 1, 10, 2, 33],
    [1, 0, 2, 10, 2, 33],
    [0, 4, 1, 3, 3, 33],
    [0, 2, 2, 3, 3, 33],
    [0, 0, 3, 3, 3, 33],
    [2, 4, 0, 7, 3, 33],
    [2, 2, 1, 7, 3, 33],
    [2, 0, 2, 7, 3, 33],
    [1, 3, 0, 15, 3, 33],
    [1, 1, 1, 15, 3, 33],
    [0, 5, 0, 8, 4, 33],
    [0, 3, 1, 8, 4, 33],
    [0, 1, 2, 8, 4, 33],
    [1, 2, 0, 20, 4, 33],
    [1, 0, 1, 20, 4, 33],
    [0, 4, 0, 13, 5, 33],
    [0, 2, 1, 13, 5, 33],
    [0, 0, 2, 13, 5, 33],
    [3, 5, 0, 0, 0, 34],
    [3, 3, 1, 0, 0, 34],
    [3, 1, 2, 0, 0, 34],
    [1, 4, 1, 1, 1, 34],
    [1, 2, 2, 1, 1, 34],
    [1, 0, 3, 1, 1, 34],
    [3, 4, 0, 5, 1, 34],
    [3, 2, 1, 5, 1, 34],
    [3, 0, 2, 5, 1, 34],
    [1, 5, 0, 6, 2, 34],
    [1, 3, 1, 6, 2, 34],
    [1, 1, 2, 6, 2, 34],
    [3, 3, 0, 10, 2, 34],
    [3, 1, 1, 10, 2, 34],
    [2, 5, 0, 3, 3, 34],
    [2, 3, 1, 3, 3, 34],
    [2, 1, 2, 3, 3, 34],
    [1, 4, 0, 11, 3, 34],
    [1, 2, 1, 11, 3, 34],
    [1, 0, 2, 11, 3, 34],
    [0, 4, 1, 4, 4, 34],
    [0, 2, 2, 4, 4, 34],
    [0, 0, 3, 4, 4, 34],
    [1, 3, 0, 16, 4, 34],
    [1, 1, 1, 16, 4, 34],
    [0, 5, 0, 9, 5, 34],
    [0, 3, 1, 9, 5, 34],
    [0, 1, 2, 9, 5, 34],
    [0, 3, 2, 0, 0, 35],
    [0, 1, 3, 0, 0, 35],
    [0, 4, 1, 5, 1, 35],
    [0, 2, 2, 5, 1, 35],
    [0, 0, 3, 5, 1, 35],
    [0, 5, 0, 10, 2, 35],
    [0, 3, 1, 10, 2, 35],
    [0, 1, 2, 10, 2, 35],
    [0, 4, 0, 15, 3, 35],
    [0, 2, 1, 15, 3, 35],
    [0, 0, 2, 15, 3, 35],
    [0, 3, 0, 20, 4, 35],
    [0, 1, 1, 20, 4, 35],
    [0, 2, 0, 25, 5, 35],
    [0, 0, 1, 25, 5, 35],
    [0, 3, 2, 1, 1, 36],
    [0, 1, 3, 1, 1, 36],
    [0, 4, 1, 6, 2, 36],
    [0, 2, 2, 6, 2, 36],
    [0, 0, 3, 6, 2, 36],
    [0, 5, 0, 11, 3, 36],
    [0, 3, 1, 11, 3, 36],
    [0, 1, 2, 11, 3, 36],
    [0, 4, 0, 16, 4, 36],
    [0, 2, 1, 16, 4, 36],
    [0, 0, 2, 16, 4, 36],
    [0, 3, 0, 21, 5, 36],
    [0, 1, 1, 21, 5, 36],
    [0, 0, 3, 7, 3, 37],
    [0, 0, 2, 17, 5, 37],
    [0, 0, 3, 8, 4, 38],
    [0, 0, 3, 9, 5, 39],
    [0, 0, 4, 0, 0, 40],
    [0, 0, 3, 10, 2, 40],
    [0, 0, 2, 20, 4, 40],
    [0, 0, 4, 1, 1, 41],
    [0, 0, 3, 11, 3, 41],
    [0, 0, 2, 21, 5, 41],
  ],
  33: [
    [1, 4, 1, 0, 0, 33],
    [1, 2, 2, 0, 0, 33],
    [1, 0, 3, 0, 0, 33],
    [4, 4, 0, 1, 1, 33],
    [4, 2, 1, 1, 1, 33],
    [4, 0, 2, 1, 1, 33],
    [1, 5, 0, 5, 1, 33],
    [1, 3, 1, 5, 1, 33],
    [1, 1, 2, 5, 1, 33],
    [2, 5, 0, 2, 2, 33],
    [2, 3, 1, 2, 2, 33],
    [2, 1, 2, 2, 2, 33],
    [1, 4, 0, 10, 2, 33],
    [1, 2, 1, 10, 2, 33],
    [1, 0, 2, 10, 2, 33],
    [0, 4, 1, 3, 3, 33],
    [0, 2, 2, 3, 3, 33],
    [0, 0, 3, 3, 3, 33],
    [2, 4, 0, 7, 3, 33],
    [2, 2, 1, 7, 3, 33],
    [2, 0, 2, 7, 3, 33],
    [1, 3, 0, 15, 3, 33],
    [1, 1, 1, 15, 3, 33],
    [0, 5, 0, 8, 4, 33],
    [0, 3, 1, 8, 4, 33],
    [0, 1, 2, 8, 4, 33],
    [1, 2, 0, 20, 4, 33],
    [1, 0, 1, 20, 4, 33],
    [0, 4, 0, 13, 5, 33],
    [0, 2, 1, 13, 5, 33],
    [0, 0, 2, 13, 5, 33],
    [3, 5, 0, 0, 0, 34],
    [3, 3, 1, 0, 0, 34],
    [3, 1, 2, 0, 0, 34],
    [1, 4, 1, 1, 1, 34],
    [1, 2, 2, 1, 1, 34],
    [1, 0, 3, 1, 1, 34],
    [3, 4, 0, 5, 1, 34],
    [3, 2, 1, 5, 1, 34],
    [3, 0, 2, 5, 1, 34],
    [1, 5, 0, 6, 2, 34],
    [1, 3, 1, 6, 2, 34],
    [1, 1, 2, 6, 2, 34],
    [3, 3, 0, 10, 2, 34],
    [3, 1, 1, 10, 2, 34],
    [2, 5, 0, 3, 3, 34],
    [2, 3, 1, 3, 3, 34],
    [2, 1, 2, 3, 3, 34],
    [1, 4, 0, 11, 3, 34],
    [1, 2, 1, 11, 3, 34],
    [1, 0, 2, 11, 3, 34],
    [0, 4, 1, 4, 4, 34],
    [0, 2, 2, 4, 4, 34],
    [0, 0, 3, 4, 4, 34],
    [1, 3, 0, 16, 4, 34],
    [1, 1, 1, 16, 4, 34],
    [0, 5, 0, 9, 5, 34],
    [0, 3, 1, 9, 5, 34],
    [0, 1, 2, 9, 5, 34],
    [5, 4, 0, 0, 0, 35],
    [5, 2, 1, 0, 0, 35],
    [5, 0, 2, 0, 0, 35],
    [0, 3, 2, 0, 0, 35],
    [0, 1, 3, 0, 0, 35],
    [3, 5, 0, 1, 1, 35],
    [3, 3, 1, 1, 1, 35],
    [3, 1, 2, 1, 1, 35],
    [0, 4, 1, 5, 1, 35],
    [0, 2, 2, 5, 1, 35],
    [0, 0, 3, 5, 1, 35],
    [1, 4, 1, 2, 2, 35],
    [1, 2, 2, 2, 2, 35],
    [1, 0, 3, 2, 2, 35],
    [3, 4, 0, 6, 2, 35],
    [3, 2, 1, 6, 2, 35],
    [3, 0, 2, 6, 2, 35],
    [0, 5, 0, 10, 2, 35],
    [0, 3, 1, 10, 2, 35],
    [0, 1, 2, 10, 2, 35],
    [1, 5, 0, 7, 3, 35],
    [1, 3, 1, 7, 3, 35],
    [1, 1, 2, 7, 3, 35],
    [0, 4, 0, 15, 3, 35],
    [0, 2, 1, 15, 3, 35],
    [0, 0, 2, 15, 3, 35],
    [1, 4, 0, 12, 4, 35],
    [1, 2, 1, 12, 4, 35],
    [1, 0, 2, 12, 4, 35],
    [0, 3, 0, 20, 4, 35],
    [0, 1, 1, 20, 4, 35],
    [0, 2, 0, 25, 5, 35],
    [0, 0, 1, 25, 5, 35],
    [0, 3, 2, 1, 1, 36],
    [0, 1, 3, 1, 1, 36],
    [0, 4, 1, 6, 2, 36],
    [0, 2, 2, 6, 2, 36],
    [0, 0, 3, 6, 2, 36],
    [0, 5, 0, 11, 3, 36],
    [0, 3, 1, 11, 3, 36],
    [0, 1, 2, 11, 3, 36],
    [0, 4, 0, 16, 4, 36],
    [0, 2, 1, 16, 4, 36],
    [0, 0, 2, 16, 4, 36],
    [0, 3, 0, 21, 5, 36],
    [0, 1, 1, 21, 5, 36],
    [0, 3, 2, 2, 2, 37],
    [0, 1, 3, 2, 2, 37],
    [0, 4, 1, 7, 3, 37],
    [0, 2, 2, 7, 3, 37],
    [0, 0, 3, 7, 3, 37],
    [0, 5, 0, 12, 4, 37],
    [0, 3, 1, 12, 4, 37],
    [0, 1, 2, 12, 4, 37],
    [0, 4, 0, 17, 5, 37],
    [0, 2, 1, 17, 5, 37],
    [0, 0, 2, 17, 5, 37],
    [0, 0, 3, 8, 4, 38],
    [0, 0, 3, 9, 5, 39],
    [0, 0, 4, 0, 0, 40],
    [0, 0, 3, 10, 2, 40],
    [0, 0, 2, 20, 4, 40],
    [0, 0, 4, 1, 1, 41],
    [0, 0, 3, 11, 3, 41],
    [0, 0, 2, 21, 5, 41],
    [0, 0, 4, 2, 2, 42],
    [0, 0, 3, 12, 4, 42],
  ],
  34: [
    [3, 5, 0, 0, 0, 34],
    [3, 3, 1, 0, 0, 34],
    [3, 1, 2, 0, 0, 34],
    [1, 4, 1, 1, 1, 34],
    [1, 2, 2, 1, 1, 34],
    [1, 0, 3, 1, 1, 34],
    [3, 4, 0, 5, 1, 34],
    [3, 2, 1, 5, 1, 34],
    [3, 0, 2, 5, 1, 34],
    [1, 5, 0, 6, 2, 34],
    [1, 3, 1, 6, 2, 34],
    [1, 1, 2, 6, 2, 34],
    [3, 3, 0, 10, 2, 34],
    [3, 1, 1, 10, 2, 34],
    [2, 5, 0, 3, 3, 34],
    [2, 3, 1, 3, 3, 34],
    [2, 1, 2, 3, 3, 34],
    [1, 4, 0, 11, 3, 34],
    [1, 2, 1, 11, 3, 34],
    [1, 0, 2, 11, 3, 34],
    [0, 4, 1, 4, 4, 34],
    [0, 2, 2, 4, 4, 34],
    [0, 0, 3, 4, 4, 34],
    [1, 3, 0, 16, 4, 34],
    [1, 1, 1, 16, 4, 34],
    [0, 5, 0, 9, 5, 34],
    [0, 3, 1, 9, 5, 34],
    [0, 1, 2, 9, 5, 34],
    [5, 4, 0, 0, 0, 35],
    [5, 2, 1, 0, 0, 35],
    [5, 0, 2, 0, 0, 35],
    [0, 3, 2, 0, 0, 35],
    [0, 1, 3, 0, 0, 35],
    [3, 5, 0, 1, 1, 35],
    [3, 3, 1, 1, 1, 35],
    [3, 1, 2, 1, 1, 35],
    [0, 4, 1, 5, 1, 35],
    [0, 2, 2, 5, 1, 35],
    [0, 0, 3, 5, 1, 35],
    [1, 4, 1, 2, 2, 35],
    [1, 2, 2, 2, 2, 35],
    [1, 0, 3, 2, 2, 35],
    [3, 4, 0, 6, 2, 35],
    [3, 2, 1, 6, 2, 35],
    [3, 0, 2, 6, 2, 35],
    [0, 5, 0, 10, 2, 35],
    [0, 3, 1, 10, 2, 35],
    [0, 1, 2, 10, 2, 35],
    [1, 5, 0, 7, 3, 35],
    [1, 3, 1, 7, 3, 35],
    [1, 1, 2, 7, 3, 35],
    [0, 4, 0, 15, 3, 35],
    [0, 2, 1, 15, 3, 35],
    [0, 0, 2, 15, 3, 35],
    [1, 4, 0, 12, 4, 35],
    [1, 2, 1, 12, 4, 35],
    [1, 0, 2, 12, 4, 35],
    [0, 3, 0, 20, 4, 35],
    [0, 1, 1, 20, 4, 35],
    [0, 2, 0, 25, 5, 35],
    [0, 0, 1, 25, 5, 35],
    [2, 4, 1, 0, 0, 36],
    [2, 2, 2, 0, 0, 36],
    [2, 0, 3, 0, 0, 36],
    [0, 3, 2, 1, 1, 36],
    [0, 1, 3, 1, 1, 36],
    [2, 5, 0, 5, 1, 36],
    [2, 3, 1, 5, 1, 36],
    [2, 1, 2, 5, 1, 36],
    [3, 5, 0, 2, 2, 36],
    [3, 3, 1, 2, 2, 36],
    [3, 1, 2, 2, 2, 36],
    [0, 4, 1, 6, 2, 36],
    [0, 2, 2, 6, 2, 36],
    [0, 0, 3, 6, 2, 36],
    [2, 4, 0, 10, 2, 36],
    [2, 2, 1, 10, 2, 36],
    [2, 0, 2, 10, 2, 36],
    [1, 4, 1, 3, 3, 36],
    [1, 2, 2, 3, 3, 36],
    [1, 0, 3, 3, 3, 36],
    [0, 5, 0, 11, 3, 36],
    [0, 3, 1, 11, 3, 36],
    [0, 1, 2, 11, 3, 36],
    [2, 3, 0, 15, 3, 36],
    [2, 1, 1, 15, 3, 36],
    [1, 5, 0, 8, 4, 36],
    [1, 3, 1, 8, 4, 36],
    [1, 1, 2, 8, 4, 36],
    [0, 4, 0, 16, 4, 36],
    [0, 2, 1, 16, 4, 36],
    [0, 0, 2, 16, 4, 36],
    [0, 3, 0, 21, 5, 36],
    [0, 1, 1, 21, 5, 36],
    [0, 3, 2, 2, 2, 37],
    [0, 1, 3, 2, 2, 37],
    [0, 4, 1, 7, 3, 37],
    [0, 2, 2, 7, 3, 37],
    [0, 0, 3, 7, 3, 37],
    [0, 5, 0, 12, 4, 37],
    [0, 3, 1, 12, 4, 37],
    [0, 1, 2, 12, 4, 37],
    [0, 4, 0, 17, 5, 37],
    [0, 2, 1, 17, 5, 37],
    [0, 0, 2, 17, 5, 37],
    [0, 3, 2, 3, 3, 38],
    [0, 1, 3, 3, 3, 38],
    [0, 4, 1, 8, 4, 38],
    [0, 2, 2, 8, 4, 38],
    [0, 0, 3, 8, 4, 38],
    [0, 5, 0, 13, 5, 38],
    [0, 3, 1, 13, 5, 38],
    [0, 1, 2, 13, 5, 38],
    [0, 0, 3, 9, 5, 39],
    [0, 0, 4, 0, 0, 40],
    [0, 0, 3, 10, 2, 40],
    [0, 0, 2, 20, 4, 40],
    [0, 0, 4, 1, 1, 41],
    [0, 0, 3, 11, 3, 41],
    [0, 0, 2, 21, 5, 41],
    [0, 0, 4, 2, 2, 42],
    [0, 0, 3, 12, 4, 42],
    [0, 0, 4, 3, 3, 43],
    [0, 0, 3, 13, 5, 43],
  ],
  35: [
    [5, 4, 0, 0, 0, 35],
    [5, 2, 1, 0, 0, 35],
    [5, 0, 2, 0, 0, 35],
    [0, 3, 2, 0, 0, 35],
    [0, 1, 3, 0, 0, 35],
    [3, 5, 0, 1, 1, 35],
    [3, 3, 1, 1, 1, 35],
    [3, 1, 2, 1, 1, 35],
    [0, 4, 1, 5, 1, 35],
    [0, 2, 2, 5, 1, 35],
    [0, 0, 3, 5, 1, 35],
    [1, 4, 1, 2, 2, 35],
    [1, 2, 2, 2, 2, 35],
    [1, 0, 3, 2, 2, 35],
    [3, 4, 0, 6, 2, 35],
    [3, 2, 1, 6, 2, 35],
    [3, 0, 2, 6, 2, 35],
    [0, 5, 0, 10, 2, 35],
    [0, 3, 1, 10, 2, 35],
    [0, 1, 2, 10, 2, 35],
    [1, 5, 0, 7, 3, 35],
    [1, 3, 1, 7, 3, 35],
    [1, 1, 2, 7, 3, 35],
    [0, 4, 0, 15, 3, 35],
    [0, 2, 1, 15, 3, 35],
    [0, 0, 2, 15, 3, 35],
    [1, 4, 0, 12, 4, 35],
    [1, 2, 1, 12, 4, 35],
    [1, 0, 2, 12, 4, 35],
    [0, 3, 0, 20, 4, 35],
    [0, 1, 1, 20, 4, 35],
    [0, 2, 0, 25, 5, 35],
    [0, 0, 1, 25, 5, 35],
    [2, 4, 1, 0, 0, 36],
    [2, 2, 2, 0, 0, 36],
    [2, 0, 3, 0, 0, 36],
    [0, 3, 2, 1, 1, 36],
    [0, 1, 3, 1, 1, 36],
    [2, 5, 0, 5, 1, 36],
    [2, 3, 1, 5, 1, 36],
    [2, 1, 2, 5, 1, 36],
    [3, 5, 0, 2, 2, 36],
    [3, 3, 1, 2, 2, 36],
    [3, 1, 2, 2, 2, 36],
    [0, 4, 1, 6, 2, 36],
    [0, 2, 2, 6, 2, 36],
    [0, 0, 3, 6, 2, 36],
    [2, 4, 0, 10, 2, 36],
    [2, 2, 1, 10, 2, 36],
    [2, 0, 2, 10, 2, 36],
    [1, 4, 1, 3, 3, 36],
    [1, 2, 2, 3, 3, 36],
    [1, 0, 3, 3, 3, 36],
    [0, 5, 0, 11, 3, 36],
    [0, 3, 1, 11, 3, 36],
    [0, 1, 2, 11, 3, 36],
    [2, 3, 0, 15, 3, 36],
    [2, 1, 1, 15, 3, 36],
    [1, 5, 0, 8, 4, 36],
    [1, 3, 1, 8, 4, 36],
    [1, 1, 2, 8, 4, 36],
    [0, 4, 0, 16, 4, 36],
    [0, 2, 1, 16, 4, 36],
    [0, 0, 2, 16, 4, 36],
    [0, 3, 0, 21, 5, 36],
    [0, 1, 1, 21, 5, 36],
    [4, 5, 0, 0, 0, 37],
    [4, 3, 1, 0, 0, 37],
    [4, 1, 2, 0, 0, 37],
    [2, 4, 1, 1, 1, 37],
    [2, 2, 2, 1, 1, 37],
    [2, 0, 3, 1, 1, 37],
    [4, 4, 0, 5, 1, 37],
    [4, 2, 1, 5, 1, 37],
    [4, 0, 2, 5, 1, 37],
    [0, 3, 2, 2, 2, 37],
    [0, 1, 3, 2, 2, 37],
    [2, 5, 0, 6, 2, 37],
    [2, 3, 1, 6, 2, 37],
    [2, 1, 2, 6, 2, 37],
    [0, 4, 1, 7, 3, 37],
    [0, 2, 2, 7, 3, 37],
    [0, 0, 3, 7, 3, 37],
    [2, 4, 0, 11, 3, 37],
    [2, 2, 1, 11, 3, 37],
    [2, 0, 2, 11, 3, 37],
    [1, 4, 1, 4, 4, 37],
    [1, 2, 2, 4, 4, 37],
    [1, 0, 3, 4, 4, 37],
    [0, 5, 0, 12, 4, 37],
    [0, 3, 1, 12, 4, 37],
    [0, 1, 2, 12, 4, 37],
    [0, 4, 0, 17, 5, 37],
    [0, 2, 1, 17, 5, 37],
    [0, 0, 2, 17, 5, 37],
    [0, 3, 2, 3, 3, 38],
    [0, 1, 3, 3, 3, 38],
    [0, 4, 1, 8, 4, 38],
    [0, 2, 2, 8, 4, 38],
    [0, 0, 3, 8, 4, 38],
    [0, 5, 0, 13, 5, 38],
    [0, 3, 1, 13, 5, 38],
    [0, 1, 2, 13, 5, 38],
    [0, 3, 2, 4, 4, 39],
    [0, 1, 3, 4, 4, 39],
    [0, 4, 1, 9, 5, 39],
    [0, 2, 2, 9, 5, 39],
    [0, 0, 3, 9, 5, 39],
    [0, 0, 4, 0, 0, 40],
    [0, 0, 3, 10, 2, 40],
    [0, 0, 2, 20, 4, 40],
    [0, 0, 4, 1, 1, 41],
    [0, 0, 3, 11, 3, 41],
    [0, 0, 2, 21, 5, 41],
    [0, 0, 4, 2, 2, 42],
    [0, 0, 3, 12, 4, 42],
    [0, 0, 4, 3, 3, 43],
    [0, 0, 3, 13, 5, 43],
    [0, 0, 4, 4, 4, 44],
  ],
  36: [
    [2, 4, 1, 0, 0, 36],
    [2, 2, 2, 0, 0, 36],
    [2, 0, 3, 0, 0, 36],
    [0, 3, 2, 1, 1, 36],
    [0, 1, 3, 1, 1, 36],
    [2, 5, 0, 5, 1, 36],
    [2, 3, 1, 5, 1, 36],
    [2, 1, 2, 5, 1, 36],
    [3, 5, 0, 2, 2, 36],
    [3, 3, 1, 2, 2, 36],
    [3, 1, 2, 2, 2, 36],
    [0, 4, 1, 6, 2, 36],
    [0, 2, 2, 6, 2, 36],
    [0, 0, 3, 6, 2, 36],
    [2, 4, 0, 10, 2, 36],
    [2, 2, 1, 10, 2, 36],
    [2, 0, 2, 10, 2, 36],
    [1, 4, 1, 3, 3, 36],
    [1, 2, 2, 3, 3, 36],
    [1, 0, 3, 3, 3, 36],
    [0, 5, 0, 11, 3, 36],
    [0, 3, 1, 11, 3, 36],
    [0, 1, 2, 11, 3, 36],
    [2, 3, 0, 15, 3, 36],
    [2, 1, 1, 15, 3, 36],
    [1, 5, 0, 8, 4, 36],
    [1, 3, 1, 8, 4, 36],
    [1, 1, 2, 8, 4, 36],
    [0, 4, 0, 16, 4, 36],
    [0, 2, 1, 16, 4, 36],
    [0, 0, 2, 16, 4, 36],
    [0, 3, 0, 21, 5, 36],
    [0, 1, 1, 21, 5, 36],
    [4, 5, 0, 0, 0, 37],
    [4, 3, 1, 0, 0, 37],
    [4, 1, 2, 0, 0, 37],
    [2, 4, 1, 1, 1, 37],
    [2, 2, 2, 1, 1, 37],
    [2, 0, 3, 1, 1, 37],
    [4, 4, 0, 5, 1, 37],
    [4, 2, 1, 5, 1, 37],
    [4, 0, 2, 5, 1, 37],
    [0, 3, 2, 2, 2, 37],
    [0, 1, 3, 2, 2, 37],
    [2, 5, 0, 6, 2, 37],
    [2, 3, 1, 6, 2, 37],
    [2, 1, 2, 6, 2, 37],
    [0, 4, 1, 7, 3, 37],
    [0, 2, 2, 7, 3, 37],
    [0, 0, 3, 7, 3, 37],
    [2, 4, 0, 11, 3, 37],
    [2, 2, 1, 11, 3, 37],
    [2, 0, 2, 11, 3, 37],
    [1, 4, 1, 4, 4, 37],
    [1, 2, 2, 4, 4, 37],
    [1, 0, 3, 4, 4, 37],
    [0, 5, 0, 12, 4, 37],
    [0, 3, 1, 12, 4, 37],
    [0, 1, 2, 12, 4, 37],
    [0, 4, 0, 17, 5, 37],
    [0, 2, 1, 17, 5, 37],
    [0, 0, 2, 17, 5, 37],
    [1, 3, 2, 0, 0, 38],
    [1, 1, 3, 0, 0, 38],
    [4, 5, 0, 1, 1, 38],
    [4, 3, 1, 1, 1, 38],
    [4, 1, 2, 1, 1, 38],
    [1, 4, 1, 5, 1, 38],
    [1, 2, 2, 5, 1, 38],
    [1, 0, 3, 5, 1, 38],
    [2, 4, 1, 2, 2, 38],
    [2, 2, 2, 2, 2, 38],
    [2, 0, 3, 2, 2, 38],
    [1, 5, 0, 10, 2, 38],
    [1, 3, 1, 10, 2, 38],
    [1, 1, 2, 10, 2, 38],
    [0, 3, 2, 3, 3, 38],
    [0, 1, 3, 3, 3, 38],
    [2, 5, 0, 7, 3, 38],
    [2, 3, 1, 7, 3, 38],
    [2, 1, 2, 7, 3, 38],
    [1, 4, 0, 15, 3, 38],
    [1, 2, 1, 15, 3, 38],
    [1, 0, 2, 15, 3, 38],
    [0, 4, 1, 8, 4, 38],
    [0, 2, 2, 8, 4, 38],
    [0, 0, 3, 8, 4, 38],
    [1, 3, 0, 20, 4, 38],
    [1, 1, 1, 20, 4, 38],
    [0, 5, 0, 13, 5, 38],
    [0, 3, 1, 13, 5, 38],
    [0, 1, 2, 13, 5, 38],
    [0, 3, 2, 4, 4, 39],
    [0, 1, 3, 4, 4, 39],
    [0, 4, 1, 9, 5, 39],
    [0, 2, 2, 9, 5, 39],
    [0, 0, 3, 9, 5, 39],
    [0, 2, 3, 0, 0, 40],
    [0, 0, 4, 0, 0, 40],
    [0, 3, 2, 5, 1, 40],
    [0, 1, 3, 5, 1, 40],
    [0, 4, 1, 10, 2, 40],
    [0, 2, 2, 10, 2, 40],
    [0, 0, 3, 10, 2, 40],
    [0, 5, 0, 15, 3, 40],
    [0, 3, 1, 15, 3, 40],
    [0, 1, 2, 15, 3, 40],
    [0, 4, 0, 20, 4, 40],
    [0, 2, 1, 20, 4, 40],
    [0, 0, 2, 20, 4, 40],
    [0, 3, 0, 25, 5, 40],
    [0, 1, 1, 25, 5, 40],
    [0, 0, 4, 1, 1, 41],
    [0, 0, 3, 11, 3, 41],
    [0, 0, 2, 21, 5, 41],
    [0, 0, 4, 2, 2, 42],
    [0, 0, 3, 12, 4, 42],
    [0, 0, 4, 3, 3, 43],
    [0, 0, 3, 13, 5, 43],
    [0, 0, 4, 4, 4, 44],
    [0, 0, 4, 5, 1, 45],
    [0, 0, 3, 15, 3, 45],
    [0, 0, 2, 25, 5, 45],
  ],
  37: [
    [4, 5, 0, 0, 0, 37],
    [4, 3, 1, 0, 0, 37],
    [4, 1, 2, 0, 0, 37],
    [2, 4, 1, 1, 1, 37],
    [2, 2, 2, 1, 1, 37],
    [2, 0, 3, 1, 1, 37],
    [4, 4, 0, 5, 1, 37],
    [4, 2, 1, 5, 1, 37],
    [4, 0, 2, 5, 1, 37],
    [0, 3, 2, 2, 2, 37],
    [0, 1, 3, 2, 2, 37],
    [2, 5, 0, 6, 2, 37],
    [2, 3, 1, 6, 2, 37],
    [2, 1, 2, 6, 2, 37],
    [0, 4, 1, 7, 3, 37],
    [0, 2, 2, 7, 3, 37],
    [0, 0, 3, 7, 3, 37],
    [2, 4, 0, 11, 3, 37],
    [2, 2, 1, 11, 3, 37],
    [2, 0, 2, 11, 3, 37],
    [1, 4, 1, 4, 4, 37],
    [1, 2, 2, 4, 4, 37],
    [1, 0, 3, 4, 4, 37],
    [0, 5, 0, 12, 4, 37],
    [0, 3, 1, 12, 4, 37],
    [0, 1, 2, 12, 4, 37],
    [0, 4, 0, 17, 5, 37],
    [0, 2, 1, 17, 5, 37],
    [0, 0, 2, 17, 5, 37],
    [1, 3, 2, 0, 0, 38],
    [1, 1, 3, 0, 0, 38],
    [4, 5, 0, 1, 1, 38],
    [4, 3, 1, 1, 1, 38],
    [4, 1, 2, 1, 1, 38],
    [1, 4, 1, 5, 1, 38],
    [1, 2, 2, 5, 1, 38],
    [1, 0, 3, 5, 1, 38],
    [2, 4, 1, 2, 2, 38],
    [2, 2, 2, 2, 2, 38],
    [2, 0, 3, 2, 2, 38],
    [1, 5, 0, 10, 2, 38],
    [1, 3, 1, 10, 2, 38],
    [1, 1, 2, 10, 2, 38],
    [0, 3, 2, 3, 3, 38],
    [0, 1, 3, 3, 3, 38],
    [2, 5, 0, 7, 3, 38],
    [2, 3, 1, 7, 3, 38],
    [2, 1, 2, 7, 3, 38],
    [1, 4, 0, 15, 3, 38],
    [1, 2, 1, 15, 3, 38],
    [1, 0, 2, 15, 3, 38],
    [0, 4, 1, 8, 4, 38],
    [0, 2, 2, 8, 4, 38],
    [0, 0, 3, 8, 4, 38],
    [1, 3, 0, 20, 4, 38],
    [1, 1, 1, 20, 4, 38],
    [0, 5, 0, 13, 5, 38],
    [0, 3, 1, 13, 5, 38],
    [0, 1, 2, 13, 5, 38],
    [3, 4, 1, 0, 0, 39],
    [3, 2, 2, 0, 0, 39],
    [3, 0, 3, 0, 0, 39],
    [1, 3, 2, 1, 1, 39],
    [1, 1, 3, 1, 1, 39],
    [3, 5, 0, 5, 1, 39],
    [3, 3, 1, 5, 1, 39],
    [3, 1, 2, 5, 1, 39],
    [1, 4, 1, 6, 2, 39],
    [1, 2, 2, 6, 2, 39],
    [1, 0, 3, 6, 2, 39],
    [3, 4, 0, 10, 2, 39],
    [3, 2, 1, 10, 2, 39],
    [3, 0, 2, 10, 2, 39],
    [2, 4, 1, 3, 3, 39],
    [2, 2, 2, 3, 3, 39],
    [2, 0, 3, 3, 3, 39],
    [1, 5, 0, 11, 3, 39],
    [1, 3, 1, 11, 3, 39],
    [1, 1, 2, 11, 3, 39],
    [0, 3, 2, 4, 4, 39],
    [0, 1, 3, 4, 4, 39],
    [1, 4, 0, 16, 4, 39],
    [1, 2, 1, 16, 4, 39],
    [1, 0, 2, 16, 4, 39],
    [0, 4, 1, 9, 5, 39],
    [0, 2, 2, 9, 5, 39],
    [0, 0, 3, 9, 5, 39],
    [0, 2, 3, 0, 0, 40],
    [0, 0, 4, 0, 0, 40],
    [0, 3, 2, 5, 1, 40],
    [0, 1, 3, 5, 1, 40],
    [0, 4, 1, 10, 2, 40],
    [0, 2, 2, 10, 2, 40],
    [0, 0, 3, 10, 2, 40],
    [0, 5, 0, 15, 3, 40],
    [0, 3, 1, 15, 3, 40],
    [0, 1, 2, 15, 3, 40],
    [0, 4, 0, 20, 4, 40],
    [0, 2, 1, 20, 4, 40],
    [0, 0, 2, 20, 4, 40],
    [0, 3, 0, 25, 5, 40],
    [0, 1, 1, 25, 5, 40],
    [0, 2, 3, 1, 1, 41],
    [0, 0, 4, 1, 1, 41],
    [0, 3, 2, 6, 2, 41],
    [0, 1, 3, 6, 2, 41],
    [0, 4, 1, 11, 3, 41],
    [0, 2, 2, 11, 3, 41],
    [0, 0, 3, 11, 3, 41],
    [0, 5, 0, 16, 4, 41],
    [0, 3, 1, 16, 4, 41],
    [0, 1, 2, 16, 4, 41],
    [0, 4, 0, 21, 5, 41],
    [0, 2, 1, 21, 5, 41],
    [0, 0, 2, 21, 5, 41],
    [0, 0, 4, 2, 2, 42],
    [0, 0, 3, 12, 4, 42],
    [0, 0, 4, 3, 3, 43],
    [0, 0, 3, 13, 5, 43],
    [0, 0, 4, 4, 4, 44],
    [0, 0, 4, 5, 1, 45],
    [0, 0, 3, 15, 3, 45],
    [0, 0, 2, 25, 5, 45],
    [0, 0, 4, 6, 2, 46],
    [0, 0, 3, 16, 4, 46],
  ],
  38: [
    [1, 3, 2, 0, 0, 38],
    [1, 1, 3, 0, 0, 38],
    [4, 5, 0, 1, 1, 38],
    [4, 3, 1, 1, 1, 38],
    [4, 1, 2, 1, 1, 38],
    [1, 4, 1, 5, 1, 38],
    [1, 2, 2, 5, 1, 38],
    [1, 0, 3, 5, 1, 38],
    [2, 4, 1, 2, 2, 38],
    [2, 2, 2, 2, 2, 38],
    [2, 0, 3, 2, 2, 38],
    [1, 5, 0, 10, 2, 38],
    [1, 3, 1, 10, 2, 38],
    [1, 1, 2, 10, 2, 38],
    [0, 3, 2, 3, 3, 38],
    [0, 1, 3, 3, 3, 38],
    [2, 5, 0, 7, 3, 38],
    [2, 3, 1, 7, 3, 38],
    [2, 1, 2, 7, 3, 38],
    [1, 4, 0, 15, 3, 38],
    [1, 2, 1, 15, 3, 38],
    [1, 0, 2, 15, 3, 38],
    [0, 4, 1, 8, 4, 38],
    [0, 2, 2, 8, 4, 38],
    [0, 0, 3, 8, 4, 38],
    [1, 3, 0, 20, 4, 38],
    [1, 1, 1, 20, 4, 38],
    [0, 5, 0, 13, 5, 38],
    [0, 3, 1, 13, 5, 38],
    [0, 1, 2, 13, 5, 38],
    [3, 4, 1, 0, 0, 39],
    [3, 2, 2, 0, 0, 39],
    [3, 0, 3, 0, 0, 39],
    [1, 3, 2, 1, 1, 39],
    [1, 1, 3, 1, 1, 39],
    [3, 5, 0, 5, 1, 39],
    [3, 3, 1, 5, 1, 39],
    [3, 1, 2, 5, 1, 39],
    [1, 4, 1, 6, 2, 39],
    [1, 2, 2, 6, 2, 39],
    [1, 0, 3, 6, 2, 39],
    [3, 4, 0, 10, 2, 39],
    [3, 2, 1, 10, 2, 39],
    [3, 0, 2, 10, 2, 39],
    [2, 4, 1, 3, 3, 39],
    [2, 2, 2, 3, 3, 39],
    [2, 0, 3, 3, 3, 39],
    [1, 5, 0, 11, 3, 39],
    [1, 3, 1, 11, 3, 39],
    [1, 1, 2, 11, 3, 39],
    [0, 3, 2, 4, 4, 39],
    [0, 1, 3, 4, 4, 39],
    [1, 4, 0, 16, 4, 39],
    [1, 2, 1, 16, 4, 39],
    [1, 0, 2, 16, 4, 39],
    [0, 4, 1, 9, 5, 39],
    [0, 2, 2, 9, 5, 39],
    [0, 0, 3, 9, 5, 39],
    [5, 5, 0, 0, 0, 40],
    [5, 3, 1, 0, 0, 40],
    [5, 1, 2, 0, 0, 40],
    [0, 2, 3, 0, 0, 40],
    [0, 0, 4, 0, 0, 40],
    [3, 4, 1, 1, 1, 40],
    [3, 2, 2, 1, 1, 40],
    [3, 0, 3, 1, 1, 40],
    [0, 3, 2, 5, 1, 40],
    [0, 1, 3, 5, 1, 40],
    [1, 3, 2, 2, 2, 40],
    [1, 1, 3, 2, 2, 40],
    [3, 5, 0, 6, 2, 40],
    [3, 3, 1, 6, 2, 40],
    [3, 1, 2, 6, 2, 40],
    [0, 4, 1, 10, 2, 40],
    [0, 2, 2, 10, 2, 40],
    [0, 0, 3, 10, 2, 40],
    [1, 4, 1, 7, 3, 40],
    [1, 2, 2, 7, 3, 40],
    [1, 0, 3, 7, 3, 40],
    [0, 5, 0, 15, 3, 40],
    [0, 3, 1, 15, 3, 40],
    [0, 1, 2, 15, 3, 40],
    [1, 5, 0, 12, 4, 40],
    [1, 3, 1, 12, 4, 40],
    [1, 1, 2, 12, 4, 40],
    [0, 4, 0, 20, 4, 40],
    [0, 2, 1, 20, 4, 40],
    [0, 0, 2, 20, 4, 40],
    [0, 3, 0, 25, 5, 40],
    [0, 1, 1, 25, 5, 40],
    [0, 2, 3, 1, 1, 41],
    [0, 0, 4, 1, 1, 41],
    [0, 3, 2, 6, 2, 41],
    [0, 1, 3, 6, 2, 41],
    [0, 4, 1, 11, 3, 41],
    [0, 2, 2, 11, 3, 41],
    [0, 0, 3, 11, 3, 41],
    [0, 5, 0, 16, 4, 41],
    [0, 3, 1, 16, 4, 41],
    [0, 1, 2, 16, 4, 41],
    [0, 4, 0, 21, 5, 41],
    [0, 2, 1, 21, 5, 41],
    [0, 0, 2, 21, 5, 41],
    [0, 2, 3, 2, 2, 42],
    [0, 0, 4, 2, 2, 42],
    [0, 3, 2, 7, 3, 42],
    [0, 1, 3, 7, 3, 42],
    [0, 4, 1, 12, 4, 42],
    [0, 2, 2, 12, 4, 42],
    [0, 0, 3, 12, 4, 42],
    [0, 5, 0, 17, 5, 42],
    [0, 3, 1, 17, 5, 42],
    [0, 1, 2, 17, 5, 42],
    [0, 0, 4, 3, 3, 43],
    [0, 0, 3, 13, 5, 43],
    [0, 0, 4, 4, 4, 44],
    [0, 0, 4, 5, 1, 45],
    [0, 0, 3, 15, 3, 45],
    [0, 0, 2, 25, 5, 45],
    [0, 0, 4, 6, 2, 46],
    [0, 0, 3, 16, 4, 46],
    [0, 0, 4, 7, 3, 47],
    [0, 0, 3, 17, 5, 47],
  ],
  39: [
    [3, 4, 1, 0, 0, 39],
    [3, 2, 2, 0, 0, 39],
    [3, 0, 3, 0, 0, 39],
    [1, 3, 2, 1, 1, 39],
    [1, 1, 3, 1, 1, 39],
    [3, 5, 0, 5, 1, 39],
    [3, 3, 1, 5, 1, 39],
    [3, 1, 2, 5, 1, 39],
    [1, 4, 1, 6, 2, 39],
    [1, 2, 2, 6, 2, 39],
    [1, 0, 3, 6, 2, 39],
    [3, 4, 0, 10, 2, 39],
    [3, 2, 1, 10, 2, 39],
    [3, 0, 2, 10, 2, 39],
    [2, 4, 1, 3, 3, 39],
    [2, 2, 2, 3, 3, 39],
    [2, 0, 3, 3, 3, 39],
    [1, 5, 0, 11, 3, 39],
    [1, 3, 1, 11, 3, 39],
    [1, 1, 2, 11, 3, 39],
    [0, 3, 2, 4, 4, 39],
    [0, 1, 3, 4, 4, 39],
    [1, 4, 0, 16, 4, 39],
    [1, 2, 1, 16, 4, 39],
    [1, 0, 2, 16, 4, 39],
    [0, 4, 1, 9, 5, 39],
    [0, 2, 2, 9, 5, 39],
    [0, 0, 3, 9, 5, 39],
    [5, 5, 0, 0, 0, 40],
    [5, 3, 1, 0, 0, 40],
    [5, 1, 2, 0, 0, 40],
    [0, 2, 3, 0, 0, 40],
    [0, 0, 4, 0, 0, 40],
    [3, 4, 1, 1, 1, 40],
    [3, 2, 2, 1, 1, 40],
    [3, 0, 3, 1, 1, 40],
    [0, 3, 2, 5, 1, 40],
    [0, 1, 3, 5, 1, 40],
    [1, 3, 2, 2, 2, 40],
    [1, 1, 3, 2, 2, 40],
    [3, 5, 0, 6, 2, 40],
    [3, 3, 1, 6, 2, 40],
    [3, 1, 2, 6, 2, 40],
    [0, 4, 1, 10, 2, 40],
    [0, 2, 2, 10, 2, 40],
    [0, 0, 3, 10, 2, 40],
    [1, 4, 1, 7, 3, 40],
    [1, 2, 2, 7, 3, 40],
    [1, 0, 3, 7, 3, 40],
    [0, 5, 0, 15, 3, 40],
    [0, 3, 1, 15, 3, 40],
    [0, 1, 2, 15, 3, 40],
    [1, 5, 0, 12, 4, 40],
    [1, 3, 1, 12, 4, 40],
    [1, 1, 2, 12, 4, 40],
    [0, 4, 0, 20, 4, 40],
    [0, 2, 1, 20, 4, 40],
    [0, 0, 2, 20, 4, 40],
    [0, 3, 0, 25, 5, 40],
    [0, 1, 1, 25, 5, 40],
    [2, 3, 2, 0, 0, 41],
    [2, 1, 3, 0, 0, 41],
    [0, 2, 3, 1, 1, 41],
    [0, 0, 4, 1, 1, 41],
    [2, 4, 1, 5, 1, 41],
    [2, 2, 2, 5, 1, 41],
    [2, 0, 3, 5, 1, 41],
    [3, 4, 1, 2, 2, 41],
    [3, 2, 2, 2, 2, 41],
    [3, 0, 3, 2, 2, 41],
    [0, 3, 2, 6, 2, 41],
    [0, 1, 3, 6, 2, 41],
    [2, 5, 0, 10, 2, 41],
    [2, 3, 1, 10, 2, 41],
    [2, 1, 2, 10, 2, 41],
    [1, 3, 2, 3, 3, 41],
    [1, 1, 3, 3, 3, 41],
    [0, 4, 1, 11, 3, 41],
    [0, 2, 2, 11, 3, 41],
    [0, 0, 3, 11, 3, 41],
    [2, 4, 0, 15, 3, 41],
    [2, 2, 1, 15, 3, 41],
    [2, 0, 2, 15, 3, 41],
    [1, 4, 1, 8, 4, 41],
    [1, 2, 2, 8, 4, 41],
    [1, 0, 3, 8, 4, 41],
    [0, 5, 0, 16, 4, 41],
    [0, 3, 1, 16, 4, 41],
    [0, 1, 2, 16, 4, 41],
    [0, 4, 0, 21, 5, 41],
    [0, 2, 1, 21, 5, 41],
    [0, 0, 2, 21, 5, 41],
    [0, 2, 3, 2, 2, 42],
    [0, 0, 4, 2, 2, 42],
    [0, 3, 2, 7, 3, 42],
    [0, 1, 3, 7, 3, 42],
    [0, 4, 1, 12, 4, 42],
    [0, 2, 2, 12, 4, 42],
    [0, 0, 3, 12, 4, 42],
    [0, 5, 0, 17, 5, 42],
    [0, 3, 1, 17, 5, 42],
    [0, 1, 2, 17, 5, 42],
    [0, 2, 3, 3, 3, 43],
    [0, 0, 4, 3, 3, 43],
    [0, 3, 2, 8, 4, 43],
    [0, 1, 3, 8, 4, 43],
    [0, 4, 1, 13, 5, 43],
    [0, 2, 2, 13, 5, 43],
    [0, 0, 3, 13, 5, 43],
    [0, 0, 4, 4, 4, 44],
    [0, 0, 4, 5, 1, 45],
    [0, 0, 3, 15, 3, 45],
    [0, 0, 2, 25, 5, 45],
    [0, 0, 4, 6, 2, 46],
    [0, 0, 3, 16, 4, 46],
    [0, 0, 4, 7, 3, 47],
    [0, 0, 3, 17, 5, 47],
    [0, 0, 4, 8, 4, 48],
  ],
  40: [
    [5, 5, 0, 0, 0, 40],
    [5, 3, 1, 0, 0, 40],
    [5, 1, 2, 0, 0, 40],
    [0, 2, 3, 0, 0, 40],
    [0, 0, 4, 0, 0, 40],
    [3, 4, 1, 1, 1, 40],
    [3, 2, 2, 1, 1, 40],
    [3, 0, 3, 1, 1, 40],
    [0, 3, 2, 5, 1, 40],
    [0, 1, 3, 5, 1, 40],
    [1, 3, 2, 2, 2, 40],
    [1, 1, 3, 2, 2, 40],
    [3, 5, 0, 6, 2, 40],
    [3, 3, 1, 6, 2, 40],
    [3, 1, 2, 6, 2, 40],
    [0, 4, 1, 10, 2, 40],
    [0, 2, 2, 10, 2, 40],
    [0, 0, 3, 10, 2, 40],
    [1, 4, 1, 7, 3, 40],
    [1, 2, 2, 7, 3, 40],
    [1, 0, 3, 7, 3, 40],
    [0, 5, 0, 15, 3, 40],
    [0, 3, 1, 15, 3, 40],
    [0, 1, 2, 15, 3, 40],
    [1, 5, 0, 12, 4, 40],
    [1, 3, 1, 12, 4, 40],
    [1, 1, 2, 12, 4, 40],
    [0, 4, 0, 20, 4, 40],
    [0, 2, 1, 20, 4, 40],
    [0, 0, 2, 20, 4, 40],
    [0, 3, 0, 25, 5, 40],
    [0, 1, 1, 25, 5, 40],
    [2, 3, 2, 0, 0, 41],
    [2, 1, 3, 0, 0, 41],
    [0, 2, 3, 1, 1, 41],
    [0, 0, 4, 1, 1, 41],
    [2, 4, 1, 5, 1, 41],
    [2, 2, 2, 5, 1, 41],
    [2, 0, 3, 5, 1, 41],
    [3, 4, 1, 2, 2, 41],
    [3, 2, 2, 2, 2, 41],
    [3, 0, 3, 2, 2, 41],
    [0, 3, 2, 6, 2, 41],
    [0, 1, 3, 6, 2, 41],
    [2, 5, 0, 10, 2, 41],
    [2, 3, 1, 10, 2, 41],
    [2, 1, 2, 10, 2, 41],
    [1, 3, 2, 3, 3, 41],
    [1, 1, 3, 3, 3, 41],
    [0, 4, 1, 11, 3, 41],
    [0, 2, 2, 11, 3, 41],
    [0, 0, 3, 11, 3, 41],
    [2, 4, 0, 15, 3, 41],
    [2, 2, 1, 15, 3, 41],
    [2, 0, 2, 15, 3, 41],
    [1, 4, 1, 8, 4, 41],
    [1, 2, 2, 8, 4, 41],
    [1, 0, 3, 8, 4, 41],
    [0, 5, 0, 16, 4, 41],
    [0, 3, 1, 16, 4, 41],
    [0, 1, 2, 16, 4, 41],
    [0, 4, 0, 21, 5, 41],
    [0, 2, 1, 21, 5, 41],
    [0, 0, 2, 21, 5, 41],
    [4, 4, 1, 0, 0, 42],
    [4, 2, 2, 0, 0, 42],
    [4, 0, 3, 0, 0, 42],
    [2, 3, 2, 1, 1, 42],
    [2, 1, 3, 1, 1, 42],
    [4, 5, 0, 5, 1, 42],
    [4, 3, 1, 5, 1, 42],
    [4, 1, 2, 5, 1, 42],
    [0, 2, 3, 2, 2, 42],
    [0, 0, 4, 2, 2, 42],
    [2, 4, 1, 6, 2, 42],
    [2, 2, 2, 6, 2, 42],
    [2, 0, 3, 6, 2, 42],
    [0, 3, 2, 7, 3, 42],
    [0, 1, 3, 7, 3, 42],
    [2, 5, 0, 11, 3, 42],
    [2, 3, 1, 11, 3, 42],
    [2, 1, 2, 11, 3, 42],
    [1, 3, 2, 4, 4, 42],
    [1, 1, 3, 4, 4, 42],
    [0, 4, 1, 12, 4, 42],
    [0, 2, 2, 12, 4, 42],
    [0, 0, 3, 12, 4, 42],
    [0, 5, 0, 17, 5, 42],
    [0, 3, 1, 17, 5, 42],
    [0, 1, 2, 17, 5, 42],
    [0, 2, 3, 3, 3, 43],
    [0, 0, 4, 3, 3, 43],
    [0, 3, 2, 8, 4, 43],
    [0, 1, 3, 8, 4, 43],
    [0, 4, 1, 13, 5, 43],
    [0, 2, 2, 13, 5, 43],
    [0, 0, 3, 13, 5, 43],
    [0, 2, 3, 4, 4, 44],
    [0, 0, 4, 4, 4, 44],
    [0, 3, 2, 9, 5, 44],
    [0, 1, 3, 9, 5, 44],
    [0, 0, 4, 5, 1, 45],
    [0, 0, 3, 15, 3, 45],
    [0, 0, 2, 25, 5, 45],
    [0, 0, 4, 6, 2, 46],
    [0, 0, 3, 16, 4, 46],
    [0, 0, 4, 7, 3, 47],
    [0, 0, 3, 17, 5, 47],
    [0, 0, 4, 8, 4, 48],
    [0, 0, 4, 9, 5, 49],
  ],
  41: [
    [2, 3, 2, 0, 0, 41],
    [2, 1, 3, 0, 0, 41],
    [0, 2, 3, 1, 1, 41],
    [0, 0, 4, 1, 1, 41],
    [2, 4, 1, 5, 1, 41],
    [2, 2, 2, 5, 1, 41],
    [2, 0, 3, 5, 1, 41],
    [3, 4, 1, 2, 2, 41],
    [3, 2, 2, 2, 2, 41],
    [3, 0, 3, 2, 2, 41],
    [0, 3, 2, 6, 2, 41],
    [0, 1, 3, 6, 2, 41],
    [2, 5, 0, 10, 2, 41],
    [2, 3, 1, 10, 2, 41],
    [2, 1, 2, 10, 2, 41],
    [1, 3, 2, 3, 3, 41],
    [1, 1, 3, 3, 3, 41],
    [0, 4, 1, 11, 3, 41],
    [0, 2, 2, 11, 3, 41],
    [0, 0, 3, 11, 3, 41],
    [2, 4, 0, 15, 3, 41],
    [2, 2, 1, 15, 3, 41],
    [2, 0, 2, 15, 3, 41],
    [1, 4, 1, 8, 4, 41],
    [1, 2, 2, 8, 4, 41],
    [1, 0, 3, 8, 4, 41],
    [0, 5, 0, 16, 4, 41],
    [0, 3, 1, 16, 4, 41],
    [0, 1, 2, 16, 4, 41],
    [0, 4, 0, 21, 5, 41],
    [0, 2, 1, 21, 5, 41],
    [0, 0, 2, 21, 5, 41],
    [4, 4, 1, 0, 0, 42],
    [4, 2, 2, 0, 0, 42],
    [4, 0, 3, 0, 0, 42],
    [2, 3, 2, 1, 1, 42],
    [2, 1, 3, 1, 1, 42],
    [4, 5, 0, 5, 1, 42],
    [4, 3, 1, 5, 1, 42],
    [4, 1, 2, 5, 1, 42],
    [0, 2, 3, 2, 2, 42],
    [0, 0, 4, 2, 2, 42],
    [2, 4, 1, 6, 2, 42],
    [2, 2, 2, 6, 2, 42],
    [2, 0, 3, 6, 2, 42],
    [0, 3, 2, 7, 3, 42],
    [0, 1, 3, 7, 3, 42],
    [2, 5, 0, 11, 3, 42],
    [2, 3, 1, 11, 3, 42],
    [2, 1, 2, 11, 3, 42],
    [1, 3, 2, 4, 4, 42],
    [1, 1, 3, 4, 4, 42],
    [0, 4, 1, 12, 4, 42],
    [0, 2, 2, 12, 4, 42],
    [0, 0, 3, 12, 4, 42],
    [0, 5, 0, 17, 5, 42],
    [0, 3, 1, 17, 5, 42],
    [0, 1, 2, 17, 5, 42],
    [1, 2, 3, 0, 0, 43],
    [1, 0, 4, 0, 0, 43],
    [4, 4, 1, 1, 1, 43],
    [4, 2, 2, 1, 1, 43],
    [4, 0, 3, 1, 1, 43],
    [1, 3, 2, 5, 1, 43],
    [1, 1, 3, 5, 1, 43],
    [2, 3, 2, 2, 2, 43],
    [2, 1, 3, 2, 2, 43],
    [1, 4, 1, 10, 2, 43],
    [1, 2, 2, 10, 2, 43],
    [1, 0, 3, 10, 2, 43],
    [0, 2, 3, 3, 3, 43],
    [0, 0, 4, 3, 3, 43],
    [2, 4, 1, 7, 3, 43],
    [2, 2, 2, 7, 3, 43],
    [2, 0, 3, 7, 3, 43],
    [1, 5, 0, 15, 3, 43],
    [1, 3, 1, 15, 3, 43],
    [1, 1, 2, 15, 3, 43],
    [0, 3, 2, 8, 4, 43],
    [0, 1, 3, 8, 4, 43],
    [1, 4, 0, 20, 4, 43],
    [1, 2, 1, 20, 4, 43],
    [1, 0, 2, 20, 4, 43],
    [0, 4, 1, 13, 5, 43],
    [0, 2, 2, 13, 5, 43],
    [0, 0, 3, 13, 5, 43],
    [0, 2, 3, 4, 4, 44],
    [0, 0, 4, 4, 4, 44],
    [0, 3, 2, 9, 5, 44],
    [0, 1, 3, 9, 5, 44],
    [0, 1, 4, 0, 0, 45],
    [0, 2, 3, 5, 1, 45],
    [0, 0, 4, 5, 1, 45],
    [0, 3, 2, 10, 2, 45],
    [0, 1, 3, 10, 2, 45],
    [0, 4, 1, 15, 3, 45],
    [0, 2, 2, 15, 3, 45],
    [0, 0, 3, 15, 3, 45],
    [0, 5, 0, 20, 4, 45],
    [0, 3, 1, 20, 4, 45],
    [0, 1, 2, 20, 4, 45],
    [0, 4, 0, 25, 5, 45],
    [0, 2, 1, 25, 5, 45],
    [0, 0, 2, 25, 5, 45],
    [0, 0, 4, 6, 2, 46],
    [0, 0, 3, 16, 4, 46],
    [0, 0, 4, 7, 3, 47],
    [0, 0, 3, 17, 5, 47],
    [0, 0, 4, 8, 4, 48],
    [0, 0, 4, 9, 5, 49],
    [0, 0, 5, 0, 0, 50],
    [0, 0, 4, 10, 2, 50],
    [0, 0, 3, 20, 4, 50],
  ],
  42: [
    [4, 4, 1, 0, 0, 42],
    [4, 2, 2, 0, 0, 42],
    [4, 0, 3, 0, 0, 42],
    [2, 3, 2, 1, 1, 42],
    [2, 1, 3, 1, 1, 42],
    [4, 5, 0, 5, 1, 42],
    [4, 3, 1, 5, 1, 42],
    [4, 1, 2, 5, 1, 42],
    [0, 2, 3, 2, 2, 42],
    [0, 0, 4, 2, 2, 42],
    [2, 4, 1, 6, 2, 42],
    [2, 2, 2, 6, 2, 42],
    [2, 0, 3, 6, 2, 42],
    [0, 3, 2, 7, 3, 42],
    [0, 1, 3, 7, 3, 42],
    [2, 5, 0, 11, 3, 42],
    [2, 3, 1, 11, 3, 42],
    [2, 1, 2, 11, 3, 42],
    [1, 3, 2, 4, 4, 42],
    [1, 1, 3, 4, 4, 42],
    [0, 4, 1, 12, 4, 42],
    [0, 2, 2, 12, 4, 42],
    [0, 0, 3, 12, 4, 42],
    [0, 5, 0, 17, 5, 42],
    [0, 3, 1, 17, 5, 42],
    [0, 1, 2, 17, 5, 42],
    [1, 2, 3, 0, 0, 43],
    [1, 0, 4, 0, 0, 43],
    [4, 4, 1, 1, 1, 43],
    [4, 2, 2, 1, 1, 43],
    [4, 0, 3, 1, 1, 43],
    [1, 3, 2, 5, 1, 43],
    [1, 1, 3, 5, 1, 43],
    [2, 3, 2, 2, 2, 43],
    [2, 1, 3, 2, 2, 43],
    [1, 4, 1, 10, 2, 43],
    [1, 2, 2, 10, 2, 43],
    [1, 0, 3, 10, 2, 43],
    [0, 2, 3, 3, 3, 43],
    [0, 0, 4, 3, 3, 43],
    [2, 4, 1, 7, 3, 43],
    [2, 2, 2, 7, 3, 43],
    [2, 0, 3, 7, 3, 43],
    [1, 5, 0, 15, 3, 43],
    [1, 3, 1, 15, 3, 43],
    [1, 1, 2, 15, 3, 43],
    [0, 3, 2, 8, 4, 43],
    [0, 1, 3, 8, 4, 43],
    [1, 4, 0, 20, 4, 43],
    [1, 2, 1, 20, 4, 43],
    [1, 0, 2, 20, 4, 43],
    [0, 4, 1, 13, 5, 43],
    [0, 2, 2, 13, 5, 43],
    [0, 0, 3, 13, 5, 43],
    [3, 3, 2, 0, 0, 44],
    [3, 1, 3, 0, 0, 44],
    [1, 2, 3, 1, 1, 44],
    [1, 0, 4, 1, 1, 44],
    [3, 4, 1, 5, 1, 44],
    [3, 2, 2, 5, 1, 44],
    [3, 0, 3, 5, 1, 44],
    [1, 3, 2, 6, 2, 44],
    [1, 1, 3, 6, 2, 44],
    [3, 5, 0, 10, 2, 44],
    [3, 3, 1, 10, 2, 44],
    [3, 1, 2, 10, 2, 44],
    [2, 3, 2, 3, 3, 44],
    [2, 1, 3, 3, 3, 44],
    [1, 4, 1, 11, 3, 44],
    [1, 2, 2, 11, 3, 44],
    [1, 0, 3, 11, 3, 44],
    [0, 2, 3, 4, 4, 44],
    [0, 0, 4, 4, 4, 44],
    [1, 5, 0, 16, 4, 44],
    [1, 3, 1, 16, 4, 44],
    [1, 1, 2, 16, 4, 44],
    [0, 3, 2, 9, 5, 44],
    [0, 1, 3, 9, 5, 44],
    [0, 1, 4, 0, 0, 45],
    [0, 2, 3, 5, 1, 45],
    [0, 0, 4, 5, 1, 45],
    [0, 3, 2, 10, 2, 45],
    [0, 1, 3, 10, 2, 45],
    [0, 4, 1, 15, 3, 45],
    [0, 2, 2, 15, 3, 45],
    [0, 0, 3, 15, 3, 45],
    [0, 5, 0, 20, 4, 45],
    [0, 3, 1, 20, 4, 45],
    [0, 1, 2, 20, 4, 45],
    [0, 4, 0, 25, 5, 45],
    [0, 2, 1, 25, 5, 45],
    [0, 0, 2, 25, 5, 45],
    [0, 1, 4, 1, 1, 46],
    [0, 2, 3, 6, 2, 46],
    [0, 0, 4, 6, 2, 46],
    [0, 3, 2, 11, 3, 46],
    [0, 1, 3, 11, 3, 46],
    [0, 4, 1, 16, 4, 46],
    [0, 2, 2, 16, 4, 46],
    [0, 0, 3, 16, 4, 46],
    [0, 5, 0, 21, 5, 46],
    [0, 3, 1, 21, 5, 46],
    [0, 1, 2, 21, 5, 46],
    [0, 0, 4, 7, 3, 47],
    [0, 0, 3, 17, 5, 47],
    [0, 0, 4, 8, 4, 48],
    [0, 0, 4, 9, 5, 49],
    [0, 0, 5, 0, 0, 50],
    [0, 0, 4, 10, 2, 50],
    [0, 0, 3, 20, 4, 50],
    [0, 0, 5, 1, 1, 51],
    [0, 0, 4, 11, 3, 51],
    [0, 0, 3, 21, 5, 51],
  ],
  43: [
    [1, 2, 3, 0, 0, 43],
    [1, 0, 4, 0, 0, 43],
    [4, 4, 1, 1, 1, 43],
    [4, 2, 2, 1, 1, 43],
    [4, 0, 3, 1, 1, 43],
    [1, 3, 2, 5, 1, 43],
    [1, 1, 3, 5, 1, 43],
    [2, 3, 2, 2, 2, 43],
    [2, 1, 3, 2, 2, 43],
    [1, 4, 1, 10, 2, 43],
    [1, 2, 2, 10, 2, 43],
    [1, 0, 3, 10, 2, 43],
    [0, 2, 3, 3, 3, 43],
    [0, 0, 4, 3, 3, 43],
    [2, 4, 1, 7, 3, 43],
    [2, 2, 2, 7, 3, 43],
    [2, 0, 3, 7, 3, 43],
    [1, 5, 0, 15, 3, 43],
    [1, 3, 1, 15, 3, 43],
    [1, 1, 2, 15, 3, 43],
    [0, 3, 2, 8, 4, 43],
    [0, 1, 3, 8, 4, 43],
    [1, 4, 0, 20, 4, 43],
    [1, 2, 1, 20, 4, 43],
    [1, 0, 2, 20, 4, 43],
    [0, 4, 1, 13, 5, 43],
    [0, 2, 2, 13, 5, 43],
    [0, 0, 3, 13, 5, 43],
    [3, 3, 2, 0, 0, 44],
    [3, 1, 3, 0, 0, 44],
    [1, 2, 3, 1, 1, 44],
    [1, 0, 4, 1, 1, 44],
    [3, 4, 1, 5, 1, 44],
    [3, 2, 2, 5, 1, 44],
    [3, 0, 3, 5, 1, 44],
    [1, 3, 2, 6, 2, 44],
    [1, 1, 3, 6, 2, 44],
    [3, 5, 0, 10, 2, 44],
    [3, 3, 1, 10, 2, 44],
    [3, 1, 2, 10, 2, 44],
    [2, 3, 2, 3, 3, 44],
    [2, 1, 3, 3, 3, 44],
    [1, 4, 1, 11, 3, 44],
    [1, 2, 2, 11, 3, 44],
    [1, 0, 3, 11, 3, 44],
    [0, 2, 3, 4, 4, 44],
    [0, 0, 4, 4, 4, 44],
    [1, 5, 0, 16, 4, 44],
    [1, 3, 1, 16, 4, 44],
    [1, 1, 2, 16, 4, 44],
    [0, 3, 2, 9, 5, 44],
    [0, 1, 3, 9, 5, 44],
    [5, 4, 1, 0, 0, 45],
    [5, 2, 2, 0, 0, 45],
    [5, 0, 3, 0, 0, 45],
    [0, 1, 4, 0, 0, 45],
    [3, 3, 2, 1, 1, 45],
    [3, 1, 3, 1, 1, 45],
    [0, 2, 3, 5, 1, 45],
    [0, 0, 4, 5, 1, 45],
    [1, 2, 3, 2, 2, 45],
    [1, 0, 4, 2, 2, 45],
    [3, 4, 1, 6, 2, 45],
    [3, 2, 2, 6, 2, 45],
    [3, 0, 3, 6, 2, 45],
    [0, 3, 2, 10, 2, 45],
    [0, 1, 3, 10, 2, 45],
    [1, 3, 2, 7, 3, 45],
    [1, 1, 3, 7, 3, 45],
    [0, 4, 1, 15, 3, 45],
    [0, 2, 2, 15, 3, 45],
    [0, 0, 3, 15, 3, 45],
    [1, 4, 1, 12, 4, 45],
    [1, 2, 2, 12, 4, 45],
    [1, 0, 3, 12, 4, 45],
    [0, 5, 0, 20, 4, 45],
    [0, 3, 1, 20, 4, 45],
    [0, 1, 2, 20, 4, 45],
    [0, 4, 0, 25, 5, 45],
    [0, 2, 1, 25, 5, 45],
    [0, 0, 2, 25, 5, 45],
    [0, 1, 4, 1, 1, 46],
    [0, 2, 3, 6, 2, 46],
    [0, 0, 4, 6, 2, 46],
    [0, 3, 2, 11, 3, 46],
    [0, 1, 3, 11, 3, 46],
    [0, 4, 1, 16, 4, 46],
    [0, 2, 2, 16, 4, 46],
    [0, 0, 3, 16, 4, 46],
    [0, 5, 0, 21, 5, 46],
    [0, 3, 1, 21, 5, 46],
    [0, 1, 2, 21, 5, 46],
    [0, 1, 4, 2, 2, 47],
    [0, 2, 3, 7, 3, 47],
    [0, 0, 4, 7, 3, 47],
    [0, 3, 2, 12, 4, 47],
    [0, 1, 3, 12, 4, 47],
    [0, 4, 1, 17, 5, 47],
    [0, 2, 2, 17, 5, 47],
    [0, 0, 3, 17, 5, 47],
    [0, 0, 4, 8, 4, 48],
    [0, 0, 4, 9, 5, 49],
    [0, 0, 5, 0, 0, 50],
    [0, 0, 4, 10, 2, 50],
    [0, 0, 3, 20, 4, 50],
    [0, 0, 5, 1, 1, 51],
    [0, 0, 4, 11, 3, 51],
    [0, 0, 3, 21, 5, 51],
    [0, 0, 5, 2, 2, 52],
    [0, 0, 4, 12, 4, 52],
  ],
  44: [
    [3, 3, 2, 0, 0, 44],
    [3, 1, 3, 0, 0, 44],
    [1, 2, 3, 1, 1, 44],
    [1, 0, 4, 1, 1, 44],
    [3, 4, 1, 5, 1, 44],
    [3, 2, 2, 5, 1, 44],
    [3, 0, 3, 5, 1, 44],
    [1, 3, 2, 6, 2, 44],
    [1, 1, 3, 6, 2, 44],
    [3, 5, 0, 10, 2, 44],
    [3, 3, 1, 10, 2, 44],
    [3, 1, 2, 10, 2, 44],
    [2, 3, 2, 3, 3, 44],
    [2, 1, 3, 3, 3, 44],
    [1, 4, 1, 11, 3, 44],
    [1, 2, 2, 11, 3, 44],
    [1, 0, 3, 11, 3, 44],
    [0, 2, 3, 4, 4, 44],
    [0, 0, 4, 4, 4, 44],
    [1, 5, 0, 16, 4, 44],
    [1, 3, 1, 16, 4, 44],
    [1, 1, 2, 16, 4, 44],
    [0, 3, 2, 9, 5, 44],
    [0, 1, 3, 9, 5, 44],
    [5, 4, 1, 0, 0, 45],
    [5, 2, 2, 0, 0, 45],
    [5, 0, 3, 0, 0, 45],
    [0, 1, 4, 0, 0, 45],
    [3, 3, 2, 1, 1, 45],
    [3, 1, 3, 1, 1, 45],
    [0, 2, 3, 5, 1, 45],
    [0, 0, 4, 5, 1, 45],
    [1, 2, 3, 2, 2, 45],
    [1, 0, 4, 2, 2, 45],
    [3, 4, 1, 6, 2, 45],
    [3, 2, 2, 6, 2, 45],
    [3, 0, 3, 6, 2, 45],
    [0, 3, 2, 10, 2, 45],
    [0, 1, 3, 10, 2, 45],
    [1, 3, 2, 7, 3, 45],
    [1, 1, 3, 7, 3, 45],
    [0, 4, 1, 15, 3, 45],
    [0, 2, 2, 15, 3, 45],
    [0, 0, 3, 15, 3, 45],
    [1, 4, 1, 12, 4, 45],
    [1, 2, 2, 12, 4, 45],
    [1, 0, 3, 12, 4, 45],
    [0, 5, 0, 20, 4, 45],
    [0, 3, 1, 20, 4, 45],
    [0, 1, 2, 20, 4, 45],
    [0, 4, 0, 25, 5, 45],
    [0, 2, 1, 25, 5, 45],
    [0, 0, 2, 25, 5, 45],
    [2, 2, 3, 0, 0, 46],
    [2, 0, 4, 0, 0, 46],
    [0, 1, 4, 1, 1, 46],
    [2, 3, 2, 5, 1, 46],
    [2, 1, 3, 5, 1, 46],
    [3, 3, 2, 2, 2, 46],
    [3, 1, 3, 2, 2, 46],
    [0, 2, 3, 6, 2, 46],
    [0, 0, 4, 6, 2, 46],
    [2, 4, 1, 10, 2, 46],
    [2, 2, 2, 10, 2, 46],
    [2, 0, 3, 10, 2, 46],
    [1, 2, 3, 3, 3, 46],
    [1, 0, 4, 3, 3, 46],
    [0, 3, 2, 11, 3, 46],
    [0, 1, 3, 11, 3, 46],
    [2, 5, 0, 15, 3, 46],
    [2, 3, 1, 15, 3, 46],
    [2, 1, 2, 15, 3, 46],
    [1, 3, 2, 8, 4, 46],
    [1, 1, 3, 8, 4, 46],
    [0, 4, 1, 16, 4, 46],
    [0, 2, 2, 16, 4, 46],
    [0, 0, 3, 16, 4, 46],
    [0, 5, 0, 21, 5, 46],
    [0, 3, 1, 21, 5, 46],
    [0, 1, 2, 21, 5, 46],
    [0, 1, 4, 2, 2, 47],
    [0, 2, 3, 7, 3, 47],
    [0, 0, 4, 7, 3, 47],
    [0, 3, 2, 12, 4, 47],
    [0, 1, 3, 12, 4, 47],
    [0, 4, 1, 17, 5, 47],
    [0, 2, 2, 17, 5, 47],
    [0, 0, 3, 17, 5, 47],
    [0, 1, 4, 3, 3, 48],
    [0, 2, 3, 8, 4, 48],
    [0, 0, 4, 8, 4, 48],
    [0, 3, 2, 13, 5, 48],
    [0, 1, 3, 13, 5, 48],
    [0, 0, 4, 9, 5, 49],
    [0, 0, 5, 0, 0, 50],
    [0, 0, 4, 10, 2, 50],
    [0, 0, 3, 20, 4, 50],
    [0, 0, 5, 1, 1, 51],
    [0, 0, 4, 11, 3, 51],
    [0, 0, 3, 21, 5, 51],
    [0, 0, 5, 2, 2, 52],
    [0, 0, 4, 12, 4, 52],
    [0, 0, 5, 3, 3, 53],
    [0, 0, 4, 13, 5, 53],
  ],
  45: [
    [5, 4, 1, 0, 0, 45],
    [5, 2, 2, 0, 0, 45],
    [5, 0, 3, 0, 0, 45],
    [0, 1, 4, 0, 0, 45],
    [3, 3, 2, 1, 1, 45],
    [3, 1, 3, 1, 1, 45],
    [0, 2, 3, 5, 1, 45],
    [0, 0, 4, 5, 1, 45],
    [1, 2, 3, 2, 2, 45],
    [1, 0, 4, 2, 2, 45],
    [3, 4, 1, 6, 2, 45],
    [3, 2, 2, 6, 2, 45],
    [3, 0, 3, 6, 2, 45],
    [0, 3, 2, 10, 2, 45],
    [0, 1, 3, 10, 2, 45],
    [1, 3, 2, 7, 3, 45],
    [1, 1, 3, 7, 3, 45],
    [0, 4, 1, 15, 3, 45],
    [0, 2, 2, 15, 3, 45],
    [0, 0, 3, 15, 3, 45],
    [1, 4, 1, 12, 4, 45],
    [1, 2, 2, 12, 4, 45],
    [1, 0, 3, 12, 4, 45],
    [0, 5, 0, 20, 4, 45],
    [0, 3, 1, 20, 4, 45],
    [0, 1, 2, 20, 4, 45],
    [0, 4, 0, 25, 5, 45],
    [0, 2, 1, 25, 5, 45],
    [0, 0, 2, 25, 5, 45],
    [2, 2, 3, 0, 0, 46],
    [2, 0, 4, 0, 0, 46],
    [0, 1, 4, 1, 1, 46],
    [2, 3, 2, 5, 1, 46],
    [2, 1, 3, 5, 1, 46],
    [3, 3, 2, 2, 2, 46],
    [3, 1, 3, 2, 2, 46],
    [0, 2, 3, 6, 2, 46],
    [0, 0, 4, 6, 2, 46],
    [2, 4, 1, 10, 2, 46],
    [2, 2, 2, 10, 2, 46],
    [2, 0, 3, 10, 2, 46],
    [1, 2, 3, 3, 3, 46],
    [1, 0, 4, 3, 3, 46],
    [0, 3, 2, 11, 3, 46],
    [0, 1, 3, 11, 3, 46],
    [2, 5, 0, 15, 3, 46],
    [2, 3, 1, 15, 3, 46],
    [2, 1, 2, 15, 3, 46],
    [1, 3, 2, 8, 4, 46],
    [1, 1, 3, 8, 4, 46],
    [0, 4, 1, 16, 4, 46],
    [0, 2, 2, 16, 4, 46],
    [0, 0, 3, 16, 4, 46],
    [0, 5, 0, 21, 5, 46],
    [0, 3, 1, 21, 5, 46],
    [0, 1, 2, 21, 5, 46],
    [4, 3, 2, 0, 0, 47],
    [4, 1, 3, 0, 0, 47],
    [2, 2, 3, 1, 1, 47],
    [2, 0, 4, 1, 1, 47],
    [4, 4, 1, 5, 1, 47],
    [4, 2, 2, 5, 1, 47],
    [4, 0, 3, 5, 1, 47],
    [0, 1, 4, 2, 2, 47],
    [2, 3, 2, 6, 2, 47],
    [2, 1, 3, 6, 2, 47],
    [0, 2, 3, 7, 3, 47],
    [0, 0, 4, 7, 3, 47],
    [2, 4, 1, 11, 3, 47],
    [2, 2, 2, 11, 3, 47],
    [2, 0, 3, 11, 3, 47],
    [1, 2, 3, 4, 4, 47],
    [1, 0, 4, 4, 4, 47],
    [0, 3, 2, 12, 4, 47],
    [0, 1, 3, 12, 4, 47],
    [0, 4, 1, 17, 5, 47],
    [0, 2, 2, 17, 5, 47],
    [0, 0, 3, 17, 5, 47],
    [0, 1, 4, 3, 3, 48],
    [0, 2, 3, 8, 4, 48],
    [0, 0, 4, 8, 4, 48],
    [0, 3, 2, 13, 5, 48],
    [0, 1, 3, 13, 5, 48],
    [0, 1, 4, 4, 4, 49],
    [0, 2, 3, 9, 5, 49],
    [0, 0, 4, 9, 5, 49],
    [0, 0, 5, 0, 0, 50],
    [0, 0, 4, 10, 2, 50],
    [0, 0, 3, 20, 4, 50],
    [0, 0, 5, 1, 1, 51],
    [0, 0, 4, 11, 3, 51],
    [0, 0, 3, 21, 5, 51],
    [0, 0, 5, 2, 2, 52],
    [0, 0, 4, 12, 4, 52],
    [0, 0, 5, 3, 3, 53],
    [0, 0, 4, 13, 5, 53],
    [0, 0, 5, 4, 4, 54],
  ],
  46: [
    [2, 2, 3, 0, 0, 46],
    [2, 0, 4, 0, 0, 46],
    [0, 1, 4, 1, 1, 46],
    [2, 3, 2, 5, 1, 46],
    [2, 1, 3, 5, 1, 46],
    [3, 3, 2, 2, 2, 46],
    [3, 1, 3, 2, 2, 46],
    [0, 2, 3, 6, 2, 46],
    [0, 0, 4, 6, 2, 46],
    [2, 4, 1, 10, 2, 46],
    [2, 2, 2, 10, 2, 46],
    [2, 0, 3, 10, 2, 46],
    [1, 2, 3, 3, 3, 46],
    [1, 0, 4, 3, 3, 46],
    [0, 3, 2, 11, 3, 46],
    [0, 1, 3, 11, 3, 46],
    [2, 5, 0, 15, 3, 46],
    [2, 3, 1, 15, 3, 46],
    [2, 1, 2, 15, 3, 46],
    [1, 3, 2, 8, 4, 46],
    [1, 1, 3, 8, 4, 46],
    [0, 4, 1, 16, 4, 46],
    [0, 2, 2, 16, 4, 46],
    [0, 0, 3, 16, 4, 46],
    [0, 5, 0, 21, 5, 46],
    [0, 3, 1, 21, 5, 46],
    [0, 1, 2, 21, 5, 46],
    [4, 3, 2, 0, 0, 47],
    [4, 1, 3, 0, 0, 47],
    [2, 2, 3, 1, 1, 47],
    [2, 0, 4, 1, 1, 47],
    [4, 4, 1, 5, 1, 47],
    [4, 2, 2, 5, 1, 47],
    [4, 0, 3, 5, 1, 47],
    [0, 1, 4, 2, 2, 47],
    [2, 3, 2, 6, 2, 47],
    [2, 1, 3, 6, 2, 47],
    [0, 2, 3, 7, 3, 47],
    [0, 0, 4, 7, 3, 47],
    [2, 4, 1, 11, 3, 47],
    [2, 2, 2, 11, 3, 47],
    [2, 0, 3, 11, 3, 47],
    [1, 2, 3, 4, 4, 47],
    [1, 0, 4, 4, 4, 47],
    [0, 3, 2, 12, 4, 47],
    [0, 1, 3, 12, 4, 47],
    [0, 4, 1, 17, 5, 47],
    [0, 2, 2, 17, 5, 47],
    [0, 0, 3, 17, 5, 47],
    [1, 1, 4, 0, 0, 48],
    [4, 3, 2, 1, 1, 48],
    [4, 1, 3, 1, 1, 48],
    [1, 2, 3, 5, 1, 48],
    [1, 0, 4, 5, 1, 48],
    [2, 2, 3, 2, 2, 48],
    [2, 0, 4, 2, 2, 48],
    [1, 3, 2, 10, 2, 48],
    [1, 1, 3, 10, 2, 48],
    [0, 1, 4, 3, 3, 48],
    [2, 3, 2, 7, 3, 48],
    [2, 1, 3, 7, 3, 48],
    [1, 4, 1, 15, 3, 48],
    [1, 2, 2, 15, 3, 48],
    [1, 0, 3, 15, 3, 48],
    [0, 2, 3, 8, 4, 48],
    [0, 0, 4, 8, 4, 48],
    [1, 5, 0, 20, 4, 48],
    [1, 3, 1, 20, 4, 48],
    [1, 1, 2, 20, 4, 48],
    [0, 3, 2, 13, 5, 48],
    [0, 1, 3, 13, 5, 48],
    [0, 1, 4, 4, 4, 49],
    [0, 2, 3, 9, 5, 49],
    [0, 0, 4, 9, 5, 49],
    [0, 0, 5, 0, 0, 50],
    [0, 1, 4, 5, 1, 50],
    [0, 2, 3, 10, 2, 50],
    [0, 0, 4, 10, 2, 50],
    [0, 3, 2, 15, 3, 50],
    [0, 1, 3, 15, 3, 50],
    [0, 4, 1, 20, 4, 50],
    [0, 2, 2, 20, 4, 50],
    [0, 0, 3, 20, 4, 50],
    [0, 5, 0, 25, 5, 50],
    [0, 3, 1, 25, 5, 50],
    [0, 1, 2, 25, 5, 50],
    [0, 0, 5, 1, 1, 51],
    [0, 0, 4, 11, 3, 51],
    [0, 0, 3, 21, 5, 51],
    [0, 0, 5, 2, 2, 52],
    [0, 0, 4, 12, 4, 52],
    [0, 0, 5, 3, 3, 53],
    [0, 0, 4, 13, 5, 53],
    [0, 0, 5, 4, 4, 54],
    [0, 0, 5, 5, 1, 55],
    [0, 0, 4, 15, 3, 55],
    [0, 0, 3, 25, 5, 55],
  ],
  47: [
    [4, 3, 2, 0, 0, 47],
    [4, 1, 3, 0, 0, 47],
    [2, 2, 3, 1, 1, 47],
    [2, 0, 4, 1, 1, 47],
    [4, 4, 1, 5, 1, 47],
    [4, 2, 2, 5, 1, 47],
    [4, 0, 3, 5, 1, 47],
    [0, 1, 4, 2, 2, 47],
    [2, 3, 2, 6, 2, 47],
    [2, 1, 3, 6, 2, 47],
    [0, 2, 3, 7, 3, 47],
    [0, 0, 4, 7, 3, 47],
    [2, 4, 1, 11, 3, 47],
    [2, 2, 2, 11, 3, 47],
    [2, 0, 3, 11, 3, 47],
    [1, 2, 3, 4, 4, 47],
    [1, 0, 4, 4, 4, 47],
    [0, 3, 2, 12, 4, 47],
    [0, 1, 3, 12, 4, 47],
    [0, 4, 1, 17, 5, 47],
    [0, 2, 2, 17, 5, 47],
    [0, 0, 3, 17, 5, 47],
    [1, 1, 4, 0, 0, 48],
    [4, 3, 2, 1, 1, 48],
    [4, 1, 3, 1, 1, 48],
    [1, 2, 3, 5, 1, 48],
    [1, 0, 4, 5, 1, 48],
    [2, 2, 3, 2, 2, 48],
    [2, 0, 4, 2, 2, 48],
    [1, 3, 2, 10, 2, 48],
    [1, 1, 3, 10, 2, 48],
    [0, 1, 4, 3, 3, 48],
    [2, 3, 2, 7, 3, 48],
    [2, 1, 3, 7, 3, 48],
    [1, 4, 1, 15, 3, 48],
    [1, 2, 2, 15, 3, 48],
    [1, 0, 3, 15, 3, 48],
    [0, 2, 3, 8, 4, 48],
    [0, 0, 4, 8, 4, 48],
    [1, 5, 0, 20, 4, 48],
    [1, 3, 1, 20, 4, 48],
    [1, 1, 2, 20, 4, 48],
    [0, 3, 2, 13, 5, 48],
    [0, 1, 3, 13, 5, 48],
    [3, 2, 3, 0, 0, 49],
    [3, 0, 4, 0, 0, 49],
    [1, 1, 4, 1, 1, 49],
    [3, 3, 2, 5, 1, 49],
    [3, 1, 3, 5, 1, 49],
    [1, 2, 3, 6, 2, 49],
    [1, 0, 4, 6, 2, 49],
    [3, 4, 1, 10, 2, 49],
    [3, 2, 2, 10, 2, 49],
    [3, 0, 3, 10, 2, 49],
    [2, 2, 3, 3, 3, 49],
    [2, 0, 4, 3, 3, 49],
    [1, 3, 2, 11, 3, 49],
    [1, 1, 3, 11, 3, 49],
    [0, 1, 4, 4, 4, 49],
    [1, 4, 1, 16, 4, 49],
    [1, 2, 2, 16, 4, 49],
    [1, 0, 3, 16, 4, 49],
    [0, 2, 3, 9, 5, 49],
    [0, 0, 4, 9, 5, 49],
    [0, 0, 5, 0, 0, 50],
    [0, 1, 4, 5, 1, 50],
    [0, 2, 3, 10, 2, 50],
    [0, 0, 4, 10, 2, 50],
    [0, 3, 2, 15, 3, 50],
    [0, 1, 3, 15, 3, 50],
    [0, 4, 1, 20, 4, 50],
    [0, 2, 2, 20, 4, 50],
    [0, 0, 3, 20, 4, 50],
    [0, 5, 0, 25, 5, 50],
    [0, 3, 1, 25, 5, 50],
    [0, 1, 2, 25, 5, 50],
    [0, 0, 5, 1, 1, 51],
    [0, 1, 4, 6, 2, 51],
    [0, 2, 3, 11, 3, 51],
    [0, 0, 4, 11, 3, 51],
    [0, 3, 2, 16, 4, 51],
    [0, 1, 3, 16, 4, 51],
    [0, 4, 1, 21, 5, 51],
    [0, 2, 2, 21, 5, 51],
    [0, 0, 3, 21, 5, 51],
    [0, 0, 5, 2, 2, 52],
    [0, 0, 4, 12, 4, 52],
    [0, 0, 5, 3, 3, 53],
    [0, 0, 4, 13, 5, 53],
    [0, 0, 5, 4, 4, 54],
    [0, 0, 5, 5, 1, 55],
    [0, 0, 4, 15, 3, 55],
    [0, 0, 3, 25, 5, 55],
    [0, 0, 5, 6, 2, 56],
    [0, 0, 4, 16, 4, 56],
  ],
  48: [
    [1, 1, 4, 0, 0, 48],
    [4, 3, 2, 1, 1, 48],
    [4, 1, 3, 1, 1, 48],
    [1, 2, 3, 5, 1, 48],
    [1, 0, 4, 5, 1, 48],
    [2, 2, 3, 2, 2, 48],
    [2, 0, 4, 2, 2, 48],
    [1, 3, 2, 10, 2, 48],
    [1, 1, 3, 10, 2, 48],
    [0, 1, 4, 3, 3, 48],
    [2, 3, 2, 7, 3, 48],
    [2, 1, 3, 7, 3, 48],
    [1, 4, 1, 15, 3, 48],
    [1, 2, 2, 15, 3, 48],
    [1, 0, 3, 15, 3, 48],
    [0, 2, 3, 8, 4, 48],
    [0, 0, 4, 8, 4, 48],
    [1, 5, 0, 20, 4, 48],
    [1, 3, 1, 20, 4, 48],
    [1, 1, 2, 20, 4, 48],
    [0, 3, 2, 13, 5, 48],
    [0, 1, 3, 13, 5, 48],
    [3, 2, 3, 0, 0, 49],
    [3, 0, 4, 0, 0, 49],
    [1, 1, 4, 1, 1, 49],
    [3, 3, 2, 5, 1, 49],
    [3, 1, 3, 5, 1, 49],
    [1, 2, 3, 6, 2, 49],
    [1, 0, 4, 6, 2, 49],
    [3, 4, 1, 10, 2, 49],
    [3, 2, 2, 10, 2, 49],
    [3, 0, 3, 10, 2, 49],
    [2, 2, 3, 3, 3, 49],
    [2, 0, 4, 3, 3, 49],
    [1, 3, 2, 11, 3, 49],
    [1, 1, 3, 11, 3, 49],
    [0, 1, 4, 4, 4, 49],
    [1, 4, 1, 16, 4, 49],
    [1, 2, 2, 16, 4, 49],
    [1, 0, 3, 16, 4, 49],
    [0, 2, 3, 9, 5, 49],
    [0, 0, 4, 9, 5, 49],
    [5, 3, 2, 0, 0, 50],
    [5, 1, 3, 0, 0, 50],
    [0, 0, 5, 0, 0, 50],
    [3, 2, 3, 1, 1, 50],
    [3, 0, 4, 1, 1, 50],
    [0, 1, 4, 5, 1, 50],
    [1, 1, 4, 2, 2, 50],
    [3, 3, 2, 6, 2, 50],
    [3, 1, 3, 6, 2, 50],
    [0, 2, 3, 10, 2, 50],
    [0, 0, 4, 10, 2, 50],
    [1, 2, 3, 7, 3, 50],
    [1, 0, 4, 7, 3, 50],
    [0, 3, 2, 15, 3, 50],
    [0, 1, 3, 15, 3, 50],
    [1, 3, 2, 12, 4, 50],
    [1, 1, 3, 12, 4, 50],
    [0, 4, 1, 20, 4, 50],
    [0, 2, 2, 20, 4, 50],
    [0, 0, 3, 20, 4, 50],
    [0, 5, 0, 25, 5, 50],
    [0, 3, 1, 25, 5, 50],
    [0, 1, 2, 25, 5, 50],
    [0, 0, 5, 1, 1, 51],
    [0, 1, 4, 6, 2, 51],
    [0, 2, 3, 11, 3, 51],
    [0, 0, 4, 11, 3, 51],
    [0, 3, 2, 16, 4, 51],
    [0, 1, 3, 16, 4, 51],
    [0, 4, 1, 21, 5, 51],
    [0, 2, 2, 21, 5, 51],
    [0, 0, 3, 21, 5, 51],
    [0, 0, 5, 2, 2, 52],
    [0, 1, 4, 7, 3, 52],
    [0, 2, 3, 12, 4, 52],
    [0, 0, 4, 12, 4, 52],
    [0, 3, 2, 17, 5, 52],
    [0, 1, 3, 17, 5, 52],
    [0, 0, 5, 3, 3, 53],
    [0, 0, 4, 13, 5, 53],
    [0, 0, 5, 4, 4, 54],
    [0, 0, 5, 5, 1, 55],
    [0, 0, 4, 15, 3, 55],
    [0, 0, 3, 25, 5, 55],
    [0, 0, 5, 6, 2, 56],
    [0, 0, 4, 16, 4, 56],
    [0, 0, 5, 7, 3, 57],
    [0, 0, 4, 17, 5, 57],
  ],
  49: [
    [3, 2, 3, 0, 0, 49],
    [3, 0, 4, 0, 0, 49],
    [1, 1, 4, 1, 1, 49],
    [3, 3, 2, 5, 1, 49],
    [3, 1, 3, 5, 1, 49],
    [1, 2, 3, 6, 2, 49],
    [1, 0, 4, 6, 2, 49],
    [3, 4, 1, 10, 2, 49],
    [3, 2, 2, 10, 2, 49],
    [3, 0, 3, 10, 2, 49],
    [2, 2, 3, 3, 3, 49],
    [2, 0, 4, 3, 3, 49],
    [1, 3, 2, 11, 3, 49],
    [1, 1, 3, 11, 3, 49],
    [0, 1, 4, 4, 4, 49],
    [1, 4, 1, 16, 4, 49],
    [1, 2, 2, 16, 4, 49],
    [1, 0, 3, 16, 4, 49],
    [0, 2, 3, 9, 5, 49],
    [0, 0, 4, 9, 5, 49],
    [5, 3, 2, 0, 0, 50],
    [5, 1, 3, 0, 0, 50],
    [0, 0, 5, 0, 0, 50],
    [3, 2, 3, 1, 1, 50],
    [3, 0, 4, 1, 1, 50],
    [0, 1, 4, 5, 1, 50],
    [1, 1, 4, 2, 2, 50],
    [3, 3, 2, 6, 2, 50],
    [3, 1, 3, 6, 2, 50],
    [0, 2, 3, 10, 2, 50],
    [0, 0, 4, 10, 2, 50],
    [1, 2, 3, 7, 3, 50],
    [1, 0, 4, 7, 3, 50],
    [0, 3, 2, 15, 3, 50],
    [0, 1, 3, 15, 3, 50],
    [1, 3, 2, 12, 4, 50],
    [1, 1, 3, 12, 4, 50],
    [0, 4, 1, 20, 4, 50],
    [0, 2, 2, 20, 4, 50],
    [0, 0, 3, 20, 4, 50],
    [0, 5, 0, 25, 5, 50],
    [0, 3, 1, 25, 5, 50],
    [0, 1, 2, 25, 5, 50],
    [2, 1, 4, 0, 0, 51],
    [0, 0, 5, 1, 1, 51],
    [2, 2, 3, 5, 1, 51],
    [2, 0, 4, 5, 1, 51],
    [3, 2, 3, 2, 2, 51],
    [3, 0, 4, 2, 2, 51],
    [0, 1, 4, 6, 2, 51],
    [2, 3, 2, 10, 2, 51],
    [2, 1, 3, 10, 2, 51],
    [1, 1, 4, 3, 3, 51],
    [0, 2, 3, 11, 3, 51],
    [0, 0, 4, 11, 3, 51],
    [2, 4, 1, 15, 3, 51],
    [2, 2, 2, 15, 3, 51],
    [2, 0, 3, 15, 3, 51],
    [1, 2, 3, 8, 4, 51],
    [1, 0, 4, 8, 4, 51],
    [0, 3, 2, 16, 4, 51],
    [0, 1, 3, 16, 4, 51],
    [0, 4, 1, 21, 5, 51],
    [0, 2, 2, 21, 5, 51],
    [0, 0, 3, 21, 5, 51],
    [0, 0, 5, 2, 2, 52],
    [0, 1, 4, 7, 3, 52],
    [0, 2, 3, 12, 4, 52],
    [0, 0, 4, 12, 4, 52],
    [0, 3, 2, 17, 5, 52],
    [0, 1, 3, 17, 5, 52],
    [0, 0, 5, 3, 3, 53],
    [0, 1, 4, 8, 4, 53],
    [0, 2, 3, 13, 5, 53],
    [0, 0, 4, 13, 5, 53],
    [0, 0, 5, 4, 4, 54],
    [0, 0, 5, 5, 1, 55],
    [0, 0, 4, 15, 3, 55],
    [0, 0, 3, 25, 5, 55],
    [0, 0, 5, 6, 2, 56],
    [0, 0, 4, 16, 4, 56],
    [0, 0, 5, 7, 3, 57],
    [0, 0, 4, 17, 5, 57],
    [0, 0, 5, 8, 4, 58],
  ],
  50: [
    [5, 3, 2, 0, 0, 50],
    [5, 1, 3, 0, 0, 50],
    [0, 0, 5, 0, 0, 50],
    [3, 2, 3, 1, 1, 50],
    [3, 0, 4, 1, 1, 50],
    [0, 1, 4, 5, 1, 50],
    [1, 1, 4, 2, 2, 50],
    [3, 3, 2, 6, 2, 50],
    [3, 1, 3, 6, 2, 50],
    [0, 2, 3, 10, 2, 50],
    [0, 0, 4, 10, 2, 50],
    [1, 2, 3, 7, 3, 50],
    [1, 0, 4, 7, 3, 50],
    [0, 3, 2, 15, 3, 50],
    [0, 1, 3, 15, 3, 50],
    [1, 3, 2, 12, 4, 50],
    [1, 1, 3, 12, 4, 50],
    [0, 4, 1, 20, 4, 50],
    [0, 2, 2, 20, 4, 50],
    [0, 0, 3, 20, 4, 50],
    [0, 5, 0, 25, 5, 50],
    [0, 3, 1, 25, 5, 50],
    [0, 1, 2, 25, 5, 50],
    [2, 1, 4, 0, 0, 51],
    [0, 0, 5, 1, 1, 51],
    [2, 2, 3, 5, 1, 51],
    [2, 0, 4, 5, 1, 51],
    [3, 2, 3, 2, 2, 51],
    [3, 0, 4, 2, 2, 51],
    [0, 1, 4, 6, 2, 51],
    [2, 3, 2, 10, 2, 51],
    [2, 1, 3, 10, 2, 51],
    [1, 1, 4, 3, 3, 51],
    [0, 2, 3, 11, 3, 51],
    [0, 0, 4, 11, 3, 51],
    [2, 4, 1, 15, 3, 51],
    [2, 2, 2, 15, 3, 51],
    [2, 0, 3, 15, 3, 51],
    [1, 2, 3, 8, 4, 51],
    [1, 0, 4, 8, 4, 51],
    [0, 3, 2, 16, 4, 51],
    [0, 1, 3, 16, 4, 51],
    [0, 4, 1, 21, 5, 51],
    [0, 2, 2, 21, 5, 51],
    [0, 0, 3, 21, 5, 51],
    [4, 2, 3, 0, 0, 52],
    [4, 0, 4, 0, 0, 52],
    [2, 1, 4, 1, 1, 52],
    [4, 3, 2, 5, 1, 52],
    [4, 1, 3, 5, 1, 52],
    [0, 0, 5, 2, 2, 52],
    [2, 2, 3, 6, 2, 52],
    [2, 0, 4, 6, 2, 52],
    [0, 1, 4, 7, 3, 52],
    [2, 3, 2, 11, 3, 52],
    [2, 1, 3, 11, 3, 52],
    [1, 1, 4, 4, 4, 52],
    [0, 2, 3, 12, 4, 52],
    [0, 0, 4, 12, 4, 52],
    [0, 3, 2, 17, 5, 52],
    [0, 1, 3, 17, 5, 52],
    [0, 0, 5, 3, 3, 53],
    [0, 1, 4, 8, 4, 53],
    [0, 2, 3, 13, 5, 53],
    [0, 0, 4, 13, 5, 53],
    [0, 0, 5, 4, 4, 54],
    [0, 1, 4, 9, 5, 54],
    [0, 0, 5, 5, 1, 55],
    [0, 0, 4, 15, 3, 55],
    [0, 0, 3, 25, 5, 55],
    [0, 0, 5, 6, 2, 56],
    [0, 0, 4, 16, 4, 56],
    [0, 0, 5, 7, 3, 57],
    [0, 0, 4, 17, 5, 57],
    [0, 0, 5, 8, 4, 58],
    [0, 0, 5, 9, 5, 59],
  ],
  51: [
    [2, 1, 4, 0, 0, 51],
    [0, 0, 5, 1, 1, 51],
    [2, 2, 3, 5, 1, 51],
    [2, 0, 4, 5, 1, 51],
    [3, 2, 3, 2, 2, 51],
    [3, 0, 4, 2, 2, 51],
    [0, 1, 4, 6, 2, 51],
    [2, 3, 2, 10, 2, 51],
    [2, 1, 3, 10, 2, 51],
    [1, 1, 4, 3, 3, 51],
    [0, 2, 3, 11, 3, 51],
    [0, 0, 4, 11, 3, 51],
    [2, 4, 1, 15, 3, 51],
    [2, 2, 2, 15, 3, 51],
    [2, 0, 3, 15, 3, 51],
    [1, 2, 3, 8, 4, 51],
    [1, 0, 4, 8, 4, 51],
    [0, 3, 2, 16, 4, 51],
    [0, 1, 3, 16, 4, 51],
    [0, 4, 1, 21, 5, 51],
    [0, 2, 2, 21, 5, 51],
    [0, 0, 3, 21, 5, 51],
    [4, 2, 3, 0, 0, 52],
    [4, 0, 4, 0, 0, 52],
    [2, 1, 4, 1, 1, 52],
    [4, 3, 2, 5, 1, 52],
    [4, 1, 3, 5, 1, 52],
    [0, 0, 5, 2, 2, 52],
    [2, 2, 3, 6, 2, 52],
    [2, 0, 4, 6, 2, 52],
    [0, 1, 4, 7, 3, 52],
    [2, 3, 2, 11, 3, 52],
    [2, 1, 3, 11, 3, 52],
    [1, 1, 4, 4, 4, 52],
    [0, 2, 3, 12, 4, 52],
    [0, 0, 4, 12, 4, 52],
    [0, 3, 2, 17, 5, 52],
    [0, 1, 3, 17, 5, 52],
    [1, 0, 5, 0, 0, 53],
    [4, 2, 3, 1, 1, 53],
    [4, 0, 4, 1, 1, 53],
    [1, 1, 4, 5, 1, 53],
    [2, 1, 4, 2, 2, 53],
    [1, 2, 3, 10, 2, 53],
    [1, 0, 4, 10, 2, 53],
    [0, 0, 5, 3, 3, 53],
    [2, 2, 3, 7, 3, 53],
    [2, 0, 4, 7, 3, 53],
    [1, 3, 2, 15, 3, 53],
    [1, 1, 3, 15, 3, 53],
    [0, 1, 4, 8, 4, 53],
    [1, 4, 1, 20, 4, 53],
    [1, 2, 2, 20, 4, 53],
    [1, 0, 3, 20, 4, 53],
    [0, 2, 3, 13, 5, 53],
    [0, 0, 4, 13, 5, 53],
    [0, 0, 5, 4, 4, 54],
    [0, 1, 4, 9, 5, 54],
    [0, 0, 5, 5, 1, 55],
    [0, 1, 4, 10, 2, 55],
    [0, 2, 3, 15, 3, 55],
    [0, 0, 4, 15, 3, 55],
    [0, 3, 2, 20, 4, 55],
    [0, 1, 3, 20, 4, 55],
    [0, 4, 1, 25, 5, 55],
    [0, 2, 2, 25, 5, 55],
    [0, 0, 3, 25, 5, 55],
    [0, 0, 5, 6, 2, 56],
    [0, 0, 4, 16, 4, 56],
    [0, 0, 5, 7, 3, 57],
    [0, 0, 4, 17, 5, 57],
    [0, 0, 5, 8, 4, 58],
    [0, 0, 5, 9, 5, 59],
    [0, 0, 5, 10, 2, 60],
    [0, 0, 4, 20, 4, 60],
  ],
  52: [
    [4, 2, 3, 0, 0, 52],
    [4, 0, 4, 0, 0, 52],
    [2, 1, 4, 1, 1, 52],
    [4, 3, 2, 5, 1, 52],
    [4, 1, 3, 5, 1, 52],
    [0, 0, 5, 2, 2, 52],
    [2, 2, 3, 6, 2, 52],
    [2, 0, 4, 6, 2, 52],
    [0, 1, 4, 7, 3, 52],
    [2, 3, 2, 11, 3, 52],
    [2, 1, 3, 11, 3, 52],
    [1, 1, 4, 4, 4, 52],
    [0, 2, 3, 12, 4, 52],
    [0, 0, 4, 12, 4, 52],
    [0, 3, 2, 17, 5, 52],
    [0, 1, 3, 17, 5, 52],
    [1, 0, 5, 0, 0, 53],
    [4, 2, 3, 1, 1, 53],
    [4, 0, 4, 1, 1, 53],
    [1, 1, 4, 5, 1, 53],
    [2, 1, 4, 2, 2, 53],
    [1, 2, 3, 10, 2, 53],
    [1, 0, 4, 10, 2, 53],
    [0, 0, 5, 3, 3, 53],
    [2, 2, 3, 7, 3, 53],
    [2, 0, 4, 7, 3, 53],
    [1, 3, 2, 15, 3, 53],
    [1, 1, 3, 15, 3, 53],
    [0, 1, 4, 8, 4, 53],
    [1, 4, 1, 20, 4, 53],
    [1, 2, 2, 20, 4, 53],
    [1, 0, 3, 20, 4, 53],
    [0, 2, 3, 13, 5, 53],
    [0, 0, 4, 13, 5, 53],
    [3, 1, 4, 0, 0, 54],
    [1, 0, 5, 1, 1, 54],
    [3, 2, 3, 5, 1, 54],
    [3, 0, 4, 5, 1, 54],
    [1, 1, 4, 6, 2, 54],
    [3, 3, 2, 10, 2, 54],
    [3, 1, 3, 10, 2, 54],
    [2, 1, 4, 3, 3, 54],
    [1, 2, 3, 11, 3, 54],
    [1, 0, 4, 11, 3, 54],
    [0, 0, 5, 4, 4, 54],
    [1, 3, 2, 16, 4, 54],
    [1, 1, 3, 16, 4, 54],
    [0, 1, 4, 9, 5, 54],
    [0, 0, 5, 5, 1, 55],
    [0, 1, 4, 10, 2, 55],
    [0, 2, 3, 15, 3, 55],
    [0, 0, 4, 15, 3, 55],
    [0, 3, 2, 20, 4, 55],
    [0, 1, 3, 20, 4, 55],
    [0, 4, 1, 25, 5, 55],
    [0, 2, 2, 25, 5, 55],
    [0, 0, 3, 25, 5, 55],
    [0, 0, 5, 6, 2, 56],
    [0, 1, 4, 11, 3, 56],
    [0, 2, 3, 16, 4, 56],
    [0, 0, 4, 16, 4, 56],
    [0, 3, 2, 21, 5, 56],
    [0, 1, 3, 21, 5, 56],
    [0, 0, 5, 7, 3, 57],
    [0, 0, 4, 17, 5, 57],
    [0, 0, 5, 8, 4, 58],
    [0, 0, 5, 9, 5, 59],
    [0, 0, 5, 10, 2, 60],
    [0, 0, 4, 20, 4, 60],
    [0, 0, 5, 11, 3, 61],
    [0, 0, 4, 21, 5, 61],
  ],
  53: [
    [1, 0, 5, 0, 0, 53],
    [4, 2, 3, 1, 1, 53],
    [4, 0, 4, 1, 1, 53],
    [1, 1, 4, 5, 1, 53],
    [2, 1, 4, 2, 2, 53],
    [1, 2, 3, 10, 2, 53],
    [1, 0, 4, 10, 2, 53],
    [0, 0, 5, 3, 3, 53],
    [2, 2, 3, 7, 3, 53],
    [2, 0, 4, 7, 3, 53],
    [1, 3, 2, 15, 3, 53],
    [1, 1, 3, 15, 3, 53],
    [0, 1, 4, 8, 4, 53],
    [1, 4, 1, 20, 4, 53],
    [1, 2, 2, 20, 4, 53],
    [1, 0, 3, 20, 4, 53],
    [0, 2, 3, 13, 5, 53],
    [0, 0, 4, 13, 5, 53],
    [3, 1, 4, 0, 0, 54],
    [1, 0, 5, 1, 1, 54],
    [3, 2, 3, 5, 1, 54],
    [3, 0, 4, 5, 1, 54],
    [1, 1, 4, 6, 2, 54],
    [3, 3, 2, 10, 2, 54],
    [3, 1, 3, 10, 2, 54],
    [2, 1, 4, 3, 3, 54],
    [1, 2, 3, 11, 3, 54],
    [1, 0, 4, 11, 3, 54],
    [0, 0, 5, 4, 4, 54],
    [1, 3, 2, 16, 4, 54],
    [1, 1, 3, 16, 4, 54],
    [0, 1, 4, 9, 5, 54],
    [5, 2, 3, 0, 0, 55],
    [5, 0, 4, 0, 0, 55],
    [3, 1, 4, 1, 1, 55],
    [0, 0, 5, 5, 1, 55],
    [1, 0, 5, 2, 2, 55],
    [3, 2, 3, 6, 2, 55],
    [3, 0, 4, 6, 2, 55],
    [0, 1, 4, 10, 2, 55],
    [1, 1, 4, 7, 3, 55],
    [0, 2, 3, 15, 3, 55],
    [0, 0, 4, 15, 3, 55],
    [1, 2, 3, 12, 4, 55],
    [1, 0, 4, 12, 4, 55],
    [0, 3, 2, 20, 4, 55],
    [0, 1, 3, 20, 4, 55],
    [0, 4, 1, 25, 5, 55],
    [0, 2, 2, 25, 5, 55],
    [0, 0, 3, 25, 5, 55],
    [0, 0, 5, 6, 2, 56],
    [0, 1, 4, 11, 3, 56],
    [0, 2, 3, 16, 4, 56],
    [0, 0, 4, 16, 4, 56],
    [0, 3, 2, 21, 5, 56],
    [0, 1, 3, 21, 5, 56],
    [0, 0, 5, 7, 3, 57],
    [0, 1, 4, 12, 4, 57],
    [0, 2, 3, 17, 5, 57],
    [0, 0, 4, 17, 5, 57],
    [0, 0, 5, 8, 4, 58],
    [0, 0, 5, 9, 5, 59],
    [0, 0, 5, 10, 2, 60],
    [0, 0, 4, 20, 4, 60],
    [0, 0, 5, 11, 3, 61],
    [0, 0, 4, 21, 5, 61],
    [0, 0, 5, 12, 4, 62],
  ],
  54: [
    [3, 1, 4, 0, 0, 54],
    [1, 0, 5, 1, 1, 54],
    [3, 2, 3, 5, 1, 54],
    [3, 0, 4, 5, 1, 54],
    [1, 1, 4, 6, 2, 54],
    [3, 3, 2, 10, 2, 54],
    [3, 1, 3, 10, 2, 54],
    [2, 1, 4, 3, 3, 54],
    [1, 2, 3, 11, 3, 54],
    [1, 0, 4, 11, 3, 54],
    [0, 0, 5, 4, 4, 54],
    [1, 3, 2, 16, 4, 54],
    [1, 1, 3, 16, 4, 54],
    [0, 1, 4, 9, 5, 54],
    [5, 2, 3, 0, 0, 55],
    [5, 0, 4, 0, 0, 55],
    [3, 1, 4, 1, 1, 55],
    [0, 0, 5, 5, 1, 55],
    [1, 0, 5, 2, 2, 55],
    [3, 2, 3, 6, 2, 55],
    [3, 0, 4, 6, 2, 55],
    [0, 1, 4, 10, 2, 55],
    [1, 1, 4, 7, 3, 55],
    [0, 2, 3, 15, 3, 55],
    [0, 0, 4, 15, 3, 55],
    [1, 2, 3, 12, 4, 55],
    [1, 0, 4, 12, 4, 55],
    [0, 3, 2, 20, 4, 55],
    [0, 1, 3, 20, 4, 55],
    [0, 4, 1, 25, 5, 55],
    [0, 2, 2, 25, 5, 55],
    [0, 0, 3, 25, 5, 55],
    [2, 0, 5, 0, 0, 56],
    [2, 1, 4, 5, 1, 56],
    [3, 1, 4, 2, 2, 56],
    [0, 0, 5, 6, 2, 56],
    [2, 2, 3, 10, 2, 56],
    [2, 0, 4, 10, 2, 56],
    [1, 0, 5, 3, 3, 56],
    [0, 1, 4, 11, 3, 56],
    [2, 3, 2, 15, 3, 56],
    [2, 1, 3, 15, 3, 56],
    [1, 1, 4, 8, 4, 56],
    [0, 2, 3, 16, 4, 56],
    [0, 0, 4, 16, 4, 56],
    [0, 3, 2, 21, 5, 56],
    [0, 1, 3, 21, 5, 56],
    [0, 0, 5, 7, 3, 57],
    [0, 1, 4, 12, 4, 57],
    [0, 2, 3, 17, 5, 57],
    [0, 0, 4, 17, 5, 57],
    [0, 0, 5, 8, 4, 58],
    [0, 1, 4, 13, 5, 58],
    [0, 0, 5, 9, 5, 59],
    [0, 0, 5, 10, 2, 60],
    [0, 0, 4, 20, 4, 60],
    [0, 0, 5, 11, 3, 61],
    [0, 0, 4, 21, 5, 61],
    [0, 0, 5, 12, 4, 62],
    [0, 0, 5, 13, 5, 63],
  ],
  55: [
    [5, 2, 3, 0, 0, 55],
    [5, 0, 4, 0, 0, 55],
    [3, 1, 4, 1, 1, 55],
    [0, 0, 5, 5, 1, 55],
    [1, 0, 5, 2, 2, 55],
    [3, 2, 3, 6, 2, 55],
    [3, 0, 4, 6, 2, 55],
    [0, 1, 4, 10, 2, 55],
    [1, 1, 4, 7, 3, 55],
    [0, 2, 3, 15, 3, 55],
    [0, 0, 4, 15, 3, 55],
    [1, 2, 3, 12, 4, 55],
    [1, 0, 4, 12, 4, 55],
    [0, 3, 2, 20, 4, 55],
    [0, 1, 3, 20, 4, 55],
    [0, 4, 1, 25, 5, 55],
    [0, 2, 2, 25, 5, 55],
    [0, 0, 3, 25, 5, 55],
    [2, 0, 5, 0, 0, 56],
    [2, 1, 4, 5, 1, 56],
    [3, 1, 4, 2, 2, 56],
    [0, 0, 5, 6, 2, 56],
    [2, 2, 3, 10, 2, 56],
    [2, 0, 4, 10, 2, 56],
    [1, 0, 5, 3, 3, 56],
    [0, 1, 4, 11, 3, 56],
    [2, 3, 2, 15, 3, 56],
    [2, 1, 3, 15, 3, 56],
    [1, 1, 4, 8, 4, 56],
    [0, 2, 3, 16, 4, 56],
    [0, 0, 4, 16, 4, 56],
    [0, 3, 2, 21, 5, 56],
    [0, 1, 3, 21, 5, 56],
    [4, 1, 4, 0, 0, 57],
    [2, 0, 5, 1, 1, 57],
    [4, 2, 3, 5, 1, 57],
    [4, 0, 4, 5, 1, 57],
    [2, 1, 4, 6, 2, 57],
    [0, 0, 5, 7, 3, 57],
    [2, 2, 3, 11, 3, 57],
    [2, 0, 4, 11, 3, 57],
    [1, 0, 5, 4, 4, 57],
    [0, 1, 4, 12, 4, 57],
    [0, 2, 3, 17, 5, 57],
    [0, 0, 4, 17, 5, 57],
    [0, 0, 5, 8, 4, 58],
    [0, 1, 4, 13, 5, 58],
    [0, 0, 5, 9, 5, 59],
    [0, 0, 5, 10, 2, 60],
    [0, 0, 4, 20, 4, 60],
    [0, 0, 5, 11, 3, 61],
    [0, 0, 4, 21, 5, 61],
    [0, 0, 5, 12, 4, 62],
    [0, 0, 5, 13, 5, 63],
  ],
  56: [
    [2, 0, 5, 0, 0, 56],
    [2, 1, 4, 5, 1, 56],
    [3, 1, 4, 2, 2, 56],
    [0, 0, 5, 6, 2, 56],
    [2, 2, 3, 10, 2, 56],
    [2, 0, 4, 10, 2, 56],
    [1, 0, 5, 3, 3, 56],
    [0, 1, 4, 11, 3, 56],
    [2, 3, 2, 15, 3, 56],
    [2, 1, 3, 15, 3, 56],
    [1, 1, 4, 8, 4, 56],
    [0, 2, 3, 16, 4, 56],
    [0, 0, 4, 16, 4, 56],
    [0, 3, 2, 21, 5, 56],
    [0, 1, 3, 21, 5, 56],
    [4, 1, 4, 0, 0, 57],
    [2, 0, 5, 1, 1, 57],
    [4, 2, 3, 5, 1, 57],
    [4, 0, 4, 5, 1, 57],
    [2, 1, 4, 6, 2, 57],
    [0, 0, 5, 7, 3, 57],
    [2, 2, 3, 11, 3, 57],
    [2, 0, 4, 11, 3, 57],
    [1, 0, 5, 4, 4, 57],
    [0, 1, 4, 12, 4, 57],
    [0, 2, 3, 17, 5, 57],
    [0, 0, 4, 17, 5, 57],
    [4, 1, 4, 1, 1, 58],
    [1, 0, 5, 5, 1, 58],
    [2, 0, 5, 2, 2, 58],
    [1, 1, 4, 10, 2, 58],
    [2, 1, 4, 7, 3, 58],
    [1, 2, 3, 15, 3, 58],
    [1, 0, 4, 15, 3, 58],
    [0, 0, 5, 8, 4, 58],
    [1, 3, 2, 20, 4, 58],
    [1, 1, 3, 20, 4, 58],
    [0, 1, 4, 13, 5, 58],
    [0, 0, 5, 9, 5, 59],
    [0, 0, 5, 10, 2, 60],
    [0, 1, 4, 15, 3, 60],
    [0, 2, 3, 20, 4, 60],
    [0, 0, 4, 20, 4, 60],
    [0, 3, 2, 25, 5, 60],
    [0, 1, 3, 25, 5, 60],
    [0, 0, 5, 11, 3, 61],
    [0, 0, 4, 21, 5, 61],
    [0, 0, 5, 12, 4, 62],
    [0, 0, 5, 13, 5, 63],
    [0, 0, 5, 15, 3, 65],
    [0, 0, 4, 25, 5, 65],
  ],
  57: [
    [4, 1, 4, 0, 0, 57],
    [2, 0, 5, 1, 1, 57],
    [4, 2, 3, 5, 1, 57],
    [4, 0, 4, 5, 1, 57],
    [2, 1, 4, 6, 2, 57],
    [0, 0, 5, 7, 3, 57],
    [2, 2, 3, 11, 3, 57],
    [2, 0, 4, 11, 3, 57],
    [1, 0, 5, 4, 4, 57],
    [0, 1, 4, 12, 4, 57],
    [0, 2, 3, 17, 5, 57],
    [0, 0, 4, 17, 5, 57],
    [4, 1, 4, 1, 1, 58],
    [1, 0, 5, 5, 1, 58],
    [2, 0, 5, 2, 2, 58],
    [1, 1, 4, 10, 2, 58],
    [2, 1, 4, 7, 3, 58],
    [1, 2, 3, 15, 3, 58],
    [1, 0, 4, 15, 3, 58],
    [0, 0, 5, 8, 4, 58],
    [1, 3, 2, 20, 4, 58],
    [1, 1, 3, 20, 4, 58],
    [0, 1, 4, 13, 5, 58],
    [3, 0, 5, 0, 0, 59],
    [3, 1, 4, 5, 1, 59],
    [1, 0, 5, 6, 2, 59],
    [3, 2, 3, 10, 2, 59],
    [3, 0, 4, 10, 2, 59],
    [2, 0, 5, 3, 3, 59],
    [1, 1, 4, 11, 3, 59],
    [1, 2, 3, 16, 4, 59],
    [1, 0, 4, 16, 4, 59],
    [0, 0, 5, 9, 5, 59],
    [0, 0, 5, 10, 2, 60],
    [0, 1, 4, 15, 3, 60],
    [0, 2, 3, 20, 4, 60],
    [0, 0, 4, 20, 4, 60],
    [0, 3, 2, 25, 5, 60],
    [0, 1, 3, 25, 5, 60],
    [0, 0, 5, 11, 3, 61],
    [0, 1, 4, 16, 4, 61],
    [0, 2, 3, 21, 5, 61],
    [0, 0, 4, 21, 5, 61],
    [0, 0, 5, 12, 4, 62],
    [0, 0, 5, 13, 5, 63],
    [0, 0, 5, 15, 3, 65],
    [0, 0, 4, 25, 5, 65],
    [0, 0, 5, 16, 4, 66],
  ],
  58: [
    [4, 1, 4, 1, 1, 58],
    [1, 0, 5, 5, 1, 58],
    [2, 0, 5, 2, 2, 58],
    [1, 1, 4, 10, 2, 58],
    [2, 1, 4, 7, 3, 58],
    [1, 2, 3, 15, 3, 58],
    [1, 0, 4, 15, 3, 58],
    [0, 0, 5, 8, 4, 58],
    [1, 3, 2, 20, 4, 58],
    [1, 1, 3, 20, 4, 58],
    [0, 1, 4, 13, 5, 58],
    [3, 0, 5, 0, 0, 59],
    [3, 1, 4, 5, 1, 59],
    [1, 0, 5, 6, 2, 59],
    [3, 2, 3, 10, 2, 59],
    [3, 0, 4, 10, 2, 59],
    [2, 0, 5, 3, 3, 59],
    [1, 1, 4, 11, 3, 59],
    [1, 2, 3, 16, 4, 59],
    [1, 0, 4, 16, 4, 59],
    [0, 0, 5, 9, 5, 59],
    [5, 1, 4, 0, 0, 60],
    [3, 0, 5, 1, 1, 60],
    [3, 1, 4, 6, 2, 60],
    [0, 0, 5, 10, 2, 60],
    [1, 0, 5, 7, 3, 60],
    [0, 1, 4, 15, 3, 60],
    [1, 1, 4, 12, 4, 60],
    [0, 2, 3, 20, 4, 60],
    [0, 0, 4, 20, 4, 60],
    [0, 3, 2, 25, 5, 60],
    [0, 1, 3, 25, 5, 60],
    [0, 0, 5, 11, 3, 61],
    [0, 1, 4, 16, 4, 61],
    [0, 2, 3, 21, 5, 61],
    [0, 0, 4, 21, 5, 61],
    [0, 0, 5, 12, 4, 62],
    [0, 1, 4, 17, 5, 62],
    [0, 0, 5, 13, 5, 63],
    [0, 0, 5, 15, 3, 65],
    [0, 0, 4, 25, 5, 65],
    [0, 0, 5, 16, 4, 66],
    [0, 0, 5, 17, 5, 67],
  ],
  59: [
    [3, 0, 5, 0, 0, 59],
    [3, 1, 4, 5, 1, 59],
    [1, 0, 5, 6, 2, 59],
    [3, 2, 3, 10, 2, 59],
    [3, 0, 4, 10, 2, 59],
    [2, 0, 5, 3, 3, 59],
    [1, 1, 4, 11, 3, 59],
    [1, 2, 3, 16, 4, 59],
    [1, 0, 4, 16, 4, 59],
    [0, 0, 5, 9, 5, 59],
    [5, 1, 4, 0, 0, 60],
    [3, 0, 5, 1, 1, 60],
    [3, 1, 4, 6, 2, 60],
    [0, 0, 5, 10, 2, 60],
    [1, 0, 5, 7, 3, 60],
    [0, 1, 4, 15, 3, 60],
    [1, 1, 4, 12, 4, 60],
    [0, 2, 3, 20, 4, 60],
    [0, 0, 4, 20, 4, 60],
    [0, 3, 2, 25, 5, 60],
    [0, 1, 3, 25, 5, 60],
    [2, 0, 5, 5, 1, 61],
    [3, 0, 5, 2, 2, 61],
    [2, 1, 4, 10, 2, 61],
    [0, 0, 5, 11, 3, 61],
    [2, 2, 3, 15, 3, 61],
    [2, 0, 4, 15, 3, 61],
    [1, 0, 5, 8, 4, 61],
    [0, 1, 4, 16, 4, 61],
    [0, 2, 3, 21, 5, 61],
    [0, 0, 4, 21, 5, 61],
    [0, 0, 5, 12, 4, 62],
    [0, 1, 4, 17, 5, 62],
    [0, 0, 5, 13, 5, 63],
    [0, 0, 5, 15, 3, 65],
    [0, 0, 4, 25, 5, 65],
    [0, 0, 5, 16, 4, 66],
    [0, 0, 5, 17, 5, 67],
  ],
  60: [
    [5, 1, 4, 0, 0, 60],
    [3, 0, 5, 1, 1, 60],
    [3, 1, 4, 6, 2, 60],
    [0, 0, 5, 10, 2, 60],
    [1, 0, 5, 7, 3, 60],
    [0, 1, 4, 15, 3, 60],
    [1, 1, 4, 12, 4, 60],
    [0, 2, 3, 20, 4, 60],
    [0, 0, 4, 20, 4, 60],
    [0, 3, 2, 25, 5, 60],
    [0, 1, 3, 25, 5, 60],
    [2, 0, 5, 5, 1, 61],
    [3, 0, 5, 2, 2, 61],
    [2, 1, 4, 10, 2, 61],
    [0, 0, 5, 11, 3, 61],
    [2, 2, 3, 15, 3, 61],
    [2, 0, 4, 15, 3, 61],
    [1, 0, 5, 8, 4, 61],
    [0, 1, 4, 16, 4, 61],
    [0, 2, 3, 21, 5, 61],
    [0, 0, 4, 21, 5, 61],
    [4, 0, 5, 0, 0, 62],
    [4, 1, 4, 5, 1, 62],
    [2, 0, 5, 6, 2, 62],
    [2, 1, 4, 11, 3, 62],
    [0, 0, 5, 12, 4, 62],
    [0, 1, 4, 17, 5, 62],
    [0, 0, 5, 13, 5, 63],
    [0, 0, 5, 15, 3, 65],
    [0, 0, 4, 25, 5, 65],
    [0, 0, 5, 16, 4, 66],
    [0, 0, 5, 17, 5, 67],
  ],
  61: [
    [2, 0, 5, 5, 1, 61],
    [3, 0, 5, 2, 2, 61],
    [2, 1, 4, 10, 2, 61],
    [0, 0, 5, 11, 3, 61],
    [2, 2, 3, 15, 3, 61],
    [2, 0, 4, 15, 3, 61],
    [1, 0, 5, 8, 4, 61],
    [0, 1, 4, 16, 4, 61],
    [0, 2, 3, 21, 5, 61],
    [0, 0, 4, 21, 5, 61],
    [4, 0, 5, 0, 0, 62],
    [4, 1, 4, 5, 1, 62],
    [2, 0, 5, 6, 2, 62],
    [2, 1, 4, 11, 3, 62],
    [0, 0, 5, 12, 4, 62],
    [0, 1, 4, 17, 5, 62],
    [4, 0, 5, 1, 1, 63],
    [1, 0, 5, 10, 2, 63],
    [2, 0, 5, 7, 3, 63],
    [1, 1, 4, 15, 3, 63],
    [1, 2, 3, 20, 4, 63],
    [1, 0, 4, 20, 4, 63],
    [0, 0, 5, 13, 5, 63],
    [0, 0, 5, 15, 3, 65],
    [0, 1, 4, 20, 4, 65],
    [0, 2, 3, 25, 5, 65],
    [0, 0, 4, 25, 5, 65],
    [0, 0, 5, 16, 4, 66],
    [0, 0, 5, 17, 5, 67],
    [0, 0, 5, 20, 4, 70],
  ],
  62: [
    [4, 0, 5, 0, 0, 62],
    [4, 1, 4, 5, 1, 62],
    [2, 0, 5, 6, 2, 62],
    [2, 1, 4, 11, 3, 62],
    [0, 0, 5, 12, 4, 62],
    [0, 1, 4, 17, 5, 62],
    [4, 0, 5, 1, 1, 63],
    [1, 0, 5, 10, 2, 63],
    [2, 0, 5, 7, 3, 63],
    [1, 1, 4, 15, 3, 63],
    [1, 2, 3, 20, 4, 63],
    [1, 0, 4, 20, 4, 63],
    [0, 0, 5, 13, 5, 63],
    [3, 0, 5, 5, 1, 64],
    [3, 1, 4, 10, 2, 64],
    [1, 0, 5, 11, 3, 64],
    [1, 1, 4, 16, 4, 64],
    [0, 0, 5, 15, 3, 65],
    [0, 1, 4, 20, 4, 65],
    [0, 2, 3, 25, 5, 65],
    [0, 0, 4, 25, 5, 65],
    [0, 0, 5, 16, 4, 66],
    [0, 1, 4, 21, 5, 66],
    [0, 0, 5, 17, 5, 67],
    [0, 0, 5, 20, 4, 70],
    [0, 0, 5, 21, 5, 71],
  ],
  63: [
    [4, 0, 5, 1, 1, 63],
    [1, 0, 5, 10, 2, 63],
    [2, 0, 5, 7, 3, 63],
    [1, 1, 4, 15, 3, 63],
    [1, 2, 3, 20, 4, 63],
    [1, 0, 4, 20, 4, 63],
    [0, 0, 5, 13, 5, 63],
    [3, 0, 5, 5, 1, 64],
    [3, 1, 4, 10, 2, 64],
    [1, 0, 5, 11, 3, 64],
    [1, 1, 4, 16, 4, 64],
    [5, 0, 5, 0, 0, 65],
    [3, 0, 5, 6, 2, 65],
    [0, 0, 5, 15, 3, 65],
    [1, 0, 5, 12, 4, 65],
    [0, 1, 4, 20, 4, 65],
    [0, 2, 3, 25, 5, 65],
    [0, 0, 4, 25, 5, 65],
    [0, 0, 5, 16, 4, 66],
    [0, 1, 4, 21, 5, 66],
    [0, 0, 5, 17, 5, 67],
    [0, 0, 5, 20, 4, 70],
    [0, 0, 5, 21, 5, 71],
  ],
  64: [
    [3, 0, 5, 5, 1, 64],
    [3, 1, 4, 10, 2, 64],
    [1, 0, 5, 11, 3, 64],
    [1, 1, 4, 16, 4, 64],
    [5, 0, 5, 0, 0, 65],
    [3, 0, 5, 6, 2, 65],
    [0, 0, 5, 15, 3, 65],
    [1, 0, 5, 12, 4, 65],
    [0, 1, 4, 20, 4, 65],
    [0, 2, 3, 25, 5, 65],
    [0, 0, 4, 25, 5, 65],
    [2, 0, 5, 10, 2, 66],
    [2, 1, 4, 15, 3, 66],
    [0, 0, 5, 16, 4, 66],
    [0, 1, 4, 21, 5, 66],
    [0, 0, 5, 17, 5, 67],
    [0, 0, 5, 20, 4, 70],
    [0, 0, 5, 21, 5, 71],
  ],
  65: [
    [5, 0, 5, 0, 0, 65],
    [3, 0, 5, 6, 2, 65],
    [0, 0, 5, 15, 3, 65],
    [1, 0, 5, 12, 4, 65],
    [0, 1, 4, 20, 4, 65],
    [0, 2, 3, 25, 5, 65],
    [0, 0, 4, 25, 5, 65],
    [2, 0, 5, 10, 2, 66],
    [2, 1, 4, 15, 3, 66],
    [0, 0, 5, 16, 4, 66],
    [0, 1, 4, 21, 5, 66],
    [4, 0, 5, 5, 1, 67],
    [2, 0, 5, 11, 3, 67],
    [0, 0, 5, 17, 5, 67],
    [0, 0, 5, 20, 4, 70],
    [0, 0, 5, 21, 5, 71],
  ],
  66: [
    [2, 0, 5, 10, 2, 66],
    [2, 1, 4, 15, 3, 66],
    [0, 0, 5, 16, 4, 66],
    [0, 1, 4, 21, 5, 66],
    [4, 0, 5, 5, 1, 67],
    [2, 0, 5, 11, 3, 67],
    [0, 0, 5, 17, 5, 67],
    [1, 0, 5, 15, 3, 68],
    [1, 1, 4, 20, 4, 68],
    [0, 0, 5, 20, 4, 70],
    [0, 1, 4, 25, 5, 70],
    [0, 0, 5, 21, 5, 71],
    [0, 0, 5, 25, 5, 75],
  ],
  67: [
    [4, 0, 5, 5, 1, 67],
    [2, 0, 5, 11, 3, 67],
    [0, 0, 5, 17, 5, 67],
    [1, 0, 5, 15, 3, 68],
    [1, 1, 4, 20, 4, 68],
    [3, 0, 5, 10, 2, 69],
    [1, 0, 5, 16, 4, 69],
    [0, 0, 5, 20, 4, 70],
    [0, 1, 4, 25, 5, 70],
    [0, 0, 5, 21, 5, 71],
    [0, 0, 5, 25, 5, 75],
  ],
  68: [
    [1, 0, 5, 15, 3, 68],
    [1, 1, 4, 20, 4, 68],
    [3, 0, 5, 10, 2, 69],
    [1, 0, 5, 16, 4, 69],
    [0, 0, 5, 20, 4, 70],
    [0, 1, 4, 25, 5, 70],
    [0, 0, 5, 21, 5, 71],
    [0, 0, 5, 25, 5, 75],
  ],
  69: [
    [3, 0, 5, 10, 2, 69],
    [1, 0, 5, 16, 4, 69],
    [0, 0, 5, 20, 4, 70],
    [0, 1, 4, 25, 5, 70],
    [2, 0, 5, 15, 3, 71],
    [0, 0, 5, 21, 5, 71],
    [0, 0, 5, 25, 5, 75],
  ],
  70: [
    [0, 0, 5, 20, 4, 70],
    [0, 1, 4, 25, 5, 70],
    [2, 0, 5, 15, 3, 71],
    [0, 0, 5, 21, 5, 71],
    [0, 0, 5, 25, 5, 75],
  ],
  71: [
    [2, 0, 5, 15, 3, 71],
    [0, 0, 5, 21, 5, 71],
    [1, 0, 5, 20, 4, 73],
    [0, 0, 5, 25, 5, 75],
  ],
  72: [
    [1, 0, 5, 20, 4, 73],
    [0, 0, 5, 25, 5, 75],
  ],
  73: [
    [1, 0, 5, 20, 4, 73],
    [0, 0, 5, 25, 5, 75],
  ],
  74: [[0, 0, 5, 25, 5, 75]],
  75: [[0, 0, 5, 25, 5, 75]],
};
